import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AnnotationType: { input: any; output: any; }
  BigInt: { input: any; output: any; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type ApiKeyByLicenseKeyResult = {
  __typename?: 'APIKeyByLicenseKeyResult';
  apiKey: Scalars['String']['output'];
  organisationId: Scalars['String']['output'];
};

export enum ApiKeyType {
  Default = 'DEFAULT',
  WithLicenseKey = 'WITH_LICENSE_KEY'
}

export type AddAdditionalPointAction = {
  annotationIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  pointCloudId: Scalars['String']['input'];
  pointIndex: Scalars['Int']['input'];
  position: InputPosition;
};

export type AddAreaAction = {
  annotationIdentifier: Scalars['String']['input'];
  groupIdentifier?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
  points: Array<InputPoint>;
};

export type AddBoxAction = {
  annotationIdentifier: Scalars['String']['input'];
  groupIdentifier?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
  position: InputPosition;
  rotation: InputPosition;
  scale: InputPosition;
};

export type AddCadLayerAction = {
  cadLayerId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AddDistanceAction = {
  annotationIdentifier: Scalars['String']['input'];
  groupIdentifier?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
  points: Array<InputPoint>;
};

export type AddGroupAction = {
  annotationIdentifiers: Array<Scalars['String']['input']>;
  groupIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AddOrthophotoLayerAction = {
  identifier: Scalars['String']['input'];
  layerId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AddPlaneAction = {
  annotationIdentifier: Scalars['String']['input'];
  groupIdentifier?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
  normal: InputPosition;
  position: InputPosition;
};

export type AddPointAction = {
  annotationIdentifier: Scalars['String']['input'];
  classification?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<InputColor>;
  groupIdentifier?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  intensity?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pointCloudId?: InputMaybe<Scalars['String']['input']>;
  position: InputPosition;
};

export type AddPointClusterAction = {
  annotationIdentifier: Scalars['String']['input'];
  groupIdentifier?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
  segments: Array<InputSegment>;
};

export type AddWmsLayerAction = {
  identifier: Scalars['String']['input'];
  layerId: Scalars['String']['input'];
  layerName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  type: WmsType;
  url: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type Annotation = {
  annotationColor?: Maybe<Color>;
  groupIdentifier?: Maybe<Scalars['String']['output']>;
  hiddenLabels: Array<AnnotationLabels>;
  identifier: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: Scalars['AnnotationType']['output'];
  visible: Scalars['Boolean']['output'];
};

export type AnnotationGroup = {
  __typename?: 'AnnotationGroup';
  identifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum AnnotationLabels {
  Area = 'AREA',
  Coordinate = 'COORDINATE',
  Length = 'LENGTH',
  Volume = 'VOLUME'
}

export type ApiKey = {
  apiKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ApiKeyWithLicenseKey = ApiKey & {
  __typename?: 'ApiKeyWithLicenseKey';
  apiKey: Scalars['String']['output'];
  licenseKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AreaAnnotation = Annotation & {
  __typename?: 'AreaAnnotation';
  annotationColor?: Maybe<Color>;
  groupIdentifier?: Maybe<Scalars['String']['output']>;
  hiddenLabels: Array<AnnotationLabels>;
  identifier: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  points: Array<Point>;
  type: Scalars['AnnotationType']['output'];
  visible: Scalars['Boolean']['output'];
};

export type BillingInvoice = {
  __typename?: 'BillingInvoice';
  date: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  price: Price;
  url?: Maybe<Scalars['String']['output']>;
};

export type BillingProduct = {
  __typename?: 'BillingProduct';
  description: Scalars['String']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  prices: Array<BillingProductPrice>;
};


export type BillingProductEndDateArgs = {
  organisationId: Scalars['ID']['input'];
};


export type BillingProductIsActiveArgs = {
  organisationId: Scalars['ID']['input'];
};

export type BillingProductPrice = {
  __typename?: 'BillingProductPrice';
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  period?: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
};

export type BoxAnnotation = Annotation & {
  __typename?: 'BoxAnnotation';
  annotationColor?: Maybe<Color>;
  annotationFilter?: Maybe<BoxAnnotationFilters>;
  groupIdentifier?: Maybe<Scalars['String']['output']>;
  hiddenLabels: Array<AnnotationLabels>;
  identifier: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Position;
  rotation: Position;
  scale: Position;
  type: Scalars['AnnotationType']['output'];
  visible: Scalars['Boolean']['output'];
};

export type BoxAnnotationFilters = {
  clipMethod: ClipMethods;
};

export type CadLayer = {
  __typename?: 'CadLayer';
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
  visibleState: Array<CadLayerVisibleState>;
};

export type CadLayerVisibleState = CadLayerVisibleStateDelete | CadLayerVisibleStateHidden;

export type CadLayerVisibleStateDelete = {
  __typename?: 'CadLayerVisibleStateDelete';
  index: Scalars['Int']['output'];
  isGroup?: Maybe<Scalars['Boolean']['output']>;
  isLayer?: Maybe<Scalars['Boolean']['output']>;
  layerIdentifier?: Maybe<Scalars['String']['output']>;
  subIndex?: Maybe<Scalars['Int']['output']>;
};

export type CadLayerVisibleStateHidden = {
  __typename?: 'CadLayerVisibleStateHidden';
  index: Scalars['Int']['output'];
  isGroup?: Maybe<Scalars['Boolean']['output']>;
  isLayer?: Maybe<Scalars['Boolean']['output']>;
  layerIdentifier?: Maybe<Scalars['String']['output']>;
  subIndex?: Maybe<Scalars['Int']['output']>;
  userId: Scalars['String']['output'];
  visible: Scalars['Boolean']['output'];
};

export type Calculation = {
  annotationIdentifier: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  pointCloudIdentifier: Scalars['String']['output'];
  status: GeneralStatus;
};

export enum CalculationBaseSurfaces {
  CustomHeight = 'CUSTOM_HEIGHT',
  Polygon = 'POLYGON'
}

export enum ClipMethods {
  Hide = 'HIDE',
  Highlight = 'HIGHLIGHT',
  Isolate = 'ISOLATE',
  None = 'NONE'
}

export type Color = {
  __typename?: 'Color';
  a: Scalars['Int']['output'];
  b: Scalars['Int']['output'];
  g: Scalars['Int']['output'];
  r: Scalars['Int']['output'];
};

export type Comment = {
  __typename?: 'Comment';
  comment: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  referenceIdentifier: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: User;
};

export type ConvertCadIdentifiers = {
  annotationIdentifier: Scalars['String']['input'];
  groupIdentifier: Scalars['String']['input'];
};

export type ConvertCadObjectAction = {
  cadObjects: Array<InputCadObject>;
  identifier: Scalars['String']['input'];
};

export type CustomClass = {
  __typename?: 'CustomClass';
  code: Scalars['Int']['output'];
  color: Color;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum DateFormats {
  Ddmmyyyy = 'DDMMYYYY',
  Mmddyyyy = 'MMDDYYYY',
  Yyyymmdd = 'YYYYMMDD'
}

export type DefaultApiKey = ApiKey & {
  __typename?: 'DefaultApiKey';
  apiKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DeleteAnnotationAction = {
  annotationIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
};

export type DeleteAnnotationMultiAction = {
  identifier: Scalars['String']['input'];
  identifiers: Array<Scalars['String']['input']>;
};

export type DeleteCadLayerAction = {
  cadLayerIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
};

export type DeleteCadObjectAction = {
  cadLayerIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  index: Scalars['Int']['input'];
  subIndex?: InputMaybe<Scalars['Int']['input']>;
};

export type DeleteCadObjectGroupAction = {
  cadLayerIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  index: Scalars['Int']['input'];
};

export type DeleteGroupAction = {
  groupIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
};

export type DeleteOrthophotoLayerAction = {
  identifier: Scalars['String']['input'];
  orthophotoLayerIdentifier: Scalars['String']['input'];
};

export type DeletePointAction = {
  annotationIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  pointIndex: Scalars['Int']['input'];
};

export type DeleteWmsLayerAction = {
  identifier: Scalars['String']['input'];
  wmsLayerIdentifier: Scalars['String']['input'];
};

export type DistanceAnnotation = Annotation & {
  __typename?: 'DistanceAnnotation';
  annotationColor?: Maybe<Color>;
  groupIdentifier?: Maybe<Scalars['String']['output']>;
  hiddenLabels: Array<AnnotationLabels>;
  identifier: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  points: Array<Point>;
  type: Scalars['AnnotationType']['output'];
  visible: Scalars['Boolean']['output'];
};

export type DistanceProjection = {
  __typename?: 'DistanceProjection';
  distance: Scalars['Float']['output'];
  height: Scalars['Float']['output'];
};

export type EditBoxAction = {
  annotationIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  position: InputPosition;
  rotation: InputPosition;
  scale: InputPosition;
};

export type EditPlaneAction = {
  annotationIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  normal: InputPosition;
  position: InputPosition;
};

export type EditPointClusterAction = {
  annotationIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  segments: Array<InputSegment>;
};

export type Export = {
  __typename?: 'Export';
  createdAt: Scalars['Date']['output'];
  exportId: Scalars['String']['output'];
  paramInfo: ExportParamInfo;
  status: GeneralStatus;
  type: Scalars['String']['output'];
};

export type ExportParamInfo = {
  __typename?: 'ExportParamInfo';
  classificationFilters?: Maybe<Array<Scalars['Int']['output']>>;
  clippingFilter?: Maybe<Scalars['Int']['output']>;
  fileType: FileTypes;
  heightFilters?: Maybe<Array<Scalars['Int']['output']>>;
  resolutionFilter?: Maybe<Scalars['Int']['output']>;
};

export enum FileTypes {
  E57 = 'E57',
  Las = 'LAS',
  Laz = 'LAZ',
  Ppc = 'PPC',
  Ppch = 'PPCH',
  Pts = 'PTS',
  Txt = 'TXT',
  TxtXyz = 'TXT_XYZ'
}

export type GeneralOptions = {
  __typename?: 'GeneralOptions';
  value: Scalars['String']['output'];
};

export enum GeneralStatus {
  Error = 'ERROR',
  Progress = 'PROGRESS',
  Success = 'SUCCESS'
}

export type HiddenLabels = {
  __typename?: 'HiddenLabels';
  identifier: Scalars['String']['output'];
  labels: Array<AnnotationLabels>;
};

export type HideCadObjectAction = {
  cadLayerIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  index: Scalars['Int']['input'];
  isGroup?: InputMaybe<Scalars['Boolean']['input']>;
  isLayer?: InputMaybe<Scalars['Boolean']['input']>;
  layerIdentifier?: InputMaybe<Scalars['String']['input']>;
  subIndex?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
  visible: Scalars['Boolean']['input'];
};

export type InputBillingAddress = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type InputBillingCustomer = {
  VAT?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<InputBillingAddress>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputCadObject = {
  annotationIdentifier: Scalars['String']['input'];
  cadLayerId: Scalars['String']['input'];
  cadObjectGroupId: Scalars['String']['input'];
  color?: InputMaybe<InputColor>;
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
  originalIdentifier?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Array<InputPosition>>;
  position?: InputMaybe<InputPosition>;
  type: Scalars['String']['input'];
};

export type InputColor = {
  a: Scalars['Int']['input'];
  b: Scalars['Int']['input'];
  g: Scalars['Int']['input'];
  r: Scalars['Int']['input'];
};

export type InputObjectGroup = {
  cadLayerId: Scalars['String']['input'];
  cadObjects: Array<InputCadObject>;
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type InputPoint = {
  pointCloudId?: InputMaybe<Scalars['String']['input']>;
  position: InputPosition;
};

export type InputPosition = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
  z: Scalars['Float']['input'];
};

export type InputProjectAction = {
  DeleteAnnotationMultiAction?: InputMaybe<DeleteAnnotationMultiAction>;
  addAdditionalPointAction?: InputMaybe<AddAdditionalPointAction>;
  addAreaAction?: InputMaybe<AddAreaAction>;
  addBoxAction?: InputMaybe<AddBoxAction>;
  addCadLayerAction?: InputMaybe<AddCadLayerAction>;
  addDistanceAction?: InputMaybe<AddDistanceAction>;
  addGroupAction?: InputMaybe<AddGroupAction>;
  addOrthophotoLayerAction?: InputMaybe<AddOrthophotoLayerAction>;
  addPlaneAction?: InputMaybe<AddPlaneAction>;
  addPointAction?: InputMaybe<AddPointAction>;
  addPointClusterAction?: InputMaybe<AddPointClusterAction>;
  addWmsLayerAction?: InputMaybe<AddWmsLayerAction>;
  convertCadObjectAction?: InputMaybe<ConvertCadObjectAction>;
  deleteAnnotationAction?: InputMaybe<DeleteAnnotationAction>;
  deleteCadLayerAction?: InputMaybe<DeleteCadLayerAction>;
  deleteCadObjectAction?: InputMaybe<DeleteCadObjectAction>;
  deleteCadObjectGroupAction?: InputMaybe<DeleteCadObjectGroupAction>;
  deleteGroupAction?: InputMaybe<DeleteGroupAction>;
  deleteOrthophotoLayerAction?: InputMaybe<DeleteOrthophotoLayerAction>;
  deletePointAction?: InputMaybe<DeletePointAction>;
  deleteWmsLayerAction?: InputMaybe<DeleteWmsLayerAction>;
  editBoxAction?: InputMaybe<EditBoxAction>;
  editPlaneAction?: InputMaybe<EditPlaneAction>;
  editPointClusterAction?: InputMaybe<EditPointClusterAction>;
  hideCadObjectAction?: InputMaybe<HideCadObjectAction>;
  moveAnnotationsToGroupAction?: InputMaybe<MoveAnnotationsToGroupAction>;
  movePointAction?: InputMaybe<MovePointAction>;
  unGroupAction?: InputMaybe<UnGroupAction>;
  updateNameAction?: InputMaybe<UpdateNameAction>;
  updatePositionAction?: InputMaybe<UpdatePositionAction>;
  updatePositionOrthophotoLayerAction?: InputMaybe<UpdatePositionOrthophotoLayerAction>;
  updatePositionWmsLayerAction?: InputMaybe<UpdatePositionWmsLayerAction>;
  updateWmsLayerAction?: InputMaybe<UpdateWmsLayerAction>;
};

export type InputProjectSettings = {
  projectionSystem?: InputMaybe<Scalars['String']['input']>;
};

export type InputSegment = {
  pointcloudId: Scalars['String']['input'];
  segmentId: Scalars['Int']['input'];
};

export type InputSubscriptionCustomLimits = {
  maxMonthlyPointCount?: InputMaybe<Scalars['Float']['input']>;
  maxPointCount?: InputMaybe<Scalars['Float']['input']>;
  maxUploadsInProgress?: InputMaybe<Scalars['Int']['input']>;
};

export type InputUser = {
  agreeReceiveNews?: InputMaybe<Scalars['Boolean']['input']>;
  agreeTerms?: InputMaybe<Scalars['Boolean']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type InviteInfo = {
  __typename?: 'InviteInfo';
  email: Scalars['String']['output'];
  inviteId?: Maybe<Scalars['String']['output']>;
  isNewUser: Scalars['Boolean']['output'];
  organisationName: Scalars['String']['output'];
};

export enum Language {
  De = 'DE',
  En = 'EN',
  Fr = 'FR',
  Ja = 'JA',
  Nl = 'NL',
  Pt = 'PT'
}

export enum MeasurementUnits {
  Feet = 'FEET',
  Meters = 'METERS'
}

export type MoveAnnotationsToGroupAction = {
  annotationIdentifiers: Array<Scalars['String']['input']>;
  groupIdentifier?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
};

export type MovePointAction = {
  annotationIdentifier: Scalars['String']['input'];
  classification?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<InputColor>;
  identifier: Scalars['String']['input'];
  intensity?: InputMaybe<Scalars['Float']['input']>;
  pointCloudId: Scalars['String']['input'];
  pointIndex: Scalars['Int']['input'];
  position: InputPosition;
};

export type Mutation = {
  __typename?: 'Mutation';
  billingCheckoutUrl: Scalars['String']['output'];
  billingPaymentDetailsUrl: Scalars['String']['output'];
  billingSetupIntentCardClientSecret: Scalars['String']['output'];
  billingUpdateCustomer: PaymentDetails;
  createApiKey: Organisation;
  deleteApiKey: Organisation;
  notificationsMarkAsRead: Scalars['Boolean']['output'];
  organisationCreate: Organisation;
  organisationDelete: Scalars['Boolean']['output'];
  organisationUpdate: Organisation;
  projectActivate: Project;
  projectAddAction: Project;
  projectAddComment: Project;
  projectAddCustomClass: Project;
  projectAddGuest: User;
  projectConfirmPointCloudUpload?: Maybe<Scalars['Boolean']['output']>;
  projectDelete: Scalars['Boolean']['output'];
  projectDeleteCalculation: Project;
  projectDeleteComment: Project;
  projectDeleteCustomClass: Project;
  projectDeleteExport: Project;
  projectDuplicate: Project;
  projectEditAnnotationClass: Project;
  projectEditAnnotationColor: Project;
  projectEditComment: Project;
  projectEditCustomClassColor: Project;
  projectEditCustomClassName: Project;
  projectEditLayerElevation: Project;
  projectExportPointcloud: Project;
  projectGenerateClassifications: Project;
  projectInitialize: Project;
  projectPointCloudDelete: Project;
  projectProjectionCalculate: Project;
  projectRelaunch: Project;
  projectRemoveGuest: User;
  projectStart: Project;
  projectStartWithPythagorasFiles: Project;
  projectToggleObjectLabelVisibility: Project;
  projectToggleObjectVisibility: Project;
  projectUndoAction: Project;
  projectUpdate: Project;
  projectUpdateClippingMethod: Project;
  projectUpdateClippingTolerance: Project;
  projectUpdatePreviewImage: Project;
  projectUpdateSettings: Project;
  projectVolumeCalculate: Project;
  superadminUpdatePlan: Organisation;
  superadminUpdateTrialDate: Organisation;
  userAcceptInvitation?: Maybe<Scalars['Boolean']['output']>;
  userAddToOrganisation: User;
  userChangeDarkMode: User;
  userChangeDateFormat: User;
  userChangeLanguage: User;
  userChangeRole: User;
  userChangeUnits: User;
  userDeleteFromOrganisation: Scalars['Boolean']['output'];
  userDisable: User;
  userEnable: User;
  userResendInvitation: User;
  userUpdate: User;
  userUpdateFavorites: User;
};


export type MutationBillingCheckoutUrlArgs = {
  organisationId: Scalars['ID']['input'];
  priceId: Scalars['ID']['input'];
};


export type MutationBillingPaymentDetailsUrlArgs = {
  organisationId: Scalars['ID']['input'];
};


export type MutationBillingSetupIntentCardClientSecretArgs = {
  organisationId: Scalars['ID']['input'];
};


export type MutationBillingUpdateCustomerArgs = {
  customer: InputBillingCustomer;
  organisationId: Scalars['ID']['input'];
};


export type MutationCreateApiKeyArgs = {
  keyType: ApiKeyType;
  licenseKey?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
};


export type MutationDeleteApiKeyArgs = {
  apiKey: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
};


export type MutationNotificationsMarkAsReadArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationOrganisationCreateArgs = {
  name: Scalars['String']['input'];
  sector: Scalars['String']['input'];
};


export type MutationOrganisationDeleteArgs = {
  organisationId: Scalars['ID']['input'];
};


export type MutationOrganisationUpdateArgs = {
  name: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
};


export type MutationProjectActivateArgs = {
  projectId: Scalars['ID']['input'];
};


export type MutationProjectAddActionArgs = {
  action: InputProjectAction;
  projectId: Scalars['ID']['input'];
};


export type MutationProjectAddCommentArgs = {
  comment: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  referenceIdentifier: Scalars['String']['input'];
};


export type MutationProjectAddCustomClassArgs = {
  color: InputColor;
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectAddGuestArgs = {
  email: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectConfirmPointCloudUploadArgs = {
  fileNames: Array<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  shouldMerge?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationProjectDeleteArgs = {
  projectId: Scalars['ID']['input'];
};


export type MutationProjectDeleteCalculationArgs = {
  calculationId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectDeleteCommentArgs = {
  commentId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectDeleteCustomClassArgs = {
  customClassId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectDeleteExportArgs = {
  exportId: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectDuplicateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectEditAnnotationClassArgs = {
  annotationIds: Array<Scalars['ID']['input']>;
  newClass?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['ID']['input'];
};


export type MutationProjectEditAnnotationColorArgs = {
  annotationIds: Array<Scalars['ID']['input']>;
  newColor: InputColor;
  projectId: Scalars['ID']['input'];
};


export type MutationProjectEditCommentArgs = {
  commentId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  updatedComment: Scalars['String']['input'];
};


export type MutationProjectEditCustomClassColorArgs = {
  customClassId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  updatedColor: InputColor;
};


export type MutationProjectEditCustomClassNameArgs = {
  customClassId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  updatedName: Scalars['String']['input'];
};


export type MutationProjectEditLayerElevationArgs = {
  layerIds: Array<Scalars['ID']['input']>;
  newElevation: Scalars['Float']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectExportPointcloudArgs = {
  classificationFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  clippingFilter?: InputMaybe<Scalars['Int']['input']>;
  fileType?: InputMaybe<FileTypes>;
  heightFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  intensityFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  pointCloudId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  resolutionFilter?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationProjectGenerateClassificationsArgs = {
  cloudName: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectInitializeArgs = {
  organisationId: Scalars['ID']['input'];
};


export type MutationProjectPointCloudDeleteArgs = {
  pointCloudId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectProjectionCalculateArgs = {
  annotationIdentifier: Scalars['String']['input'];
  classificationFilters?: InputMaybe<Array<Scalars['Int']['input']>>;
  clippingFilter?: InputMaybe<Scalars['Int']['input']>;
  heightFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  intensityFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  pointCloudId: Scalars['ID']['input'];
  profileGroupIdentifier: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  resolutionFilter?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationProjectRelaunchArgs = {
  projectId: Scalars['ID']['input'];
};


export type MutationProjectRemoveGuestArgs = {
  projectId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationProjectStartArgs = {
  cloudNames?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileNames: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  shouldMerge?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationProjectStartWithPythagorasFilesArgs = {
  cloudName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectToggleObjectLabelVisibilityArgs = {
  identifiers: Array<Scalars['String']['input']>;
  label: AnnotationLabels;
  projectId: Scalars['ID']['input'];
  visible: Scalars['Boolean']['input'];
};


export type MutationProjectToggleObjectVisibilityArgs = {
  identifiers: Array<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  visible: Scalars['Boolean']['input'];
};


export type MutationProjectUndoActionArgs = {
  identifier: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectUpdateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectUpdateClippingMethodArgs = {
  annotationIdentifiers: Array<Scalars['String']['input']>;
  clipMethod: ClipMethods;
  projectId: Scalars['ID']['input'];
};


export type MutationProjectUpdateClippingToleranceArgs = {
  annotationIdentifiers: Array<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  tolerance: Scalars['Float']['input'];
};


export type MutationProjectUpdatePreviewImageArgs = {
  previewImageFileName: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectUpdateSettingsArgs = {
  projectId: Scalars['ID']['input'];
  settings: InputProjectSettings;
};


export type MutationProjectVolumeCalculateArgs = {
  annotationIdentifier: Scalars['String']['input'];
  baseSurface: CalculationBaseSurfaces;
  classificationFilters?: InputMaybe<Array<Scalars['Int']['input']>>;
  clippingFilter?: InputMaybe<Scalars['Int']['input']>;
  heightFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  intensityFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  pointCloudId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  referenceHeight?: InputMaybe<Scalars['Float']['input']>;
  resolutionFilter?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSuperadminUpdatePlanArgs = {
  customLimits: InputSubscriptionCustomLimits;
  endDate: Scalars['Date']['input'];
  organisationId: Scalars['ID']['input'];
  subscriptionType: SubscriptionType;
};


export type MutationSuperadminUpdateTrialDateArgs = {
  endDate: Scalars['Date']['input'];
  organisationId: Scalars['ID']['input'];
};


export type MutationUserAcceptInvitationArgs = {
  inviteId: Scalars['String']['input'];
  user?: InputMaybe<InputUser>;
  userEmail: Scalars['String']['input'];
};


export type MutationUserAddToOrganisationArgs = {
  email: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
  role: UserRole;
};


export type MutationUserChangeDarkModeArgs = {
  inDarkMode: Scalars['Boolean']['input'];
};


export type MutationUserChangeDateFormatArgs = {
  inFormat: DateFormats;
};


export type MutationUserChangeLanguageArgs = {
  language: Language;
};


export type MutationUserChangeRoleArgs = {
  organisationId: Scalars['ID']['input'];
  role: UserRole;
  userId: Scalars['ID']['input'];
};


export type MutationUserChangeUnitsArgs = {
  inUnit: MeasurementUnits;
};


export type MutationUserDeleteFromOrganisationArgs = {
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUserDisableArgs = {
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUserEnableArgs = {
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUserResendInvitationArgs = {
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUserUpdateArgs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserUpdateFavoritesArgs = {
  inFavorites: Scalars['Boolean']['input'];
  projectId: Scalars['ID']['input'];
};

export type Notification = {
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  type: NotificationType;
};

export enum NotificationType {
  PointcloudCalculationDone = 'POINTCLOUD_CALCULATION_DONE',
  PointcloudConvertDone = 'POINTCLOUD_CONVERT_DONE',
  PointcloudExportDone = 'POINTCLOUD_EXPORT_DONE',
  UserAcceptedInvitation = 'USER_ACCEPTED_INVITATION'
}

export type Organisation = {
  __typename?: 'Organisation';
  apiKeys: Array<ApiKey>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isRootOrganisation?: Maybe<Scalars['Boolean']['output']>;
  licenseKey?: Maybe<Scalars['String']['output']>;
  myPermissions: Array<Permissions>;
  name: Scalars['String']['output'];
  prohibitedActions: Array<PossibleActions>;
  projects: Array<Project>;
  stats: OrganisationStats;
  subscription: OrganisationSubscription;
  usersAmount: Scalars['Int']['output'];
};

export type OrganisationStats = {
  __typename?: 'OrganisationStats';
  totalMonthlyPointCount: Scalars['BigInt']['output'];
  totalMonthlyPointCountLeft: Scalars['Float']['output'];
  totalPointCount: Scalars['BigInt']['output'];
  totalPointCountLeft: Scalars['Float']['output'];
  totalProjects: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
};

export type OrganisationSubscription = {
  __typename?: 'OrganisationSubscription';
  canAddPointClouds: Scalars['Boolean']['output'];
  canAddSimultaneousUploads: Scalars['Boolean']['output'];
  customLimits?: Maybe<SubscriptionCustomLimits>;
  endDate?: Maybe<Scalars['Date']['output']>;
  isFreeTrial: Scalars['Boolean']['output'];
  limits: SubscriptionLimits;
  simultaneousUploadsLeft: Scalars['Int']['output'];
  type: SubscriptionType;
};

export type OrthophotoLayer = {
  __typename?: 'OrthophotoLayer';
  elevation?: Maybe<Scalars['Float']['output']>;
  identifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
  visible: Scalars['Boolean']['output'];
};

export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  VAT?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Address>;
  cardBrand?: Maybe<Scalars['String']['output']>;
  cardLast4?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<Scalars['String']['output']>;
};

export enum Permissions {
  All = 'ALL',
  ApiKey = 'API_KEY',
  Billing = 'BILLING',
  Organisations = 'ORGANISATIONS',
  Projects = 'PROJECTS',
  ProjectsComment = 'PROJECTS_COMMENT',
  ProjectsRead = 'PROJECTS_READ',
  Users = 'USERS'
}

export type Plane = Annotation & {
  __typename?: 'Plane';
  annotationColor?: Maybe<Color>;
  annotationFilter?: Maybe<PlaneFilters>;
  groupIdentifier?: Maybe<Scalars['String']['output']>;
  hiddenLabels: Array<AnnotationLabels>;
  identifier: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  normal: Position;
  position: Position;
  type: Scalars['AnnotationType']['output'];
  visible: Scalars['Boolean']['output'];
};

export type PlaneFilters = {
  clipMethod: ClipMethods;
  tolerance: Scalars['Float']['output'];
};

export type Point = {
  __typename?: 'Point';
  pointCloudId?: Maybe<Scalars['String']['output']>;
  position: Position;
};

export type PointAnnotation = Annotation & {
  __typename?: 'PointAnnotation';
  annotationColor?: Maybe<Color>;
  classification?: Maybe<Scalars['Int']['output']>;
  color?: Maybe<Color>;
  groupIdentifier?: Maybe<Scalars['String']['output']>;
  hiddenLabels: Array<AnnotationLabels>;
  identifier: Scalars['ID']['output'];
  intensity?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  pointCloudId?: Maybe<Scalars['String']['output']>;
  position: Position;
  type: Scalars['AnnotationType']['output'];
  visible: Scalars['Boolean']['output'];
};

export type PointCloud = {
  __typename?: 'PointCloud';
  availableClasses: Array<Scalars['Int']['output']>;
  cloudName: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  hasClassifications: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  pointCount?: Maybe<Scalars['BigInt']['output']>;
  uploadStatus: UploadStatus;
  visible: Scalars['Boolean']['output'];
};

export type PointCloudCalculationDoneNotification = Notification & {
  __typename?: 'PointCloudCalculationDoneNotification';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  meta: PointCloudCalculationDoneNotificationMeta;
  organisationId: Scalars['ID']['output'];
  type: NotificationType;
};

export type PointCloudCalculationDoneNotificationMeta = {
  __typename?: 'PointCloudCalculationDoneNotificationMeta';
  annotationIdentifier?: Maybe<Scalars['ID']['output']>;
  pointCloudIdentifier?: Maybe<Scalars['ID']['output']>;
  projectId: Scalars['ID']['output'];
  projectName: Scalars['String']['output'];
  status?: Maybe<GeneralStatus>;
};

export type PointCloudConvertDoneNotification = Notification & {
  __typename?: 'PointCloudConvertDoneNotification';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  meta: PointCloudConvertDoneNotificationMeta;
  organisationId: Scalars['ID']['output'];
  type: NotificationType;
};

export type PointCloudConvertDoneNotificationMeta = {
  __typename?: 'PointCloudConvertDoneNotificationMeta';
  projectId: Scalars['ID']['output'];
  projectName: Scalars['String']['output'];
  status?: Maybe<UploadStatus>;
};

export type PointCloudExportDoneNotification = Notification & {
  __typename?: 'PointCloudExportDoneNotification';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  meta: PointCloudConvertDoneNotificationMeta;
  organisationId: Scalars['ID']['output'];
  type: NotificationType;
};

export type PointCloudExportDoneNotificationMeta = {
  __typename?: 'PointCloudExportDoneNotificationMeta';
  export?: Maybe<Export>;
  projectId: Scalars['ID']['output'];
  projectName: Scalars['String']['output'];
  status?: Maybe<GeneralStatus>;
};

export type PointCluster = Annotation & {
  __typename?: 'PointCluster';
  annotationClass?: Maybe<Scalars['Int']['output']>;
  annotationColor?: Maybe<Color>;
  annotationFilter?: Maybe<PointClusterFilters>;
  groupIdentifier?: Maybe<Scalars['String']['output']>;
  hiddenLabels: Array<AnnotationLabels>;
  identifier: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  segments: Array<Segment>;
  type: Scalars['AnnotationType']['output'];
  visible: Scalars['Boolean']['output'];
};

export type PointClusterFilters = {
  clipMethod: ClipMethods;
};

export type Position = {
  __typename?: 'Position';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
  z: Scalars['Float']['output'];
};

export enum PossibleActions {
  ToolFloorPlan = 'TOOL_FLOOR_PLAN',
  ToolPlane = 'TOOL_PLANE'
}

export type Price = {
  __typename?: 'Price';
  currency: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type Project = {
  __typename?: 'Project';
  assignee?: Maybe<User>;
  assigneeId?: Maybe<Scalars['ID']['output']>;
  calculations: Array<Calculation>;
  comments?: Maybe<Array<Comment>>;
  customClasses?: Maybe<Array<CustomClass>>;
  description?: Maybe<Scalars['String']['output']>;
  exports: Array<Export>;
  id: Scalars['ID']['output'];
  isInitializing?: Maybe<Scalars['Boolean']['output']>;
  mapVisible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pointClouds: Array<PointCloud>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<ProjectSettings>;
  state: ProjectState;
  stateByAnnotation: Array<StateByAnnotation>;
  stateByLayer: Array<StateByLayer>;
  stateByUser: Array<StateByUser>;
  uploadStatus: UploadStatus;
};

export type ProjectSettings = {
  __typename?: 'ProjectSettings';
  projectionSystem?: Maybe<Scalars['String']['output']>;
};

export type ProjectState = {
  __typename?: 'ProjectState';
  annotations: Array<Annotation>;
  cadLayers: Array<CadLayer>;
  groups: Array<AnnotationGroup>;
  orderedIdentifiers: Array<OrderedIdentifier>;
  orthophotoLayerOrderedIdentifiers: Array<OrderedIdentifier>;
  orthophotoLayers: Array<OrthophotoLayer>;
  wmsLayerOrderedIdentifiers: Array<OrderedIdentifier>;
  wmsLayers: Array<WmsLayer>;
};

export type ProjectionCalculation = Calculation & {
  __typename?: 'ProjectionCalculation';
  annotationIdentifier: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isOutDated: Scalars['Boolean']['output'];
  paramInfo: ProjectionCalculationParamInfo;
  pointCloudIdentifier: Scalars['String']['output'];
  profileGroupIdentifier: Scalars['String']['output'];
  result?: Maybe<ProjectionCalculationResult>;
  status: GeneralStatus;
};

export type ProjectionCalculationParamInfo = {
  __typename?: 'ProjectionCalculationParamInfo';
  classificationFilters?: Maybe<Array<Scalars['Int']['output']>>;
  clippingFilter?: Maybe<Scalars['Int']['output']>;
  heightFilters?: Maybe<Array<Scalars['Int']['output']>>;
  intensityFilters?: Maybe<Array<Scalars['Int']['output']>>;
  resolutionFilter?: Maybe<Scalars['Int']['output']>;
};

export type ProjectionCalculationResult = {
  __typename?: 'ProjectionCalculationResult';
  projection: Array<DistanceProjection>;
};

export type Query = {
  __typename?: 'Query';
  billingInvoices: Array<BillingInvoice>;
  billingPaymentDetails?: Maybe<PaymentDetails>;
  billingProducts: Array<BillingProduct>;
  currentUser?: Maybe<User>;
  hubspotSectors: Array<GeneralOptions>;
  notifications: Array<Notification>;
  organisationAPIKeyByLicenseKey: ApiKeyByLicenseKeyResult;
  organisationById: Organisation;
  organisationJwtToken: Scalars['String']['output'];
  organisations: Array<Organisation>;
  projectById: Project;
  projectRequestDownloadToken: Scalars['String']['output'];
  projectRequestReadSASToken: Scalars['String']['output'];
  projectRequestUploadSAS: Scalars['String']['output'];
  projectsByOrganisationId: Array<Project>;
  superadminOrganisations: Array<Organisation>;
  userInviteInfo: InviteInfo;
  usersByOrganisationId: Array<User>;
};


export type QueryBillingInvoicesArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryBillingPaymentDetailsArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryOrganisationApiKeyByLicenseKeyArgs = {
  licenseKey: Scalars['String']['input'];
};


export type QueryOrganisationByIdArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryOrganisationJwtTokenArgs = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  licenseKey?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['ID']['input'];
};


export type QueryOrganisationsArgs = {
  includeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryProjectByIdArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectRequestDownloadTokenArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectRequestReadSasTokenArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectRequestUploadSasArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectsByOrganisationIdArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryUserInviteInfoArgs = {
  token: Scalars['String']['input'];
};


export type QueryUsersByOrganisationIdArgs = {
  organisationId: Scalars['ID']['input'];
};

export type Segment = {
  __typename?: 'Segment';
  pointcloudId: Scalars['String']['output'];
  segmentId: Scalars['Int']['output'];
};

export type StateByUser = {
  __typename?: 'StateByUser';
  annotationFilters: Array<UserStateAnnotationFilter>;
  hiddenIdentifiers: Array<Scalars['String']['output']>;
  hiddenLabels: Array<HiddenLabels>;
  userId: Scalars['ID']['output'];
};

export type SubscriptionCustomLimits = {
  __typename?: 'SubscriptionCustomLimits';
  maxMonthlyPointCount?: Maybe<Scalars['Float']['output']>;
  maxPointCount?: Maybe<Scalars['Float']['output']>;
  maxUploadsInProgress?: Maybe<Scalars['Int']['output']>;
  trialEndDate?: Maybe<Scalars['Date']['output']>;
};

export type SubscriptionLimits = {
  __typename?: 'SubscriptionLimits';
  maxMonthlyPointCount: Scalars['Float']['output'];
  maxPointCount: Scalars['Float']['output'];
  maxUploadsInProgress: Scalars['Int']['output'];
};

export enum SubscriptionType {
  Custom = 'CUSTOM',
  Free = 'FREE',
  Grow = 'GROW',
  Launch = 'LAUNCH',
  Scale = 'SCALE'
}

export type UnGroupAction = {
  groupIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
};

export type UpdateNameAction = {
  annotationIdentifier?: InputMaybe<Scalars['String']['input']>;
  cadLayerIdentifier?: InputMaybe<Scalars['String']['input']>;
  groupIdentifier?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orthophotoLayerIdentifier?: InputMaybe<Scalars['String']['input']>;
  pointCloudIdentifier?: InputMaybe<Scalars['String']['input']>;
  wmsLayerIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePositionAction = {
  identifier: Scalars['String']['input'];
  identifiers: Array<UpdatePositionActionIdentifiers>;
  toGroupIdentifier?: InputMaybe<Scalars['String']['input']>;
  toIndex: Scalars['Int']['input'];
};

export type UpdatePositionActionIdentifiers = {
  identifier: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type UpdatePositionOrthophotoLayerAction = {
  identifier: Scalars['String']['input'];
  identifiers: Array<UpdatePositionOrthophotoLayerActionIdentifiers>;
  toIndex: Scalars['Int']['input'];
};

export type UpdatePositionOrthophotoLayerActionIdentifiers = {
  identifier: Scalars['String']['input'];
};

export type UpdatePositionWmsLayerAction = {
  identifier: Scalars['String']['input'];
  identifiers: Array<UpdatePositionWmsLayerActionIdentifiers>;
  toIndex: Scalars['Int']['input'];
};

export type UpdatePositionWmsLayerActionIdentifiers = {
  identifier: Scalars['String']['input'];
};

export type UpdateWmsLayerAction = {
  identifier: Scalars['String']['input'];
  layerId: Scalars['String']['input'];
  layerName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  type: WmsType;
  url: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export enum UploadStatus {
  Error = 'ERROR',
  Progress = 'PROGRESS',
  Success = 'SUCCESS',
  Suspended = 'SUSPENDED'
}

export type User = {
  __typename?: 'User';
  allowedProjectIds: Array<Scalars['ID']['output']>;
  allowedProjects: Array<Project>;
  darkMode?: Maybe<Scalars['Boolean']['output']>;
  dateFormat: DateFormats;
  email: Scalars['String']['output'];
  favoriteProjectIds: Array<Scalars['ID']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isSuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  joinDate?: Maybe<Scalars['Date']['output']>;
  language: Language;
  lastName: Scalars['String']['output'];
  measurementUnit: MeasurementUnits;
  name: Scalars['String']['output'];
  organisations: Array<Organisation>;
  role: UserRole;
  rolesByOrganisation: Array<UserRoleOrganisation>;
  status?: Maybe<UserStatus>;
};


export type UserAllowedProjectIdsArgs = {
  organisationId: Scalars['ID']['input'];
};


export type UserAllowedProjectsArgs = {
  organisationId: Scalars['ID']['input'];
};


export type UserJoinDateArgs = {
  organisationId: Scalars['ID']['input'];
};


export type UserRoleArgs = {
  organisationId: Scalars['ID']['input'];
};


export type UserStatusArgs = {
  organisationId: Scalars['ID']['input'];
};

export type UserAcceptedInvitationNotification = Notification & {
  __typename?: 'UserAcceptedInvitationNotification';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  meta: UserAcceptedInvitationNotificationMeta;
  organisationId: Scalars['ID']['output'];
  type: NotificationType;
};

export type UserAcceptedInvitationNotificationMeta = {
  __typename?: 'UserAcceptedInvitationNotificationMeta';
  organisationName: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export enum UserRole {
  Admin = 'ADMIN',
  ApiKey = 'API_KEY',
  Guest = 'GUEST',
  Member = 'MEMBER'
}

export type UserRoleOrganisation = {
  __typename?: 'UserRoleOrganisation';
  organisationId: Scalars['ID']['output'];
  role: UserRole;
};

export type UserStateAnnotationFilter = UserStateBoxAnnotationFilter | UserStatePlaneFilter | UserStatePointClusterFilter;

export type UserStateBoxAnnotationFilter = BoxAnnotationFilters & {
  __typename?: 'UserStateBoxAnnotationFilter';
  clipMethod: ClipMethods;
  identifier: Scalars['String']['output'];
};

export type UserStatePlaneFilter = PlaneFilters & {
  __typename?: 'UserStatePlaneFilter';
  clipMethod: ClipMethods;
  identifier: Scalars['String']['output'];
  tolerance: Scalars['Float']['output'];
};

export type UserStatePointClusterFilter = PointClusterFilters & {
  __typename?: 'UserStatePointClusterFilter';
  clipMethod: ClipMethods;
  identifier: Scalars['String']['output'];
};

export enum UserStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  InvitePending = 'INVITE_PENDING'
}

export type VolumeCalculation = Calculation & {
  __typename?: 'VolumeCalculation';
  annotationIdentifier: Scalars['String']['output'];
  baseSurface: CalculationBaseSurfaces;
  id: Scalars['ID']['output'];
  isOutDated: Scalars['Boolean']['output'];
  paramInfo: VolumeCalculationParamInfo;
  pointCloudIdentifier: Scalars['String']['output'];
  result?: Maybe<VolumeCalculationResult>;
  status: GeneralStatus;
};

export type VolumeCalculationParamInfo = {
  __typename?: 'VolumeCalculationParamInfo';
  classificationFilters?: Maybe<Array<Scalars['Int']['output']>>;
  clippingFilter?: Maybe<Scalars['Int']['output']>;
  heightFilters?: Maybe<Array<Scalars['Int']['output']>>;
  intensityFilters?: Maybe<Array<Scalars['Int']['output']>>;
  referenceHeight?: Maybe<Scalars['Float']['output']>;
  resolutionFilter?: Maybe<Scalars['Int']['output']>;
};

export type VolumeCalculationResult = {
  __typename?: 'VolumeCalculationResult';
  area: Scalars['Float']['output'];
  volume: Scalars['Float']['output'];
  volumeNegative: Scalars['Float']['output'];
  volumePositive: Scalars['Float']['output'];
};

export type WmsLayer = {
  __typename?: 'WMSLayer';
  identifier: Scalars['String']['output'];
  layerName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  password?: Maybe<Scalars['String']['output']>;
  type: WmsType;
  url: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
  visible: Scalars['Boolean']['output'];
};

export enum WmsType {
  Wms = 'WMS',
  Wmts = 'WMTS'
}

export type OrderedIdentifier = {
  __typename?: 'orderedIdentifier';
  identifier: Scalars['String']['output'];
  index: Scalars['Int']['output'];
};

export type StateByAnnotation = {
  __typename?: 'stateByAnnotation';
  annotationClass?: Maybe<Scalars['Int']['output']>;
  annotationColor?: Maybe<Color>;
  annotationId: Scalars['String']['output'];
};

export type StateByLayer = {
  __typename?: 'stateByLayer';
  layerElevation?: Maybe<Scalars['Float']['output']>;
  layerId: Scalars['String']['output'];
};

type ApiKey_ApiKeyWithLicenseKey_Fragment = { __typename?: 'ApiKeyWithLicenseKey', licenseKey: string, name: string, apiKey: string };

type ApiKey_DefaultApiKey_Fragment = { __typename?: 'DefaultApiKey', name: string, apiKey: string };

export type ApiKeyFragment = ApiKey_ApiKeyWithLicenseKey_Fragment | ApiKey_DefaultApiKey_Fragment;

export type CreateApiKeyMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  keyType: ApiKeyType;
  licenseKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateApiKeyMutation = { __typename?: 'Mutation', createApiKey: { __typename?: 'Organisation', id: string, apiKeys: Array<{ __typename?: 'ApiKeyWithLicenseKey', licenseKey: string, name: string, apiKey: string } | { __typename?: 'DefaultApiKey', name: string, apiKey: string }> } };

export type DeleteApiKeyMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  apiKey: Scalars['String']['input'];
}>;


export type DeleteApiKeyMutation = { __typename?: 'Mutation', deleteApiKey: { __typename?: 'Organisation', id: string, apiKeys: Array<{ __typename?: 'ApiKeyWithLicenseKey', licenseKey: string, name: string, apiKey: string } | { __typename?: 'DefaultApiKey', name: string, apiKey: string }> } };

export type ApiKeysQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type ApiKeysQuery = { __typename?: 'Query', organisation: { __typename?: 'Organisation', id: string, apiKeys: Array<{ __typename?: 'ApiKeyWithLicenseKey', licenseKey: string, name: string, apiKey: string } | { __typename?: 'DefaultApiKey', name: string, apiKey: string }> } };

export type BillingProductsQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type BillingProductsQuery = { __typename?: 'Query', billingProducts: Array<{ __typename?: 'BillingProduct', name: string, description: string, isActive?: boolean | null, endDate?: any | null, prices: Array<{ __typename?: 'BillingProductPrice', value: number, currency: string, period?: string | null, id: string }> }> };

export type BillingInvoicesQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type BillingInvoicesQuery = { __typename?: 'Query', billingInvoices: Array<{ __typename?: 'BillingInvoice', date: any, description: string, url?: string | null, price: { __typename?: 'Price', value: number, currency: string } }> };

export type PaymentDetailsFragment = { __typename?: 'PaymentDetails', name?: string | null, VAT?: string | null, email?: string | null, paymentType?: string | null, cardBrand?: string | null, cardLast4?: string | null, address?: { __typename?: 'Address', postalCode?: string | null, country?: string | null, line1?: string | null, line2?: string | null, city?: string | null } | null };

export type BillingPaymentDetailsQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type BillingPaymentDetailsQuery = { __typename?: 'Query', billingPaymentDetails?: { __typename?: 'PaymentDetails', name?: string | null, VAT?: string | null, email?: string | null, paymentType?: string | null, cardBrand?: string | null, cardLast4?: string | null, address?: { __typename?: 'Address', postalCode?: string | null, country?: string | null, line1?: string | null, line2?: string | null, city?: string | null } | null } | null };

export type BillingCheckoutUrlMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  priceId: Scalars['ID']['input'];
}>;


export type BillingCheckoutUrlMutation = { __typename?: 'Mutation', billingCheckoutUrl: string };

export type BillingSetupIntentCardClientSecretMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type BillingSetupIntentCardClientSecretMutation = { __typename?: 'Mutation', billingSetupIntentCardClientSecret: string };

export type BillingUpdateCustomerMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  customer: InputBillingCustomer;
}>;


export type BillingUpdateCustomerMutation = { __typename?: 'Mutation', billingUpdateCustomer: { __typename?: 'PaymentDetails', name?: string | null, VAT?: string | null, email?: string | null, paymentType?: string | null, cardBrand?: string | null, cardLast4?: string | null, address?: { __typename?: 'Address', postalCode?: string | null, country?: string | null, line1?: string | null, line2?: string | null, city?: string | null } | null } };

export type HubspotSectorsQueryVariables = Exact<{ [key: string]: never; }>;


export type HubspotSectorsQuery = { __typename?: 'Query', hubspotSectors: Array<{ __typename?: 'GeneralOptions', value: string }> };

export type NotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'PointCloudCalculationDoneNotification', organisationId: string, id: string, type: NotificationType, isRead?: boolean | null, createdAt: any, meta: { __typename?: 'PointCloudCalculationDoneNotificationMeta', projectId: string, projectName: string, status?: GeneralStatus | null, annotationIdentifier?: string | null } } | { __typename?: 'PointCloudConvertDoneNotification', organisationId: string, id: string, type: NotificationType, isRead?: boolean | null, createdAt: any, meta: { __typename?: 'PointCloudConvertDoneNotificationMeta', projectId: string, projectName: string, uploadStatus?: UploadStatus | null } } | { __typename?: 'PointCloudExportDoneNotification', organisationId: string, id: string, type: NotificationType, isRead?: boolean | null, createdAt: any, meta: { __typename?: 'PointCloudConvertDoneNotificationMeta', projectId: string, projectName: string } } | { __typename?: 'UserAcceptedInvitationNotification', organisationId: string, id: string, type: NotificationType, isRead?: boolean | null, createdAt: any, meta: { __typename?: 'UserAcceptedInvitationNotificationMeta', organisationName: string, userName: string } }> };

export type NotificationsMarkAsReadMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type NotificationsMarkAsReadMutation = { __typename?: 'Mutation', notificationsMarkAsRead: boolean };

export type OrganisationsFragment = { __typename?: 'Organisation', id: string, name: string, usersAmount: number, myPermissions: Array<Permissions>, isRootOrganisation?: boolean | null, prohibitedActions: Array<PossibleActions>, createdAt: any, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalMonthlyPointCount: any, totalPointCountLeft: number, totalMonthlyPointCountLeft: number, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, isFreeTrial: boolean, endDate?: any | null, canAddPointClouds: boolean, canAddSimultaneousUploads: boolean, simultaneousUploadsLeft: number } };

export type OrganisationsQueryVariables = Exact<{
  includeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type OrganisationsQuery = { __typename?: 'Query', organisations: Array<{ __typename?: 'Organisation', id: string, name: string, usersAmount: number, myPermissions: Array<Permissions>, isRootOrganisation?: boolean | null, prohibitedActions: Array<PossibleActions>, createdAt: any, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalMonthlyPointCount: any, totalPointCountLeft: number, totalMonthlyPointCountLeft: number, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, isFreeTrial: boolean, endDate?: any | null, canAddPointClouds: boolean, canAddSimultaneousUploads: boolean, simultaneousUploadsLeft: number } }> };

export type OrganisationUpdateMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type OrganisationUpdateMutation = { __typename?: 'Mutation', organisationUpdate: { __typename?: 'Organisation', id: string, name: string } };

export type OrganisationCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  sector: Scalars['String']['input'];
}>;


export type OrganisationCreateMutation = { __typename?: 'Mutation', organisationCreate: { __typename?: 'Organisation', id: string, name: string, usersAmount: number, myPermissions: Array<Permissions>, isRootOrganisation?: boolean | null, prohibitedActions: Array<PossibleActions>, createdAt: any, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalMonthlyPointCount: any, totalPointCountLeft: number, totalMonthlyPointCountLeft: number, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, isFreeTrial: boolean, endDate?: any | null, canAddPointClouds: boolean, canAddSimultaneousUploads: boolean, simultaneousUploadsLeft: number } } };

export type OrganisationDeleteMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type OrganisationDeleteMutation = { __typename?: 'Mutation', organisationDelete: boolean };

export type ProjectsFragment = { __typename?: 'Project', id: string, name: string, description?: string | null, uploadStatus: UploadStatus, isInitializing?: boolean | null, previewUrl?: string | null, assignee?: { __typename?: 'User', id: string, name: string } | null, pointClouds: Array<{ __typename?: 'PointCloud', id: string, pointCount?: any | null }> };

export type ProjectStateFragment = { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'AreaAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, points: Array<{ __typename?: 'Point', pointCloudId?: string | null, position: { __typename?: 'Position', x: number, y: number, z: number } }>, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'BoxAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, scale: { __typename?: 'Position', x: number, y: number, z: number }, rotation: { __typename?: 'Position', x: number, y: number, z: number }, annotationFilter?: { __typename?: 'UserStateBoxAnnotationFilter', clipMethod: ClipMethods } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'DistanceAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, points: Array<{ __typename?: 'Point', pointCloudId?: string | null, position: { __typename?: 'Position', x: number, y: number, z: number } }>, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'Plane', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, normal: { __typename?: 'Position', x: number, y: number, z: number }, annotationFilter?: { __typename?: 'UserStatePlaneFilter', clipMethod: ClipMethods, tolerance: number } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'PointAnnotation', pointCloudId?: string | null, classification?: number | null, intensity?: number | null, identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, color?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'PointCluster', annotationClass?: number | null, identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, segments: Array<{ __typename?: 'Segment', pointcloudId: string, segmentId: number }>, annotationFilter?: { __typename?: 'UserStatePointClusterFilter', clipMethod: ClipMethods } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null }>, groups: Array<{ __typename?: 'AnnotationGroup', identifier: string, name: string }>, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<{ __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null } | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }> }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> };

type Calculation_ProjectionCalculation_Fragment = { __typename?: 'ProjectionCalculation', profileGroupIdentifier: string, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'ProjectionCalculationResult', projection: Array<{ __typename?: 'DistanceProjection', distance: number, height: number }> } | null, paramInfo: { __typename?: 'ProjectionCalculationParamInfo', heightFilters?: Array<number> | null, intensityFilters?: Array<number> | null, classificationFilters?: Array<number> | null, resolutionFilter?: number | null, clippingFilter?: number | null } };

type Calculation_VolumeCalculation_Fragment = { __typename?: 'VolumeCalculation', baseSurface: CalculationBaseSurfaces, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'VolumeCalculationResult', volume: number, area: number, volumePositive: number, volumeNegative: number } | null, paramInfo: { __typename?: 'VolumeCalculationParamInfo', referenceHeight?: number | null, heightFilters?: Array<number> | null, intensityFilters?: Array<number> | null, classificationFilters?: Array<number> | null, resolutionFilter?: number | null, clippingFilter?: number | null } };

export type CalculationFragment = Calculation_ProjectionCalculation_Fragment | Calculation_VolumeCalculation_Fragment;

export type ExportFragment = { __typename?: 'Export', exportId: string, status: GeneralStatus, type: string, createdAt: any, paramInfo: { __typename?: 'ExportParamInfo', fileType: FileTypes, heightFilters?: Array<number> | null, classificationFilters?: Array<number> | null, resolutionFilter?: number | null, clippingFilter?: number | null } };

export type ProjectFragment = { __typename?: 'Project', id: string, name: string, description?: string | null, uploadStatus: UploadStatus, mapVisible: boolean, previewUrl?: string | null, assignee?: { __typename?: 'User', id: string, name: string } | null, pointClouds: Array<{ __typename?: 'PointCloud', id: string, hasClassifications: boolean, uploadStatus: UploadStatus, cloudName: string, availableClasses: Array<number>, visible: boolean, displayName: string, pointCount?: any | null }>, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'AreaAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, points: Array<{ __typename?: 'Point', pointCloudId?: string | null, position: { __typename?: 'Position', x: number, y: number, z: number } }>, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'BoxAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, scale: { __typename?: 'Position', x: number, y: number, z: number }, rotation: { __typename?: 'Position', x: number, y: number, z: number }, annotationFilter?: { __typename?: 'UserStateBoxAnnotationFilter', clipMethod: ClipMethods } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'DistanceAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, points: Array<{ __typename?: 'Point', pointCloudId?: string | null, position: { __typename?: 'Position', x: number, y: number, z: number } }>, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'Plane', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, normal: { __typename?: 'Position', x: number, y: number, z: number }, annotationFilter?: { __typename?: 'UserStatePlaneFilter', clipMethod: ClipMethods, tolerance: number } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'PointAnnotation', pointCloudId?: string | null, classification?: number | null, intensity?: number | null, identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, color?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'PointCluster', annotationClass?: number | null, identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, segments: Array<{ __typename?: 'Segment', pointcloudId: string, segmentId: number }>, annotationFilter?: { __typename?: 'UserStatePointClusterFilter', clipMethod: ClipMethods } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null }>, groups: Array<{ __typename?: 'AnnotationGroup', identifier: string, name: string }>, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<{ __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null } | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }> }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> }, settings?: { __typename?: 'ProjectSettings', projectionSystem?: string | null } | null, calculations: Array<{ __typename?: 'ProjectionCalculation', profileGroupIdentifier: string, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'ProjectionCalculationResult', projection: Array<{ __typename?: 'DistanceProjection', distance: number, height: number }> } | null, paramInfo: { __typename?: 'ProjectionCalculationParamInfo', heightFilters?: Array<number> | null, intensityFilters?: Array<number> | null, classificationFilters?: Array<number> | null, resolutionFilter?: number | null, clippingFilter?: number | null } } | { __typename?: 'VolumeCalculation', baseSurface: CalculationBaseSurfaces, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'VolumeCalculationResult', volume: number, area: number, volumePositive: number, volumeNegative: number } | null, paramInfo: { __typename?: 'VolumeCalculationParamInfo', referenceHeight?: number | null, heightFilters?: Array<number> | null, intensityFilters?: Array<number> | null, classificationFilters?: Array<number> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }>, exports: Array<{ __typename?: 'Export', exportId: string, status: GeneralStatus, type: string, createdAt: any, paramInfo: { __typename?: 'ExportParamInfo', fileType: FileTypes, heightFilters?: Array<number> | null, classificationFilters?: Array<number> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }>, comments?: Array<{ __typename?: 'Comment', id: string, comment: string, referenceIdentifier: string, createdAt: any, updatedAt?: any | null, user: { __typename?: 'User', id: string, name: string } }> | null, customClasses?: Array<{ __typename?: 'CustomClass', id: string, name: string, code: number, color: { __typename?: 'Color', r: number, g: number, b: number, a: number } }> | null };

export type ProjectsQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type ProjectsQuery = { __typename?: 'Query', projectsByOrganisationId: Array<{ __typename?: 'Project', id: string, name: string, description?: string | null, uploadStatus: UploadStatus, isInitializing?: boolean | null, previewUrl?: string | null, assignee?: { __typename?: 'User', id: string, name: string } | null, pointClouds: Array<{ __typename?: 'PointCloud', id: string, pointCount?: any | null }> }> };

export type ProjectByIdQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectByIdQuery = { __typename?: 'Query', projectById: { __typename?: 'Project', id: string, name: string, description?: string | null, uploadStatus: UploadStatus, mapVisible: boolean, previewUrl?: string | null, assignee?: { __typename?: 'User', id: string, name: string } | null, pointClouds: Array<{ __typename?: 'PointCloud', id: string, hasClassifications: boolean, uploadStatus: UploadStatus, cloudName: string, availableClasses: Array<number>, visible: boolean, displayName: string, pointCount?: any | null }>, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'AreaAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, points: Array<{ __typename?: 'Point', pointCloudId?: string | null, position: { __typename?: 'Position', x: number, y: number, z: number } }>, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'BoxAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, scale: { __typename?: 'Position', x: number, y: number, z: number }, rotation: { __typename?: 'Position', x: number, y: number, z: number }, annotationFilter?: { __typename?: 'UserStateBoxAnnotationFilter', clipMethod: ClipMethods } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'DistanceAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, points: Array<{ __typename?: 'Point', pointCloudId?: string | null, position: { __typename?: 'Position', x: number, y: number, z: number } }>, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'Plane', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, normal: { __typename?: 'Position', x: number, y: number, z: number }, annotationFilter?: { __typename?: 'UserStatePlaneFilter', clipMethod: ClipMethods, tolerance: number } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'PointAnnotation', pointCloudId?: string | null, classification?: number | null, intensity?: number | null, identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, color?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'PointCluster', annotationClass?: number | null, identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, segments: Array<{ __typename?: 'Segment', pointcloudId: string, segmentId: number }>, annotationFilter?: { __typename?: 'UserStatePointClusterFilter', clipMethod: ClipMethods } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null }>, groups: Array<{ __typename?: 'AnnotationGroup', identifier: string, name: string }>, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<{ __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null } | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }> }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> }, settings?: { __typename?: 'ProjectSettings', projectionSystem?: string | null } | null, calculations: Array<{ __typename?: 'ProjectionCalculation', profileGroupIdentifier: string, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'ProjectionCalculationResult', projection: Array<{ __typename?: 'DistanceProjection', distance: number, height: number }> } | null, paramInfo: { __typename?: 'ProjectionCalculationParamInfo', heightFilters?: Array<number> | null, intensityFilters?: Array<number> | null, classificationFilters?: Array<number> | null, resolutionFilter?: number | null, clippingFilter?: number | null } } | { __typename?: 'VolumeCalculation', baseSurface: CalculationBaseSurfaces, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'VolumeCalculationResult', volume: number, area: number, volumePositive: number, volumeNegative: number } | null, paramInfo: { __typename?: 'VolumeCalculationParamInfo', referenceHeight?: number | null, heightFilters?: Array<number> | null, intensityFilters?: Array<number> | null, classificationFilters?: Array<number> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }>, exports: Array<{ __typename?: 'Export', exportId: string, status: GeneralStatus, type: string, createdAt: any, paramInfo: { __typename?: 'ExportParamInfo', fileType: FileTypes, heightFilters?: Array<number> | null, classificationFilters?: Array<number> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }>, comments?: Array<{ __typename?: 'Comment', id: string, comment: string, referenceIdentifier: string, createdAt: any, updatedAt?: any | null, user: { __typename?: 'User', id: string, name: string } }> | null, customClasses?: Array<{ __typename?: 'CustomClass', id: string, name: string, code: number, color: { __typename?: 'Color', r: number, g: number, b: number, a: number } }> | null } };

export type ProjectCalculationsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectCalculationsQuery = { __typename?: 'Query', projectById: { __typename?: 'Project', id: string, calculations: Array<{ __typename?: 'ProjectionCalculation', profileGroupIdentifier: string, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'ProjectionCalculationResult', projection: Array<{ __typename?: 'DistanceProjection', distance: number, height: number }> } | null, paramInfo: { __typename?: 'ProjectionCalculationParamInfo', heightFilters?: Array<number> | null, intensityFilters?: Array<number> | null, classificationFilters?: Array<number> | null, resolutionFilter?: number | null, clippingFilter?: number | null } } | { __typename?: 'VolumeCalculation', baseSurface: CalculationBaseSurfaces, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'VolumeCalculationResult', volume: number, area: number, volumePositive: number, volumeNegative: number } | null, paramInfo: { __typename?: 'VolumeCalculationParamInfo', referenceHeight?: number | null, heightFilters?: Array<number> | null, intensityFilters?: Array<number> | null, classificationFilters?: Array<number> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }> } };

export type ProjectExportsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectExportsQuery = { __typename?: 'Query', projectById: { __typename?: 'Project', id: string, exports: Array<{ __typename?: 'Export', exportId: string, status: GeneralStatus, type: string, createdAt: any, paramInfo: { __typename?: 'ExportParamInfo', fileType: FileTypes, heightFilters?: Array<number> | null, classificationFilters?: Array<number> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }> } };

export type ProjectDeleteExportMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  exportId: Scalars['String']['input'];
}>;


export type ProjectDeleteExportMutation = { __typename?: 'Mutation', projectDeleteExport: { __typename?: 'Project', id: string, exports: Array<{ __typename?: 'Export', exportId: string, status: GeneralStatus, type: string, createdAt: any, paramInfo: { __typename?: 'ExportParamInfo', fileType: FileTypes, heightFilters?: Array<number> | null, classificationFilters?: Array<number> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }> } };

export type ProjectRequestUploadSasQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectRequestUploadSasQuery = { __typename?: 'Query', projectRequestUploadSAS: string };

export type ProjectRequestReadSasTokenQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectRequestReadSasTokenQuery = { __typename?: 'Query', projectRequestReadSASToken: string };

export type ProjectStartMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  fileNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
  cloudNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  organisationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  shouldMerge?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProjectStartMutation = { __typename?: 'Mutation', projectStart: { __typename?: 'Project', id: string, name: string, description?: string | null, uploadStatus: UploadStatus, isInitializing?: boolean | null, previewUrl?: string | null, assignee?: { __typename?: 'User', id: string, name: string } | null, pointClouds: Array<{ __typename?: 'PointCloud', id: string, pointCount?: any | null }> } };

export type ProjectRelaunchMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectRelaunchMutation = { __typename?: 'Mutation', projectRelaunch: { __typename?: 'Project', id: string, name: string, description?: string | null, uploadStatus: UploadStatus, isInitializing?: boolean | null, previewUrl?: string | null, assignee?: { __typename?: 'User', id: string, name: string } | null, pointClouds: Array<{ __typename?: 'PointCloud', id: string, pointCount?: any | null }> } };

export type ProjectStartWithPythagorasFilesMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  cloudName: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type ProjectStartWithPythagorasFilesMutation = { __typename?: 'Mutation', projectStartWithPythagorasFiles: { __typename?: 'Project', id: string, name: string, description?: string | null, uploadStatus: UploadStatus, isInitializing?: boolean | null, previewUrl?: string | null, assignee?: { __typename?: 'User', id: string, name: string } | null, pointClouds: Array<{ __typename?: 'PointCloud', id: string, pointCount?: any | null }> } };

export type ProjectUpdateMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type ProjectUpdateMutation = { __typename?: 'Mutation', projectUpdate: { __typename?: 'Project', id: string, name: string, description?: string | null, uploadStatus: UploadStatus, isInitializing?: boolean | null, previewUrl?: string | null, assignee?: { __typename?: 'User', id: string, name: string } | null, pointClouds: Array<{ __typename?: 'PointCloud', id: string, pointCount?: any | null }> } };

export type ProjectUpdatePreviewImageMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  previewImageFileName: Scalars['String']['input'];
}>;


export type ProjectUpdatePreviewImageMutation = { __typename?: 'Mutation', projectUpdatePreviewImage: { __typename?: 'Project', id: string, name: string, description?: string | null, uploadStatus: UploadStatus, isInitializing?: boolean | null, previewUrl?: string | null, assignee?: { __typename?: 'User', id: string, name: string } | null, pointClouds: Array<{ __typename?: 'PointCloud', id: string, pointCount?: any | null }> } };

export type ProjectUpdateSettingsMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  settings: InputProjectSettings;
}>;


export type ProjectUpdateSettingsMutation = { __typename?: 'Mutation', projectUpdateSettings: { __typename?: 'Project', id: string, settings?: { __typename?: 'ProjectSettings', projectionSystem?: string | null } | null } };

export type ProjectDeleteMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectDeleteMutation = { __typename?: 'Mutation', projectDelete: boolean };

export type ProjectActivateMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectActivateMutation = { __typename?: 'Mutation', projectActivate: { __typename?: 'Project', uploadStatus: UploadStatus } };

export type ProjectDuplicateMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type ProjectDuplicateMutation = { __typename?: 'Mutation', projectDuplicate: { __typename?: 'Project', id: string } };

export type ProjectConfirmPointCloudUploadMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  fileNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
  shouldMerge?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProjectConfirmPointCloudUploadMutation = { __typename?: 'Mutation', projectConfirmPointCloudUpload?: boolean | null };

export type ProjectUndoActionMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  identifier: Scalars['String']['input'];
}>;


export type ProjectUndoActionMutation = { __typename?: 'Mutation', projectUndoAction: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'AreaAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, points: Array<{ __typename?: 'Point', pointCloudId?: string | null, position: { __typename?: 'Position', x: number, y: number, z: number } }>, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'BoxAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, scale: { __typename?: 'Position', x: number, y: number, z: number }, rotation: { __typename?: 'Position', x: number, y: number, z: number }, annotationFilter?: { __typename?: 'UserStateBoxAnnotationFilter', clipMethod: ClipMethods } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'DistanceAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, points: Array<{ __typename?: 'Point', pointCloudId?: string | null, position: { __typename?: 'Position', x: number, y: number, z: number } }>, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'Plane', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, normal: { __typename?: 'Position', x: number, y: number, z: number }, annotationFilter?: { __typename?: 'UserStatePlaneFilter', clipMethod: ClipMethods, tolerance: number } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'PointAnnotation', pointCloudId?: string | null, classification?: number | null, intensity?: number | null, identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, color?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'PointCluster', annotationClass?: number | null, identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, segments: Array<{ __typename?: 'Segment', pointcloudId: string, segmentId: number }>, annotationFilter?: { __typename?: 'UserStatePointClusterFilter', clipMethod: ClipMethods } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null }>, groups: Array<{ __typename?: 'AnnotationGroup', identifier: string, name: string }>, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<{ __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null } | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }> }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> }, calculations: Array<{ __typename?: 'ProjectionCalculation', isOutDated: boolean } | { __typename?: 'VolumeCalculation', isOutDated: boolean }>, pointClouds: Array<{ __typename?: 'PointCloud', id: string, displayName: string }> } };

export type ProjectAddActionMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  action: InputProjectAction;
}>;


export type ProjectAddActionMutation = { __typename?: 'Mutation', projectAddAction: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'AreaAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, points: Array<{ __typename?: 'Point', pointCloudId?: string | null, position: { __typename?: 'Position', x: number, y: number, z: number } }>, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'BoxAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, scale: { __typename?: 'Position', x: number, y: number, z: number }, rotation: { __typename?: 'Position', x: number, y: number, z: number }, annotationFilter?: { __typename?: 'UserStateBoxAnnotationFilter', clipMethod: ClipMethods } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'DistanceAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, points: Array<{ __typename?: 'Point', pointCloudId?: string | null, position: { __typename?: 'Position', x: number, y: number, z: number } }>, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'Plane', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, normal: { __typename?: 'Position', x: number, y: number, z: number }, annotationFilter?: { __typename?: 'UserStatePlaneFilter', clipMethod: ClipMethods, tolerance: number } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'PointAnnotation', pointCloudId?: string | null, classification?: number | null, intensity?: number | null, identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, color?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'PointCluster', annotationClass?: number | null, identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, segments: Array<{ __typename?: 'Segment', pointcloudId: string, segmentId: number }>, annotationFilter?: { __typename?: 'UserStatePointClusterFilter', clipMethod: ClipMethods } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null }>, groups: Array<{ __typename?: 'AnnotationGroup', identifier: string, name: string }>, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<{ __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null } | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }> }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> }, calculations: Array<{ __typename?: 'ProjectionCalculation', isOutDated: boolean } | { __typename?: 'VolumeCalculation', isOutDated: boolean }>, pointClouds: Array<{ __typename?: 'PointCloud', id: string, displayName: string }> } };

export type ProjectToggleObjectVisibilityMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  identifiers: Array<Scalars['String']['input']> | Scalars['String']['input'];
  visible: Scalars['Boolean']['input'];
}>;


export type ProjectToggleObjectVisibilityMutation = { __typename?: 'Mutation', projectToggleObjectVisibility: { __typename?: 'Project', id: string, mapVisible: boolean, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'AreaAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, points: Array<{ __typename?: 'Point', pointCloudId?: string | null, position: { __typename?: 'Position', x: number, y: number, z: number } }>, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'BoxAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, scale: { __typename?: 'Position', x: number, y: number, z: number }, rotation: { __typename?: 'Position', x: number, y: number, z: number }, annotationFilter?: { __typename?: 'UserStateBoxAnnotationFilter', clipMethod: ClipMethods } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'DistanceAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, points: Array<{ __typename?: 'Point', pointCloudId?: string | null, position: { __typename?: 'Position', x: number, y: number, z: number } }>, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'Plane', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, normal: { __typename?: 'Position', x: number, y: number, z: number }, annotationFilter?: { __typename?: 'UserStatePlaneFilter', clipMethod: ClipMethods, tolerance: number } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'PointAnnotation', pointCloudId?: string | null, classification?: number | null, intensity?: number | null, identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, color?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'PointCluster', annotationClass?: number | null, identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, segments: Array<{ __typename?: 'Segment', pointcloudId: string, segmentId: number }>, annotationFilter?: { __typename?: 'UserStatePointClusterFilter', clipMethod: ClipMethods } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null }>, groups: Array<{ __typename?: 'AnnotationGroup', identifier: string, name: string }>, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<{ __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null } | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }> }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> }, pointClouds: Array<{ __typename?: 'PointCloud', id: string, visible: boolean }> } };

export type ProjectToggleObjectLabelVisibilityMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  identifiers: Array<Scalars['String']['input']> | Scalars['String']['input'];
  visible: Scalars['Boolean']['input'];
  label: AnnotationLabels;
}>;


export type ProjectToggleObjectLabelVisibilityMutation = { __typename?: 'Mutation', projectToggleObjectLabelVisibility: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'AreaAnnotation', identifier: string, hiddenLabels: Array<AnnotationLabels> } | { __typename?: 'BoxAnnotation', identifier: string, hiddenLabels: Array<AnnotationLabels> } | { __typename?: 'DistanceAnnotation', identifier: string, hiddenLabels: Array<AnnotationLabels> } | { __typename?: 'Plane', identifier: string, hiddenLabels: Array<AnnotationLabels> } | { __typename?: 'PointAnnotation', identifier: string, hiddenLabels: Array<AnnotationLabels> } | { __typename?: 'PointCluster', identifier: string, hiddenLabels: Array<AnnotationLabels> }> } } };

export type ProjectUpdateClippingMethodMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  annotationIdentifiers: Array<Scalars['String']['input']> | Scalars['String']['input'];
  clipMethod: ClipMethods;
}>;


export type ProjectUpdateClippingMethodMutation = { __typename?: 'Mutation', projectUpdateClippingMethod: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'AreaAnnotation' } | { __typename?: 'BoxAnnotation', annotationFilter?: { __typename?: 'UserStateBoxAnnotationFilter', clipMethod: ClipMethods } | null } | { __typename?: 'DistanceAnnotation' } | { __typename?: 'Plane', annotationFilter?: { __typename?: 'UserStatePlaneFilter', clipMethod: ClipMethods } | null } | { __typename?: 'PointAnnotation' } | { __typename?: 'PointCluster', annotationFilter?: { __typename?: 'UserStatePointClusterFilter', clipMethod: ClipMethods } | null }> } } };

export type ProjectUpdateClippingToleranceMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  annotationIdentifiers: Array<Scalars['String']['input']> | Scalars['String']['input'];
  tolerance: Scalars['Float']['input'];
}>;


export type ProjectUpdateClippingToleranceMutation = { __typename?: 'Mutation', projectUpdateClippingTolerance: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'AreaAnnotation' } | { __typename?: 'BoxAnnotation' } | { __typename?: 'DistanceAnnotation' } | { __typename?: 'Plane', annotationFilter?: { __typename?: 'UserStatePlaneFilter', tolerance: number } | null } | { __typename?: 'PointAnnotation' } | { __typename?: 'PointCluster' }> } } };

export type ProjectVolumeCalculateMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  pointCloudId: Scalars['ID']['input'];
  annotationIdentifier: Scalars['String']['input'];
  referenceHeight?: InputMaybe<Scalars['Float']['input']>;
  baseSurface: CalculationBaseSurfaces;
  classificationFilters?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  heightFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  intensityFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  resolutionFilter?: InputMaybe<Scalars['Int']['input']>;
  clippingFilter?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProjectVolumeCalculateMutation = { __typename?: 'Mutation', projectVolumeCalculate: { __typename?: 'Project', id: string, calculations: Array<{ __typename?: 'ProjectionCalculation', profileGroupIdentifier: string, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'ProjectionCalculationResult', projection: Array<{ __typename?: 'DistanceProjection', distance: number, height: number }> } | null, paramInfo: { __typename?: 'ProjectionCalculationParamInfo', heightFilters?: Array<number> | null, intensityFilters?: Array<number> | null, classificationFilters?: Array<number> | null, resolutionFilter?: number | null, clippingFilter?: number | null } } | { __typename?: 'VolumeCalculation', baseSurface: CalculationBaseSurfaces, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'VolumeCalculationResult', volume: number, area: number, volumePositive: number, volumeNegative: number } | null, paramInfo: { __typename?: 'VolumeCalculationParamInfo', referenceHeight?: number | null, heightFilters?: Array<number> | null, intensityFilters?: Array<number> | null, classificationFilters?: Array<number> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }> } };

export type ProjectExportPointcloudMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  pointCloudId: Scalars['ID']['input'];
  fileType?: InputMaybe<FileTypes>;
  heightFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  intensityFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  classificationFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  resolutionFilter?: InputMaybe<Scalars['Int']['input']>;
  clippingFilter?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProjectExportPointcloudMutation = { __typename?: 'Mutation', projectExportPointcloud: { __typename?: 'Project', id: string, exports: Array<{ __typename?: 'Export', exportId: string, status: GeneralStatus, type: string, createdAt: any, paramInfo: { __typename?: 'ExportParamInfo', fileType: FileTypes, heightFilters?: Array<number> | null, classificationFilters?: Array<number> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }> } };

export type ProjectProjectionCalculateMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  pointCloudId: Scalars['ID']['input'];
  annotationIdentifier: Scalars['String']['input'];
  profileGroupIdentifier: Scalars['String']['input'];
  classificationFilters?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  heightFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  intensityFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  resolutionFilter?: InputMaybe<Scalars['Int']['input']>;
  clippingFilter?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProjectProjectionCalculateMutation = { __typename?: 'Mutation', projectProjectionCalculate: { __typename?: 'Project', id: string, calculations: Array<{ __typename?: 'ProjectionCalculation', profileGroupIdentifier: string, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'ProjectionCalculationResult', projection: Array<{ __typename?: 'DistanceProjection', distance: number, height: number }> } | null, paramInfo: { __typename?: 'ProjectionCalculationParamInfo', heightFilters?: Array<number> | null, intensityFilters?: Array<number> | null, classificationFilters?: Array<number> | null, resolutionFilter?: number | null, clippingFilter?: number | null } } | { __typename?: 'VolumeCalculation', baseSurface: CalculationBaseSurfaces, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'VolumeCalculationResult', volume: number, area: number, volumePositive: number, volumeNegative: number } | null, paramInfo: { __typename?: 'VolumeCalculationParamInfo', referenceHeight?: number | null, heightFilters?: Array<number> | null, intensityFilters?: Array<number> | null, classificationFilters?: Array<number> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }> } };

export type ProjectDeleteCalculationMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  calculationId: Scalars['ID']['input'];
}>;


export type ProjectDeleteCalculationMutation = { __typename?: 'Mutation', projectDeleteCalculation: { __typename?: 'Project', id: string, calculations: Array<{ __typename?: 'ProjectionCalculation', profileGroupIdentifier: string, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'ProjectionCalculationResult', projection: Array<{ __typename?: 'DistanceProjection', distance: number, height: number }> } | null, paramInfo: { __typename?: 'ProjectionCalculationParamInfo', heightFilters?: Array<number> | null, intensityFilters?: Array<number> | null, classificationFilters?: Array<number> | null, resolutionFilter?: number | null, clippingFilter?: number | null } } | { __typename?: 'VolumeCalculation', baseSurface: CalculationBaseSurfaces, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'VolumeCalculationResult', volume: number, area: number, volumePositive: number, volumeNegative: number } | null, paramInfo: { __typename?: 'VolumeCalculationParamInfo', referenceHeight?: number | null, heightFilters?: Array<number> | null, intensityFilters?: Array<number> | null, classificationFilters?: Array<number> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }> } };

export type ProjectGenerateClassificationsMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  cloudName: Scalars['String']['input'];
}>;


export type ProjectGenerateClassificationsMutation = { __typename?: 'Mutation', projectGenerateClassifications: { __typename?: 'Project', id: string, pointClouds: Array<{ __typename?: 'PointCloud', hasClassifications: boolean }> } };

export type ProjectPointCloudDeleteMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  pointCloudId: Scalars['ID']['input'];
}>;


export type ProjectPointCloudDeleteMutation = { __typename?: 'Mutation', projectPointCloudDelete: { __typename?: 'Project', id: string, name: string, description?: string | null, uploadStatus: UploadStatus, mapVisible: boolean, previewUrl?: string | null, assignee?: { __typename?: 'User', id: string, name: string } | null, pointClouds: Array<{ __typename?: 'PointCloud', id: string, hasClassifications: boolean, uploadStatus: UploadStatus, cloudName: string, availableClasses: Array<number>, visible: boolean, displayName: string, pointCount?: any | null }>, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'AreaAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, points: Array<{ __typename?: 'Point', pointCloudId?: string | null, position: { __typename?: 'Position', x: number, y: number, z: number } }>, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'BoxAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, scale: { __typename?: 'Position', x: number, y: number, z: number }, rotation: { __typename?: 'Position', x: number, y: number, z: number }, annotationFilter?: { __typename?: 'UserStateBoxAnnotationFilter', clipMethod: ClipMethods } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'DistanceAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, points: Array<{ __typename?: 'Point', pointCloudId?: string | null, position: { __typename?: 'Position', x: number, y: number, z: number } }>, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'Plane', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, normal: { __typename?: 'Position', x: number, y: number, z: number }, annotationFilter?: { __typename?: 'UserStatePlaneFilter', clipMethod: ClipMethods, tolerance: number } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'PointAnnotation', pointCloudId?: string | null, classification?: number | null, intensity?: number | null, identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, color?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'PointCluster', annotationClass?: number | null, identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, segments: Array<{ __typename?: 'Segment', pointcloudId: string, segmentId: number }>, annotationFilter?: { __typename?: 'UserStatePointClusterFilter', clipMethod: ClipMethods } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null }>, groups: Array<{ __typename?: 'AnnotationGroup', identifier: string, name: string }>, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<{ __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null } | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }> }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> }, settings?: { __typename?: 'ProjectSettings', projectionSystem?: string | null } | null, calculations: Array<{ __typename?: 'ProjectionCalculation', profileGroupIdentifier: string, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'ProjectionCalculationResult', projection: Array<{ __typename?: 'DistanceProjection', distance: number, height: number }> } | null, paramInfo: { __typename?: 'ProjectionCalculationParamInfo', heightFilters?: Array<number> | null, intensityFilters?: Array<number> | null, classificationFilters?: Array<number> | null, resolutionFilter?: number | null, clippingFilter?: number | null } } | { __typename?: 'VolumeCalculation', baseSurface: CalculationBaseSurfaces, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'VolumeCalculationResult', volume: number, area: number, volumePositive: number, volumeNegative: number } | null, paramInfo: { __typename?: 'VolumeCalculationParamInfo', referenceHeight?: number | null, heightFilters?: Array<number> | null, intensityFilters?: Array<number> | null, classificationFilters?: Array<number> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }>, exports: Array<{ __typename?: 'Export', exportId: string, status: GeneralStatus, type: string, createdAt: any, paramInfo: { __typename?: 'ExportParamInfo', fileType: FileTypes, heightFilters?: Array<number> | null, classificationFilters?: Array<number> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }>, comments?: Array<{ __typename?: 'Comment', id: string, comment: string, referenceIdentifier: string, createdAt: any, updatedAt?: any | null, user: { __typename?: 'User', id: string, name: string } }> | null, customClasses?: Array<{ __typename?: 'CustomClass', id: string, name: string, code: number, color: { __typename?: 'Color', r: number, g: number, b: number, a: number } }> | null } };

export type PointCloudUploadStatusQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type PointCloudUploadStatusQuery = { __typename?: 'Query', projectById: { __typename?: 'Project', id: string, pointClouds: Array<{ __typename?: 'PointCloud', id: string, uploadStatus: UploadStatus }> } };

export type ProjectInitializeMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type ProjectInitializeMutation = { __typename?: 'Mutation', projectInitialize: { __typename?: 'Project', id: string } };

export type ProjectAddCommentMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  comment: Scalars['String']['input'];
  referenceIdentifier: Scalars['String']['input'];
}>;


export type ProjectAddCommentMutation = { __typename?: 'Mutation', projectAddComment: { __typename?: 'Project', comments?: Array<{ __typename?: 'Comment', id: string }> | null } };

export type ProjectDeleteCommentMutationVariables = Exact<{
  commentId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type ProjectDeleteCommentMutation = { __typename?: 'Mutation', projectDeleteComment: { __typename?: 'Project', id: string, comments?: Array<{ __typename?: 'Comment', id: string }> | null } };

export type ProjectEditCommentMutationVariables = Exact<{
  commentId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  newComment: Scalars['String']['input'];
}>;


export type ProjectEditCommentMutation = { __typename?: 'Mutation', projectEditComment: { __typename?: 'Project', id: string, comments?: Array<{ __typename: 'Comment', id: string, comment: string }> | null } };

export type ProjectAddCustomClassMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  color: InputColor;
}>;


export type ProjectAddCustomClassMutation = { __typename?: 'Mutation', projectAddCustomClass: { __typename?: 'Project', id: string, customClasses?: Array<{ __typename?: 'CustomClass', id: string, name: string, code: number, color: { __typename?: 'Color', r: number, g: number, b: number, a: number } }> | null } };

export type ProjectDeleteCustomClassMutationVariables = Exact<{
  customClassId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type ProjectDeleteCustomClassMutation = { __typename?: 'Mutation', projectDeleteCustomClass: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'AreaAnnotation' } | { __typename?: 'BoxAnnotation' } | { __typename?: 'DistanceAnnotation' } | { __typename?: 'Plane' } | { __typename?: 'PointAnnotation' } | { __typename?: 'PointCluster', annotationClass?: number | null }> }, customClasses?: Array<{ __typename?: 'CustomClass', id: string }> | null } };

export type ProjectEditCustomClassNameMutationVariables = Exact<{
  customClassId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  newName: Scalars['String']['input'];
}>;


export type ProjectEditCustomClassNameMutation = { __typename?: 'Mutation', projectEditCustomClassName: { __typename?: 'Project', id: string, customClasses?: Array<{ __typename?: 'CustomClass', id: string, name: string }> | null } };

export type ProjectEditCustomClassColorMutationVariables = Exact<{
  customClassId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  newColor: InputColor;
}>;


export type ProjectEditCustomClassColorMutation = { __typename?: 'Mutation', projectEditCustomClassColor: { __typename?: 'Project', id: string, customClasses?: Array<{ __typename?: 'CustomClass', id: string, color: { __typename?: 'Color', r: number, g: number, b: number, a: number } }> | null } };

export type ProjectEditAnnotationColorMutationVariables = Exact<{
  annotationIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  newColor: InputColor;
}>;


export type ProjectEditAnnotationColorMutation = { __typename?: 'Mutation', projectEditAnnotationColor: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'AreaAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, points: Array<{ __typename?: 'Point', pointCloudId?: string | null, position: { __typename?: 'Position', x: number, y: number, z: number } }>, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'BoxAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, scale: { __typename?: 'Position', x: number, y: number, z: number }, rotation: { __typename?: 'Position', x: number, y: number, z: number }, annotationFilter?: { __typename?: 'UserStateBoxAnnotationFilter', clipMethod: ClipMethods } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'DistanceAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, points: Array<{ __typename?: 'Point', pointCloudId?: string | null, position: { __typename?: 'Position', x: number, y: number, z: number } }>, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'Plane', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, normal: { __typename?: 'Position', x: number, y: number, z: number }, annotationFilter?: { __typename?: 'UserStatePlaneFilter', clipMethod: ClipMethods, tolerance: number } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'PointAnnotation', pointCloudId?: string | null, classification?: number | null, intensity?: number | null, identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, color?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'PointCluster', annotationClass?: number | null, identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, segments: Array<{ __typename?: 'Segment', pointcloudId: string, segmentId: number }>, annotationFilter?: { __typename?: 'UserStatePointClusterFilter', clipMethod: ClipMethods } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null }>, groups: Array<{ __typename?: 'AnnotationGroup', identifier: string, name: string }>, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<{ __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null } | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }> }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> } } };

export type ProjectEditAnnotationClassMutationVariables = Exact<{
  annotationIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  newClass: Scalars['Int']['input'];
}>;


export type ProjectEditAnnotationClassMutation = { __typename?: 'Mutation', projectEditAnnotationClass: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'AreaAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, points: Array<{ __typename?: 'Point', pointCloudId?: string | null, position: { __typename?: 'Position', x: number, y: number, z: number } }>, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'BoxAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, scale: { __typename?: 'Position', x: number, y: number, z: number }, rotation: { __typename?: 'Position', x: number, y: number, z: number }, annotationFilter?: { __typename?: 'UserStateBoxAnnotationFilter', clipMethod: ClipMethods } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'DistanceAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, points: Array<{ __typename?: 'Point', pointCloudId?: string | null, position: { __typename?: 'Position', x: number, y: number, z: number } }>, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'Plane', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, normal: { __typename?: 'Position', x: number, y: number, z: number }, annotationFilter?: { __typename?: 'UserStatePlaneFilter', clipMethod: ClipMethods, tolerance: number } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'PointAnnotation', pointCloudId?: string | null, classification?: number | null, intensity?: number | null, identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, color?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'PointCluster', annotationClass?: number | null, identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, segments: Array<{ __typename?: 'Segment', pointcloudId: string, segmentId: number }>, annotationFilter?: { __typename?: 'UserStatePointClusterFilter', clipMethod: ClipMethods } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null }>, groups: Array<{ __typename?: 'AnnotationGroup', identifier: string, name: string }>, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<{ __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null } | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }> }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> }, pointClouds: Array<{ __typename?: 'PointCloud', id: string, availableClasses: Array<number> }> } };

export type ProjectEditLayerElevationMutationVariables = Exact<{
  layerIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  newElevation: Scalars['Float']['input'];
}>;


export type ProjectEditLayerElevationMutation = { __typename?: 'Mutation', projectEditLayerElevation: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'AreaAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, points: Array<{ __typename?: 'Point', pointCloudId?: string | null, position: { __typename?: 'Position', x: number, y: number, z: number } }>, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'BoxAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, scale: { __typename?: 'Position', x: number, y: number, z: number }, rotation: { __typename?: 'Position', x: number, y: number, z: number }, annotationFilter?: { __typename?: 'UserStateBoxAnnotationFilter', clipMethod: ClipMethods } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'DistanceAnnotation', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, points: Array<{ __typename?: 'Point', pointCloudId?: string | null, position: { __typename?: 'Position', x: number, y: number, z: number } }>, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'Plane', identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, normal: { __typename?: 'Position', x: number, y: number, z: number }, annotationFilter?: { __typename?: 'UserStatePlaneFilter', clipMethod: ClipMethods, tolerance: number } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'PointAnnotation', pointCloudId?: string | null, classification?: number | null, intensity?: number | null, identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, position: { __typename?: 'Position', x: number, y: number, z: number }, color?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null } | { __typename?: 'PointCluster', annotationClass?: number | null, identifier: string, groupIdentifier?: string | null, type: any, name: string, visible: boolean, hiddenLabels: Array<AnnotationLabels>, segments: Array<{ __typename?: 'Segment', pointcloudId: string, segmentId: number }>, annotationFilter?: { __typename?: 'UserStatePointClusterFilter', clipMethod: ClipMethods } | null, annotationColor?: { __typename?: 'Color', r: number, g: number, b: number, a: number } | null }>, groups: Array<{ __typename?: 'AnnotationGroup', identifier: string, name: string }>, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<{ __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null } | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }> }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> } } };

export type ProjectAddGuestMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
}>;


export type ProjectAddGuestMutation = { __typename?: 'Mutation', projectAddGuest: { __typename?: 'User', id: string } };

export type ProjectRemoveGuestMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type ProjectRemoveGuestMutation = { __typename?: 'Mutation', projectRemoveGuest: { __typename?: 'User', id: string } };

export type ProjectRequestDownloadTokenQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectRequestDownloadTokenQuery = { __typename?: 'Query', projectRequestDownloadToken: string };

export type SuperadminOrganisationFragment = { __typename?: 'Organisation', id: string, name: string, createdAt: any, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalMonthlyPointCount: any, totalPointCountLeft: number, totalMonthlyPointCountLeft: number, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, endDate?: any | null, customLimits?: { __typename?: 'SubscriptionCustomLimits', maxPointCount?: number | null, maxMonthlyPointCount?: number | null, maxUploadsInProgress?: number | null, trialEndDate?: any | null } | null, limits: { __typename?: 'SubscriptionLimits', maxPointCount: number, maxMonthlyPointCount: number, maxUploadsInProgress: number } } };

export type SuperadminOrganisationsQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperadminOrganisationsQuery = { __typename?: 'Query', superadminOrganisations: Array<{ __typename?: 'Organisation', id: string, name: string, createdAt: any, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalMonthlyPointCount: any, totalPointCountLeft: number, totalMonthlyPointCountLeft: number, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, endDate?: any | null, customLimits?: { __typename?: 'SubscriptionCustomLimits', maxPointCount?: number | null, maxMonthlyPointCount?: number | null, maxUploadsInProgress?: number | null, trialEndDate?: any | null } | null, limits: { __typename?: 'SubscriptionLimits', maxPointCount: number, maxMonthlyPointCount: number, maxUploadsInProgress: number } } }> };

export type SuperadminUpdateTrialDateMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  endDate: Scalars['Date']['input'];
}>;


export type SuperadminUpdateTrialDateMutation = { __typename?: 'Mutation', superadminUpdateTrialDate: { __typename?: 'Organisation', id: string, name: string, createdAt: any, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalMonthlyPointCount: any, totalPointCountLeft: number, totalMonthlyPointCountLeft: number, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, endDate?: any | null, customLimits?: { __typename?: 'SubscriptionCustomLimits', maxPointCount?: number | null, maxMonthlyPointCount?: number | null, maxUploadsInProgress?: number | null, trialEndDate?: any | null } | null, limits: { __typename?: 'SubscriptionLimits', maxPointCount: number, maxMonthlyPointCount: number, maxUploadsInProgress: number } } } };

export type SuperadminUpdatePlanMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  customLimits: InputSubscriptionCustomLimits;
  subscriptionType: SubscriptionType;
  endDate: Scalars['Date']['input'];
}>;


export type SuperadminUpdatePlanMutation = { __typename?: 'Mutation', superadminUpdatePlan: { __typename?: 'Organisation', id: string, name: string, createdAt: any, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalMonthlyPointCount: any, totalPointCountLeft: number, totalMonthlyPointCountLeft: number, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, endDate?: any | null, customLimits?: { __typename?: 'SubscriptionCustomLimits', maxPointCount?: number | null, maxMonthlyPointCount?: number | null, maxUploadsInProgress?: number | null, trialEndDate?: any | null } | null, limits: { __typename?: 'SubscriptionLimits', maxPointCount: number, maxMonthlyPointCount: number, maxUploadsInProgress: number } } } };

export type CurrentUserFragment = { __typename?: 'User', id: string, name: string, email: string, firstName: string, lastName: string, isSuperAdmin?: boolean | null, favoriteProjectIds: Array<string>, measurementUnit: MeasurementUnits, dateFormat: DateFormats, darkMode?: boolean | null, language: Language, rolesByOrganisation: Array<{ __typename?: 'UserRoleOrganisation', organisationId: string, role: UserRole }>, organisations: Array<{ __typename?: 'Organisation', id: string, myPermissions: Array<Permissions>, prohibitedActions: Array<PossibleActions>, projects: Array<{ __typename?: 'Project', id: string }>, subscription: { __typename?: 'OrganisationSubscription', isFreeTrial: boolean, endDate?: any | null, canAddPointClouds: boolean, canAddSimultaneousUploads: boolean, simultaneousUploadsLeft: number } }> };

export type UserFragment = { __typename?: 'User', id: string, name: string, role: UserRole, joinDate?: any | null, status?: UserStatus | null, allowedProjectIds: Array<string>, email: string, allowedProjects: Array<{ __typename?: 'Project', id: string, name: string }> };

export type UsersQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type UsersQuery = { __typename?: 'Query', usersByOrganisationId: Array<{ __typename?: 'User', id: string, name: string, role: UserRole, joinDate?: any | null, status?: UserStatus | null, allowedProjectIds: Array<string>, email: string, allowedProjects: Array<{ __typename?: 'Project', id: string, name: string }> }> };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, name: string, email: string, firstName: string, lastName: string, isSuperAdmin?: boolean | null, favoriteProjectIds: Array<string>, measurementUnit: MeasurementUnits, dateFormat: DateFormats, darkMode?: boolean | null, language: Language, rolesByOrganisation: Array<{ __typename?: 'UserRoleOrganisation', organisationId: string, role: UserRole }>, organisations: Array<{ __typename?: 'Organisation', id: string, myPermissions: Array<Permissions>, prohibitedActions: Array<PossibleActions>, projects: Array<{ __typename?: 'Project', id: string }>, subscription: { __typename?: 'OrganisationSubscription', isFreeTrial: boolean, endDate?: any | null, canAddPointClouds: boolean, canAddSimultaneousUploads: boolean, simultaneousUploadsLeft: number } }> } | null };

export type UserAddToOrganisationMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  role: UserRole;
}>;


export type UserAddToOrganisationMutation = { __typename?: 'Mutation', userAddToOrganisation: { __typename?: 'User', id: string, name: string, role: UserRole, joinDate?: any | null, status?: UserStatus | null, allowedProjectIds: Array<string>, email: string, allowedProjects: Array<{ __typename?: 'Project', id: string, name: string }> } };

export type UserResendInvitationMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type UserResendInvitationMutation = { __typename?: 'Mutation', userResendInvitation: { __typename?: 'User', id: string, name: string, role: UserRole, joinDate?: any | null, status?: UserStatus | null, allowedProjectIds: Array<string>, email: string, allowedProjects: Array<{ __typename?: 'Project', id: string, name: string }> } };

export type UserDeleteFromOrganisationMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type UserDeleteFromOrganisationMutation = { __typename?: 'Mutation', userDeleteFromOrganisation: boolean };

export type UserChangeRoleMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  role: UserRole;
}>;


export type UserChangeRoleMutation = { __typename?: 'Mutation', userChangeRole: { __typename?: 'User', id: string, name: string, role: UserRole, joinDate?: any | null, status?: UserStatus | null, allowedProjectIds: Array<string>, email: string, allowedProjects: Array<{ __typename?: 'Project', id: string, name: string }> } };

export type UserDisableMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type UserDisableMutation = { __typename?: 'Mutation', userDisable: { __typename?: 'User', id: string, name: string, role: UserRole, joinDate?: any | null, status?: UserStatus | null, allowedProjectIds: Array<string>, email: string, allowedProjects: Array<{ __typename?: 'Project', id: string, name: string }> } };

export type UserEnableMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type UserEnableMutation = { __typename?: 'Mutation', userEnable: { __typename?: 'User', id: string, name: string, role: UserRole, joinDate?: any | null, status?: UserStatus | null, allowedProjectIds: Array<string>, email: string, allowedProjects: Array<{ __typename?: 'Project', id: string, name: string }> } };

export type UserInviteInfoQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type UserInviteInfoQuery = { __typename?: 'Query', userInviteInfo: { __typename?: 'InviteInfo', email: string, organisationName: string, isNewUser: boolean, inviteId?: string | null } };

export type UserAcceptInvitationMutationVariables = Exact<{
  inviteId: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
  user?: InputMaybe<InputUser>;
}>;


export type UserAcceptInvitationMutation = { __typename?: 'Mutation', userAcceptInvitation?: boolean | null };

export type UserUpdateMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type UserUpdateMutation = { __typename?: 'Mutation', userUpdate: { __typename?: 'User', id: string, name: string, email: string, firstName: string, lastName: string, isSuperAdmin?: boolean | null, favoriteProjectIds: Array<string>, measurementUnit: MeasurementUnits, dateFormat: DateFormats, darkMode?: boolean | null, language: Language, rolesByOrganisation: Array<{ __typename?: 'UserRoleOrganisation', organisationId: string, role: UserRole }>, organisations: Array<{ __typename?: 'Organisation', id: string, myPermissions: Array<Permissions>, prohibitedActions: Array<PossibleActions>, projects: Array<{ __typename?: 'Project', id: string }>, subscription: { __typename?: 'OrganisationSubscription', isFreeTrial: boolean, endDate?: any | null, canAddPointClouds: boolean, canAddSimultaneousUploads: boolean, simultaneousUploadsLeft: number } }> } };

export type UserUpdateFavoritesMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  inFavorites: Scalars['Boolean']['input'];
}>;


export type UserUpdateFavoritesMutation = { __typename?: 'Mutation', userUpdateFavorites: { __typename?: 'User', id: string, favoriteProjectIds: Array<string> } };

export type UserChangeUnitsMutationVariables = Exact<{
  inUnit: MeasurementUnits;
}>;


export type UserChangeUnitsMutation = { __typename?: 'Mutation', userChangeUnits: { __typename?: 'User', id: string, measurementUnit: MeasurementUnits } };

export type UserChangeDateFormatMutationVariables = Exact<{
  inFormat: DateFormats;
}>;


export type UserChangeDateFormatMutation = { __typename?: 'Mutation', userChangeDateFormat: { __typename?: 'User', id: string, dateFormat: DateFormats } };

export type UserChangeDarkModeMutationVariables = Exact<{
  inDarkMode: Scalars['Boolean']['input'];
}>;


export type UserChangeDarkModeMutation = { __typename?: 'Mutation', userChangeDarkMode: { __typename?: 'User', id: string, darkMode?: boolean | null } };

export type UserChangeLanguageMutationVariables = Exact<{
  language: Language;
}>;


export type UserChangeLanguageMutation = { __typename?: 'Mutation', userChangeLanguage: { __typename?: 'User', id: string, language: Language } };

export const ApiKeyFragmentDoc = gql`
    fragment ApiKey on ApiKey {
  name
  apiKey
  ... on ApiKeyWithLicenseKey {
    licenseKey
  }
}
    `;
export const PaymentDetailsFragmentDoc = gql`
    fragment PaymentDetails on PaymentDetails {
  address {
    postalCode
    country
    line1
    line2
    city
  }
  name
  VAT
  email
  paymentType
  cardBrand
  cardLast4
}
    `;
export const OrganisationsFragmentDoc = gql`
    fragment Organisations on Organisation {
  id
  name
  usersAmount
  myPermissions
  stats {
    totalPointCount
    totalMonthlyPointCount
    totalPointCountLeft
    totalMonthlyPointCountLeft
    totalUsers
    totalProjects
  }
  isRootOrganisation
  subscription {
    type
    isFreeTrial
    endDate
    canAddPointClouds
    canAddSimultaneousUploads
    simultaneousUploadsLeft
  }
  prohibitedActions
  createdAt
}
    `;
export const ProjectsFragmentDoc = gql`
    fragment Projects on Project {
  id
  name
  description
  uploadStatus
  isInitializing
  assignee {
    id
    name
  }
  pointClouds {
    id
    pointCount
  }
  previewUrl
}
    `;
export const ProjectStateFragmentDoc = gql`
    fragment ProjectState on ProjectState {
  annotations {
    identifier
    groupIdentifier
    type
    name
    visible
    hiddenLabels
    annotationColor {
      r
      g
      b
      a
    }
    ... on PointAnnotation {
      position {
        x
        y
        z
      }
      color {
        r
        g
        b
        a
      }
      pointCloudId
      classification
      intensity
    }
    ... on DistanceAnnotation {
      points {
        position {
          x
          y
          z
        }
        pointCloudId
      }
    }
    ... on AreaAnnotation {
      points {
        position {
          x
          y
          z
        }
        pointCloudId
      }
    }
    ... on BoxAnnotation {
      position {
        x
        y
        z
      }
      scale {
        x
        y
        z
      }
      rotation {
        x
        y
        z
      }
      annotationFilter {
        clipMethod
      }
    }
    ... on PointCluster {
      segments {
        pointcloudId
        segmentId
      }
      annotationFilter {
        clipMethod
      }
      annotationClass
    }
    ... on Plane {
      position {
        x
        y
        z
      }
      normal {
        x
        y
        z
      }
      annotationFilter {
        clipMethod
        tolerance
      }
    }
  }
  groups {
    identifier
    name
  }
  orderedIdentifiers {
    identifier
    index
  }
  wmsLayerOrderedIdentifiers {
    identifier
    index
  }
  orthophotoLayerOrderedIdentifiers {
    identifier
    index
  }
  cadLayers {
    identifier
    name
    fileUrl
    fileName
    visibleState {
      ... on CadLayerVisibleStateDelete {
        index
        isGroup
        subIndex
      }
      ... on CadLayerVisibleStateHidden {
        index
        isGroup
        isLayer
        layerIdentifier
        subIndex
        visible
        userId
      }
    }
  }
  wmsLayers {
    identifier
    type
    name
    url
    username
    password
    layerName
    visible
  }
  orthophotoLayers {
    identifier
    name
    visible
    url
    elevation
  }
}
    `;
export const CalculationFragmentDoc = gql`
    fragment Calculation on Calculation {
  id
  status
  annotationIdentifier
  pointCloudIdentifier
  ... on VolumeCalculation {
    baseSurface
    result {
      volume
      area
      volumePositive
      volumeNegative
    }
    paramInfo {
      referenceHeight
      heightFilters
      intensityFilters
      classificationFilters
      resolutionFilter
      clippingFilter
    }
    isOutDated
  }
  ... on ProjectionCalculation {
    profileGroupIdentifier
    result {
      projection {
        distance
        height
      }
    }
    paramInfo {
      heightFilters
      intensityFilters
      classificationFilters
      resolutionFilter
      clippingFilter
    }
    isOutDated
  }
}
    `;
export const ExportFragmentDoc = gql`
    fragment Export on Export {
  exportId
  status
  type
  createdAt
  paramInfo {
    fileType
    heightFilters
    classificationFilters
    resolutionFilter
    clippingFilter
  }
}
    `;
export const ProjectFragmentDoc = gql`
    fragment Project on Project {
  id
  name
  description
  uploadStatus
  assignee {
    id
    name
  }
  pointClouds {
    id
    hasClassifications
    uploadStatus
    cloudName
    availableClasses
    visible
    displayName
    pointCount
  }
  state {
    ...ProjectState
  }
  settings {
    projectionSystem
  }
  calculations {
    ...Calculation
  }
  exports {
    ...Export
  }
  mapVisible
  comments {
    id
    comment
    user {
      id
      name
    }
    referenceIdentifier
    createdAt
    updatedAt
  }
  customClasses {
    id
    name
    color {
      r
      g
      b
      a
    }
    code
  }
  previewUrl
}
    ${ProjectStateFragmentDoc}
${CalculationFragmentDoc}
${ExportFragmentDoc}`;
export const SuperadminOrganisationFragmentDoc = gql`
    fragment SuperadminOrganisation on Organisation {
  id
  name
  createdAt
  stats {
    totalPointCount
    totalMonthlyPointCount
    totalPointCountLeft
    totalMonthlyPointCountLeft
    totalUsers
    totalProjects
  }
  subscription {
    type
    endDate
    customLimits {
      maxPointCount
      maxMonthlyPointCount
      maxUploadsInProgress
      trialEndDate
    }
    limits {
      maxPointCount
      maxMonthlyPointCount
      maxUploadsInProgress
    }
  }
}
    `;
export const CurrentUserFragmentDoc = gql`
    fragment CurrentUser on User {
  id
  name
  email
  firstName
  lastName
  isSuperAdmin
  rolesByOrganisation {
    organisationId
    role
  }
  organisations {
    id
    myPermissions
    projects {
      id
    }
    subscription {
      isFreeTrial
      endDate
      canAddPointClouds
      canAddSimultaneousUploads
      simultaneousUploadsLeft
    }
    prohibitedActions
  }
  favoriteProjectIds
  measurementUnit
  dateFormat
  darkMode
  language
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  name
  role(organisationId: $organisationId)
  joinDate(organisationId: $organisationId)
  status(organisationId: $organisationId)
  status(organisationId: $organisationId)
  allowedProjectIds(organisationId: $organisationId)
  allowedProjects(organisationId: $organisationId) {
    id
    name
  }
  name
  email
}
    `;
export const CreateApiKeyDocument = gql`
    mutation createApiKey($organisationId: ID!, $name: String!, $keyType: APIKeyType!, $licenseKey: String) {
  createApiKey(
    organisationId: $organisationId
    name: $name
    keyType: $keyType
    licenseKey: $licenseKey
  ) {
    id
    apiKeys {
      ...ApiKey
    }
  }
}
    ${ApiKeyFragmentDoc}`;
export type CreateApiKeyMutationFn = Apollo.MutationFunction<CreateApiKeyMutation, CreateApiKeyMutationVariables>;

/**
 * __useCreateApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyMutation, { data, loading, error }] = useCreateApiKeyMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      name: // value for 'name'
 *      keyType: // value for 'keyType'
 *      licenseKey: // value for 'licenseKey'
 *   },
 * });
 */
export function useCreateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiKeyMutation, CreateApiKeyMutationVariables>(CreateApiKeyDocument, options);
      }
export type CreateApiKeyMutationHookResult = ReturnType<typeof useCreateApiKeyMutation>;
export type CreateApiKeyMutationResult = Apollo.MutationResult<CreateApiKeyMutation>;
export type CreateApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>;
export const DeleteApiKeyDocument = gql`
    mutation deleteApiKey($organisationId: ID!, $apiKey: String!) {
  deleteApiKey(organisationId: $organisationId, apiKey: $apiKey) {
    id
    apiKeys {
      ...ApiKey
    }
  }
}
    ${ApiKeyFragmentDoc}`;
export type DeleteApiKeyMutationFn = Apollo.MutationFunction<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;

/**
 * __useDeleteApiKeyMutation__
 *
 * To run a mutation, you first call `useDeleteApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApiKeyMutation, { data, loading, error }] = useDeleteApiKeyMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      apiKey: // value for 'apiKey'
 *   },
 * });
 */
export function useDeleteApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>(DeleteApiKeyDocument, options);
      }
export type DeleteApiKeyMutationHookResult = ReturnType<typeof useDeleteApiKeyMutation>;
export type DeleteApiKeyMutationResult = Apollo.MutationResult<DeleteApiKeyMutation>;
export type DeleteApiKeyMutationOptions = Apollo.BaseMutationOptions<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;
export const ApiKeysDocument = gql`
    query apiKeys($organisationId: ID!) {
  organisation: organisationById(organisationId: $organisationId) {
    id
    apiKeys {
      ...ApiKey
    }
  }
}
    ${ApiKeyFragmentDoc}`;

/**
 * __useApiKeysQuery__
 *
 * To run a query within a React component, call `useApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeysQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useApiKeysQuery(baseOptions: Apollo.QueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables> & ({ variables: ApiKeysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
      }
export function useApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
        }
export function useApiKeysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
        }
export type ApiKeysQueryHookResult = ReturnType<typeof useApiKeysQuery>;
export type ApiKeysLazyQueryHookResult = ReturnType<typeof useApiKeysLazyQuery>;
export type ApiKeysSuspenseQueryHookResult = ReturnType<typeof useApiKeysSuspenseQuery>;
export type ApiKeysQueryResult = Apollo.QueryResult<ApiKeysQuery, ApiKeysQueryVariables>;
export const BillingProductsDocument = gql`
    query billingProducts($organisationId: ID!) {
  billingProducts {
    name
    description
    prices {
      value
      currency
      period
      id
    }
    isActive(organisationId: $organisationId)
    endDate(organisationId: $organisationId)
  }
}
    `;

/**
 * __useBillingProductsQuery__
 *
 * To run a query within a React component, call `useBillingProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingProductsQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useBillingProductsQuery(baseOptions: Apollo.QueryHookOptions<BillingProductsQuery, BillingProductsQueryVariables> & ({ variables: BillingProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingProductsQuery, BillingProductsQueryVariables>(BillingProductsDocument, options);
      }
export function useBillingProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingProductsQuery, BillingProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingProductsQuery, BillingProductsQueryVariables>(BillingProductsDocument, options);
        }
export function useBillingProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingProductsQuery, BillingProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BillingProductsQuery, BillingProductsQueryVariables>(BillingProductsDocument, options);
        }
export type BillingProductsQueryHookResult = ReturnType<typeof useBillingProductsQuery>;
export type BillingProductsLazyQueryHookResult = ReturnType<typeof useBillingProductsLazyQuery>;
export type BillingProductsSuspenseQueryHookResult = ReturnType<typeof useBillingProductsSuspenseQuery>;
export type BillingProductsQueryResult = Apollo.QueryResult<BillingProductsQuery, BillingProductsQueryVariables>;
export const BillingInvoicesDocument = gql`
    query billingInvoices($organisationId: ID!) {
  billingInvoices(organisationId: $organisationId) {
    date
    description
    price {
      value
      currency
    }
    url
  }
}
    `;

/**
 * __useBillingInvoicesQuery__
 *
 * To run a query within a React component, call `useBillingInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingInvoicesQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useBillingInvoicesQuery(baseOptions: Apollo.QueryHookOptions<BillingInvoicesQuery, BillingInvoicesQueryVariables> & ({ variables: BillingInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingInvoicesQuery, BillingInvoicesQueryVariables>(BillingInvoicesDocument, options);
      }
export function useBillingInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingInvoicesQuery, BillingInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingInvoicesQuery, BillingInvoicesQueryVariables>(BillingInvoicesDocument, options);
        }
export function useBillingInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingInvoicesQuery, BillingInvoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BillingInvoicesQuery, BillingInvoicesQueryVariables>(BillingInvoicesDocument, options);
        }
export type BillingInvoicesQueryHookResult = ReturnType<typeof useBillingInvoicesQuery>;
export type BillingInvoicesLazyQueryHookResult = ReturnType<typeof useBillingInvoicesLazyQuery>;
export type BillingInvoicesSuspenseQueryHookResult = ReturnType<typeof useBillingInvoicesSuspenseQuery>;
export type BillingInvoicesQueryResult = Apollo.QueryResult<BillingInvoicesQuery, BillingInvoicesQueryVariables>;
export const BillingPaymentDetailsDocument = gql`
    query billingPaymentDetails($organisationId: ID!) {
  billingPaymentDetails(organisationId: $organisationId) {
    ...PaymentDetails
  }
}
    ${PaymentDetailsFragmentDoc}`;

/**
 * __useBillingPaymentDetailsQuery__
 *
 * To run a query within a React component, call `useBillingPaymentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingPaymentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingPaymentDetailsQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useBillingPaymentDetailsQuery(baseOptions: Apollo.QueryHookOptions<BillingPaymentDetailsQuery, BillingPaymentDetailsQueryVariables> & ({ variables: BillingPaymentDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingPaymentDetailsQuery, BillingPaymentDetailsQueryVariables>(BillingPaymentDetailsDocument, options);
      }
export function useBillingPaymentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingPaymentDetailsQuery, BillingPaymentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingPaymentDetailsQuery, BillingPaymentDetailsQueryVariables>(BillingPaymentDetailsDocument, options);
        }
export function useBillingPaymentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingPaymentDetailsQuery, BillingPaymentDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BillingPaymentDetailsQuery, BillingPaymentDetailsQueryVariables>(BillingPaymentDetailsDocument, options);
        }
export type BillingPaymentDetailsQueryHookResult = ReturnType<typeof useBillingPaymentDetailsQuery>;
export type BillingPaymentDetailsLazyQueryHookResult = ReturnType<typeof useBillingPaymentDetailsLazyQuery>;
export type BillingPaymentDetailsSuspenseQueryHookResult = ReturnType<typeof useBillingPaymentDetailsSuspenseQuery>;
export type BillingPaymentDetailsQueryResult = Apollo.QueryResult<BillingPaymentDetailsQuery, BillingPaymentDetailsQueryVariables>;
export const BillingCheckoutUrlDocument = gql`
    mutation billingCheckoutUrl($organisationId: ID!, $priceId: ID!) {
  billingCheckoutUrl(organisationId: $organisationId, priceId: $priceId)
}
    `;
export type BillingCheckoutUrlMutationFn = Apollo.MutationFunction<BillingCheckoutUrlMutation, BillingCheckoutUrlMutationVariables>;

/**
 * __useBillingCheckoutUrlMutation__
 *
 * To run a mutation, you first call `useBillingCheckoutUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBillingCheckoutUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [billingCheckoutUrlMutation, { data, loading, error }] = useBillingCheckoutUrlMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      priceId: // value for 'priceId'
 *   },
 * });
 */
export function useBillingCheckoutUrlMutation(baseOptions?: Apollo.MutationHookOptions<BillingCheckoutUrlMutation, BillingCheckoutUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BillingCheckoutUrlMutation, BillingCheckoutUrlMutationVariables>(BillingCheckoutUrlDocument, options);
      }
export type BillingCheckoutUrlMutationHookResult = ReturnType<typeof useBillingCheckoutUrlMutation>;
export type BillingCheckoutUrlMutationResult = Apollo.MutationResult<BillingCheckoutUrlMutation>;
export type BillingCheckoutUrlMutationOptions = Apollo.BaseMutationOptions<BillingCheckoutUrlMutation, BillingCheckoutUrlMutationVariables>;
export const BillingSetupIntentCardClientSecretDocument = gql`
    mutation billingSetupIntentCardClientSecret($organisationId: ID!) {
  billingSetupIntentCardClientSecret(organisationId: $organisationId)
}
    `;
export type BillingSetupIntentCardClientSecretMutationFn = Apollo.MutationFunction<BillingSetupIntentCardClientSecretMutation, BillingSetupIntentCardClientSecretMutationVariables>;

/**
 * __useBillingSetupIntentCardClientSecretMutation__
 *
 * To run a mutation, you first call `useBillingSetupIntentCardClientSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBillingSetupIntentCardClientSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [billingSetupIntentCardClientSecretMutation, { data, loading, error }] = useBillingSetupIntentCardClientSecretMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useBillingSetupIntentCardClientSecretMutation(baseOptions?: Apollo.MutationHookOptions<BillingSetupIntentCardClientSecretMutation, BillingSetupIntentCardClientSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BillingSetupIntentCardClientSecretMutation, BillingSetupIntentCardClientSecretMutationVariables>(BillingSetupIntentCardClientSecretDocument, options);
      }
export type BillingSetupIntentCardClientSecretMutationHookResult = ReturnType<typeof useBillingSetupIntentCardClientSecretMutation>;
export type BillingSetupIntentCardClientSecretMutationResult = Apollo.MutationResult<BillingSetupIntentCardClientSecretMutation>;
export type BillingSetupIntentCardClientSecretMutationOptions = Apollo.BaseMutationOptions<BillingSetupIntentCardClientSecretMutation, BillingSetupIntentCardClientSecretMutationVariables>;
export const BillingUpdateCustomerDocument = gql`
    mutation billingUpdateCustomer($organisationId: ID!, $customer: InputBillingCustomer!) {
  billingUpdateCustomer(organisationId: $organisationId, customer: $customer) {
    ...PaymentDetails
  }
}
    ${PaymentDetailsFragmentDoc}`;
export type BillingUpdateCustomerMutationFn = Apollo.MutationFunction<BillingUpdateCustomerMutation, BillingUpdateCustomerMutationVariables>;

/**
 * __useBillingUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useBillingUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBillingUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [billingUpdateCustomerMutation, { data, loading, error }] = useBillingUpdateCustomerMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      customer: // value for 'customer'
 *   },
 * });
 */
export function useBillingUpdateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<BillingUpdateCustomerMutation, BillingUpdateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BillingUpdateCustomerMutation, BillingUpdateCustomerMutationVariables>(BillingUpdateCustomerDocument, options);
      }
export type BillingUpdateCustomerMutationHookResult = ReturnType<typeof useBillingUpdateCustomerMutation>;
export type BillingUpdateCustomerMutationResult = Apollo.MutationResult<BillingUpdateCustomerMutation>;
export type BillingUpdateCustomerMutationOptions = Apollo.BaseMutationOptions<BillingUpdateCustomerMutation, BillingUpdateCustomerMutationVariables>;
export const HubspotSectorsDocument = gql`
    query hubspotSectors {
  hubspotSectors {
    value
  }
}
    `;

/**
 * __useHubspotSectorsQuery__
 *
 * To run a query within a React component, call `useHubspotSectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHubspotSectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHubspotSectorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHubspotSectorsQuery(baseOptions?: Apollo.QueryHookOptions<HubspotSectorsQuery, HubspotSectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HubspotSectorsQuery, HubspotSectorsQueryVariables>(HubspotSectorsDocument, options);
      }
export function useHubspotSectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HubspotSectorsQuery, HubspotSectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HubspotSectorsQuery, HubspotSectorsQueryVariables>(HubspotSectorsDocument, options);
        }
export function useHubspotSectorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HubspotSectorsQuery, HubspotSectorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HubspotSectorsQuery, HubspotSectorsQueryVariables>(HubspotSectorsDocument, options);
        }
export type HubspotSectorsQueryHookResult = ReturnType<typeof useHubspotSectorsQuery>;
export type HubspotSectorsLazyQueryHookResult = ReturnType<typeof useHubspotSectorsLazyQuery>;
export type HubspotSectorsSuspenseQueryHookResult = ReturnType<typeof useHubspotSectorsSuspenseQuery>;
export type HubspotSectorsQueryResult = Apollo.QueryResult<HubspotSectorsQuery, HubspotSectorsQueryVariables>;
export const NotificationsDocument = gql`
    query notifications {
  notifications {
    id
    type
    isRead
    createdAt
    ... on PointCloudConvertDoneNotification {
      organisationId
      meta {
        projectId
        projectName
        uploadStatus: status
      }
    }
    ... on PointCloudCalculationDoneNotification {
      organisationId
      meta {
        projectId
        projectName
        status
        annotationIdentifier
      }
    }
    ... on UserAcceptedInvitationNotification {
      organisationId
      meta {
        organisationName
        userName
      }
    }
    ... on PointCloudExportDoneNotification {
      organisationId
      meta {
        projectId
        projectName
      }
    }
  }
}
    `;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export function useNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsSuspenseQueryHookResult = ReturnType<typeof useNotificationsSuspenseQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const NotificationsMarkAsReadDocument = gql`
    mutation notificationsMarkAsRead($ids: [ID!]) {
  notificationsMarkAsRead(ids: $ids)
}
    `;
export type NotificationsMarkAsReadMutationFn = Apollo.MutationFunction<NotificationsMarkAsReadMutation, NotificationsMarkAsReadMutationVariables>;

/**
 * __useNotificationsMarkAsReadMutation__
 *
 * To run a mutation, you first call `useNotificationsMarkAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationsMarkAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationsMarkAsReadMutation, { data, loading, error }] = useNotificationsMarkAsReadMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useNotificationsMarkAsReadMutation(baseOptions?: Apollo.MutationHookOptions<NotificationsMarkAsReadMutation, NotificationsMarkAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotificationsMarkAsReadMutation, NotificationsMarkAsReadMutationVariables>(NotificationsMarkAsReadDocument, options);
      }
export type NotificationsMarkAsReadMutationHookResult = ReturnType<typeof useNotificationsMarkAsReadMutation>;
export type NotificationsMarkAsReadMutationResult = Apollo.MutationResult<NotificationsMarkAsReadMutation>;
export type NotificationsMarkAsReadMutationOptions = Apollo.BaseMutationOptions<NotificationsMarkAsReadMutation, NotificationsMarkAsReadMutationVariables>;
export const OrganisationsDocument = gql`
    query organisations($includeIds: [ID!]) {
  organisations(includeIds: $includeIds) {
    ...Organisations
  }
}
    ${OrganisationsFragmentDoc}`;

/**
 * __useOrganisationsQuery__
 *
 * To run a query within a React component, call `useOrganisationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationsQuery({
 *   variables: {
 *      includeIds: // value for 'includeIds'
 *   },
 * });
 */
export function useOrganisationsQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationsQuery, OrganisationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationsQuery, OrganisationsQueryVariables>(OrganisationsDocument, options);
      }
export function useOrganisationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationsQuery, OrganisationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationsQuery, OrganisationsQueryVariables>(OrganisationsDocument, options);
        }
export function useOrganisationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationsQuery, OrganisationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationsQuery, OrganisationsQueryVariables>(OrganisationsDocument, options);
        }
export type OrganisationsQueryHookResult = ReturnType<typeof useOrganisationsQuery>;
export type OrganisationsLazyQueryHookResult = ReturnType<typeof useOrganisationsLazyQuery>;
export type OrganisationsSuspenseQueryHookResult = ReturnType<typeof useOrganisationsSuspenseQuery>;
export type OrganisationsQueryResult = Apollo.QueryResult<OrganisationsQuery, OrganisationsQueryVariables>;
export const OrganisationUpdateDocument = gql`
    mutation organisationUpdate($organisationId: ID!, $name: String!) {
  organisationUpdate(organisationId: $organisationId, name: $name) {
    id
    name
  }
}
    `;
export type OrganisationUpdateMutationFn = Apollo.MutationFunction<OrganisationUpdateMutation, OrganisationUpdateMutationVariables>;

/**
 * __useOrganisationUpdateMutation__
 *
 * To run a mutation, you first call `useOrganisationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationUpdateMutation, { data, loading, error }] = useOrganisationUpdateMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useOrganisationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationUpdateMutation, OrganisationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationUpdateMutation, OrganisationUpdateMutationVariables>(OrganisationUpdateDocument, options);
      }
export type OrganisationUpdateMutationHookResult = ReturnType<typeof useOrganisationUpdateMutation>;
export type OrganisationUpdateMutationResult = Apollo.MutationResult<OrganisationUpdateMutation>;
export type OrganisationUpdateMutationOptions = Apollo.BaseMutationOptions<OrganisationUpdateMutation, OrganisationUpdateMutationVariables>;
export const OrganisationCreateDocument = gql`
    mutation organisationCreate($name: String!, $sector: String!) {
  organisationCreate(name: $name, sector: $sector) {
    ...Organisations
  }
}
    ${OrganisationsFragmentDoc}`;
export type OrganisationCreateMutationFn = Apollo.MutationFunction<OrganisationCreateMutation, OrganisationCreateMutationVariables>;

/**
 * __useOrganisationCreateMutation__
 *
 * To run a mutation, you first call `useOrganisationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationCreateMutation, { data, loading, error }] = useOrganisationCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      sector: // value for 'sector'
 *   },
 * });
 */
export function useOrganisationCreateMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationCreateMutation, OrganisationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationCreateMutation, OrganisationCreateMutationVariables>(OrganisationCreateDocument, options);
      }
export type OrganisationCreateMutationHookResult = ReturnType<typeof useOrganisationCreateMutation>;
export type OrganisationCreateMutationResult = Apollo.MutationResult<OrganisationCreateMutation>;
export type OrganisationCreateMutationOptions = Apollo.BaseMutationOptions<OrganisationCreateMutation, OrganisationCreateMutationVariables>;
export const OrganisationDeleteDocument = gql`
    mutation organisationDelete($organisationId: ID!) {
  organisationDelete(organisationId: $organisationId)
}
    `;
export type OrganisationDeleteMutationFn = Apollo.MutationFunction<OrganisationDeleteMutation, OrganisationDeleteMutationVariables>;

/**
 * __useOrganisationDeleteMutation__
 *
 * To run a mutation, you first call `useOrganisationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationDeleteMutation, { data, loading, error }] = useOrganisationDeleteMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useOrganisationDeleteMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationDeleteMutation, OrganisationDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationDeleteMutation, OrganisationDeleteMutationVariables>(OrganisationDeleteDocument, options);
      }
export type OrganisationDeleteMutationHookResult = ReturnType<typeof useOrganisationDeleteMutation>;
export type OrganisationDeleteMutationResult = Apollo.MutationResult<OrganisationDeleteMutation>;
export type OrganisationDeleteMutationOptions = Apollo.BaseMutationOptions<OrganisationDeleteMutation, OrganisationDeleteMutationVariables>;
export const ProjectsDocument = gql`
    query projects($organisationId: ID!) {
  projectsByOrganisationId(organisationId: $organisationId) {
    ...Projects
  }
}
    ${ProjectsFragmentDoc}`;

/**
 * __useProjectsQuery__
 *
 * To run a query within a React component, call `useProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useProjectsQuery(baseOptions: Apollo.QueryHookOptions<ProjectsQuery, ProjectsQueryVariables> & ({ variables: ProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
      }
export function useProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
        }
export function useProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
        }
export type ProjectsQueryHookResult = ReturnType<typeof useProjectsQuery>;
export type ProjectsLazyQueryHookResult = ReturnType<typeof useProjectsLazyQuery>;
export type ProjectsSuspenseQueryHookResult = ReturnType<typeof useProjectsSuspenseQuery>;
export type ProjectsQueryResult = Apollo.QueryResult<ProjectsQuery, ProjectsQueryVariables>;
export const ProjectByIdDocument = gql`
    query projectById($projectId: ID!) {
  projectById(projectId: $projectId) {
    ...Project
  }
}
    ${ProjectFragmentDoc}`;

/**
 * __useProjectByIdQuery__
 *
 * To run a query within a React component, call `useProjectByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectByIdQuery(baseOptions: Apollo.QueryHookOptions<ProjectByIdQuery, ProjectByIdQueryVariables> & ({ variables: ProjectByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectByIdQuery, ProjectByIdQueryVariables>(ProjectByIdDocument, options);
      }
export function useProjectByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectByIdQuery, ProjectByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectByIdQuery, ProjectByIdQueryVariables>(ProjectByIdDocument, options);
        }
export function useProjectByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectByIdQuery, ProjectByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectByIdQuery, ProjectByIdQueryVariables>(ProjectByIdDocument, options);
        }
export type ProjectByIdQueryHookResult = ReturnType<typeof useProjectByIdQuery>;
export type ProjectByIdLazyQueryHookResult = ReturnType<typeof useProjectByIdLazyQuery>;
export type ProjectByIdSuspenseQueryHookResult = ReturnType<typeof useProjectByIdSuspenseQuery>;
export type ProjectByIdQueryResult = Apollo.QueryResult<ProjectByIdQuery, ProjectByIdQueryVariables>;
export const ProjectCalculationsDocument = gql`
    query projectCalculations($projectId: ID!) {
  projectById(projectId: $projectId) {
    id
    calculations {
      ...Calculation
    }
  }
}
    ${CalculationFragmentDoc}`;

/**
 * __useProjectCalculationsQuery__
 *
 * To run a query within a React component, call `useProjectCalculationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectCalculationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectCalculationsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectCalculationsQuery(baseOptions: Apollo.QueryHookOptions<ProjectCalculationsQuery, ProjectCalculationsQueryVariables> & ({ variables: ProjectCalculationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectCalculationsQuery, ProjectCalculationsQueryVariables>(ProjectCalculationsDocument, options);
      }
export function useProjectCalculationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectCalculationsQuery, ProjectCalculationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectCalculationsQuery, ProjectCalculationsQueryVariables>(ProjectCalculationsDocument, options);
        }
export function useProjectCalculationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectCalculationsQuery, ProjectCalculationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectCalculationsQuery, ProjectCalculationsQueryVariables>(ProjectCalculationsDocument, options);
        }
export type ProjectCalculationsQueryHookResult = ReturnType<typeof useProjectCalculationsQuery>;
export type ProjectCalculationsLazyQueryHookResult = ReturnType<typeof useProjectCalculationsLazyQuery>;
export type ProjectCalculationsSuspenseQueryHookResult = ReturnType<typeof useProjectCalculationsSuspenseQuery>;
export type ProjectCalculationsQueryResult = Apollo.QueryResult<ProjectCalculationsQuery, ProjectCalculationsQueryVariables>;
export const ProjectExportsDocument = gql`
    query projectExports($projectId: ID!) {
  projectById(projectId: $projectId) {
    id
    exports {
      ...Export
    }
  }
}
    ${ExportFragmentDoc}`;

/**
 * __useProjectExportsQuery__
 *
 * To run a query within a React component, call `useProjectExportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectExportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectExportsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectExportsQuery(baseOptions: Apollo.QueryHookOptions<ProjectExportsQuery, ProjectExportsQueryVariables> & ({ variables: ProjectExportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectExportsQuery, ProjectExportsQueryVariables>(ProjectExportsDocument, options);
      }
export function useProjectExportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectExportsQuery, ProjectExportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectExportsQuery, ProjectExportsQueryVariables>(ProjectExportsDocument, options);
        }
export function useProjectExportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectExportsQuery, ProjectExportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectExportsQuery, ProjectExportsQueryVariables>(ProjectExportsDocument, options);
        }
export type ProjectExportsQueryHookResult = ReturnType<typeof useProjectExportsQuery>;
export type ProjectExportsLazyQueryHookResult = ReturnType<typeof useProjectExportsLazyQuery>;
export type ProjectExportsSuspenseQueryHookResult = ReturnType<typeof useProjectExportsSuspenseQuery>;
export type ProjectExportsQueryResult = Apollo.QueryResult<ProjectExportsQuery, ProjectExportsQueryVariables>;
export const ProjectDeleteExportDocument = gql`
    mutation projectDeleteExport($projectId: ID!, $exportId: String!) {
  projectDeleteExport(projectId: $projectId, exportId: $exportId) {
    id
    exports {
      ...Export
    }
  }
}
    ${ExportFragmentDoc}`;
export type ProjectDeleteExportMutationFn = Apollo.MutationFunction<ProjectDeleteExportMutation, ProjectDeleteExportMutationVariables>;

/**
 * __useProjectDeleteExportMutation__
 *
 * To run a mutation, you first call `useProjectDeleteExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectDeleteExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectDeleteExportMutation, { data, loading, error }] = useProjectDeleteExportMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      exportId: // value for 'exportId'
 *   },
 * });
 */
export function useProjectDeleteExportMutation(baseOptions?: Apollo.MutationHookOptions<ProjectDeleteExportMutation, ProjectDeleteExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectDeleteExportMutation, ProjectDeleteExportMutationVariables>(ProjectDeleteExportDocument, options);
      }
export type ProjectDeleteExportMutationHookResult = ReturnType<typeof useProjectDeleteExportMutation>;
export type ProjectDeleteExportMutationResult = Apollo.MutationResult<ProjectDeleteExportMutation>;
export type ProjectDeleteExportMutationOptions = Apollo.BaseMutationOptions<ProjectDeleteExportMutation, ProjectDeleteExportMutationVariables>;
export const ProjectRequestUploadSasDocument = gql`
    query projectRequestUploadSAS($projectId: ID!) {
  projectRequestUploadSAS(projectId: $projectId)
}
    `;

/**
 * __useProjectRequestUploadSasQuery__
 *
 * To run a query within a React component, call `useProjectRequestUploadSasQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRequestUploadSasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectRequestUploadSasQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectRequestUploadSasQuery(baseOptions: Apollo.QueryHookOptions<ProjectRequestUploadSasQuery, ProjectRequestUploadSasQueryVariables> & ({ variables: ProjectRequestUploadSasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectRequestUploadSasQuery, ProjectRequestUploadSasQueryVariables>(ProjectRequestUploadSasDocument, options);
      }
export function useProjectRequestUploadSasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectRequestUploadSasQuery, ProjectRequestUploadSasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectRequestUploadSasQuery, ProjectRequestUploadSasQueryVariables>(ProjectRequestUploadSasDocument, options);
        }
export function useProjectRequestUploadSasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectRequestUploadSasQuery, ProjectRequestUploadSasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectRequestUploadSasQuery, ProjectRequestUploadSasQueryVariables>(ProjectRequestUploadSasDocument, options);
        }
export type ProjectRequestUploadSasQueryHookResult = ReturnType<typeof useProjectRequestUploadSasQuery>;
export type ProjectRequestUploadSasLazyQueryHookResult = ReturnType<typeof useProjectRequestUploadSasLazyQuery>;
export type ProjectRequestUploadSasSuspenseQueryHookResult = ReturnType<typeof useProjectRequestUploadSasSuspenseQuery>;
export type ProjectRequestUploadSasQueryResult = Apollo.QueryResult<ProjectRequestUploadSasQuery, ProjectRequestUploadSasQueryVariables>;
export const ProjectRequestReadSasTokenDocument = gql`
    query projectRequestReadSASToken($projectId: ID!) {
  projectRequestReadSASToken(projectId: $projectId)
}
    `;

/**
 * __useProjectRequestReadSasTokenQuery__
 *
 * To run a query within a React component, call `useProjectRequestReadSasTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRequestReadSasTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectRequestReadSasTokenQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectRequestReadSasTokenQuery(baseOptions: Apollo.QueryHookOptions<ProjectRequestReadSasTokenQuery, ProjectRequestReadSasTokenQueryVariables> & ({ variables: ProjectRequestReadSasTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectRequestReadSasTokenQuery, ProjectRequestReadSasTokenQueryVariables>(ProjectRequestReadSasTokenDocument, options);
      }
export function useProjectRequestReadSasTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectRequestReadSasTokenQuery, ProjectRequestReadSasTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectRequestReadSasTokenQuery, ProjectRequestReadSasTokenQueryVariables>(ProjectRequestReadSasTokenDocument, options);
        }
export function useProjectRequestReadSasTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectRequestReadSasTokenQuery, ProjectRequestReadSasTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectRequestReadSasTokenQuery, ProjectRequestReadSasTokenQueryVariables>(ProjectRequestReadSasTokenDocument, options);
        }
export type ProjectRequestReadSasTokenQueryHookResult = ReturnType<typeof useProjectRequestReadSasTokenQuery>;
export type ProjectRequestReadSasTokenLazyQueryHookResult = ReturnType<typeof useProjectRequestReadSasTokenLazyQuery>;
export type ProjectRequestReadSasTokenSuspenseQueryHookResult = ReturnType<typeof useProjectRequestReadSasTokenSuspenseQuery>;
export type ProjectRequestReadSasTokenQueryResult = Apollo.QueryResult<ProjectRequestReadSasTokenQuery, ProjectRequestReadSasTokenQueryVariables>;
export const ProjectStartDocument = gql`
    mutation projectStart($projectId: ID!, $fileNames: [String!]!, $cloudNames: [String!], $organisationId: ID!, $name: String!, $description: String!, $shouldMerge: Boolean) {
  projectStart(
    projectId: $projectId
    fileNames: $fileNames
    cloudNames: $cloudNames
    organisationId: $organisationId
    name: $name
    description: $description
    shouldMerge: $shouldMerge
  ) {
    ...Projects
  }
}
    ${ProjectsFragmentDoc}`;
export type ProjectStartMutationFn = Apollo.MutationFunction<ProjectStartMutation, ProjectStartMutationVariables>;

/**
 * __useProjectStartMutation__
 *
 * To run a mutation, you first call `useProjectStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectStartMutation, { data, loading, error }] = useProjectStartMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      fileNames: // value for 'fileNames'
 *      cloudNames: // value for 'cloudNames'
 *      organisationId: // value for 'organisationId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      shouldMerge: // value for 'shouldMerge'
 *   },
 * });
 */
export function useProjectStartMutation(baseOptions?: Apollo.MutationHookOptions<ProjectStartMutation, ProjectStartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectStartMutation, ProjectStartMutationVariables>(ProjectStartDocument, options);
      }
export type ProjectStartMutationHookResult = ReturnType<typeof useProjectStartMutation>;
export type ProjectStartMutationResult = Apollo.MutationResult<ProjectStartMutation>;
export type ProjectStartMutationOptions = Apollo.BaseMutationOptions<ProjectStartMutation, ProjectStartMutationVariables>;
export const ProjectRelaunchDocument = gql`
    mutation projectRelaunch($projectId: ID!) {
  projectRelaunch(projectId: $projectId) {
    ...Projects
  }
}
    ${ProjectsFragmentDoc}`;
export type ProjectRelaunchMutationFn = Apollo.MutationFunction<ProjectRelaunchMutation, ProjectRelaunchMutationVariables>;

/**
 * __useProjectRelaunchMutation__
 *
 * To run a mutation, you first call `useProjectRelaunchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectRelaunchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectRelaunchMutation, { data, loading, error }] = useProjectRelaunchMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectRelaunchMutation(baseOptions?: Apollo.MutationHookOptions<ProjectRelaunchMutation, ProjectRelaunchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectRelaunchMutation, ProjectRelaunchMutationVariables>(ProjectRelaunchDocument, options);
      }
export type ProjectRelaunchMutationHookResult = ReturnType<typeof useProjectRelaunchMutation>;
export type ProjectRelaunchMutationResult = Apollo.MutationResult<ProjectRelaunchMutation>;
export type ProjectRelaunchMutationOptions = Apollo.BaseMutationOptions<ProjectRelaunchMutation, ProjectRelaunchMutationVariables>;
export const ProjectStartWithPythagorasFilesDocument = gql`
    mutation projectStartWithPythagorasFiles($projectId: ID!, $cloudName: String!, $organisationId: ID!, $name: String!, $description: String!) {
  projectStartWithPythagorasFiles(
    projectId: $projectId
    cloudName: $cloudName
    organisationId: $organisationId
    name: $name
    description: $description
  ) {
    ...Projects
  }
}
    ${ProjectsFragmentDoc}`;
export type ProjectStartWithPythagorasFilesMutationFn = Apollo.MutationFunction<ProjectStartWithPythagorasFilesMutation, ProjectStartWithPythagorasFilesMutationVariables>;

/**
 * __useProjectStartWithPythagorasFilesMutation__
 *
 * To run a mutation, you first call `useProjectStartWithPythagorasFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectStartWithPythagorasFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectStartWithPythagorasFilesMutation, { data, loading, error }] = useProjectStartWithPythagorasFilesMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      cloudName: // value for 'cloudName'
 *      organisationId: // value for 'organisationId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useProjectStartWithPythagorasFilesMutation(baseOptions?: Apollo.MutationHookOptions<ProjectStartWithPythagorasFilesMutation, ProjectStartWithPythagorasFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectStartWithPythagorasFilesMutation, ProjectStartWithPythagorasFilesMutationVariables>(ProjectStartWithPythagorasFilesDocument, options);
      }
export type ProjectStartWithPythagorasFilesMutationHookResult = ReturnType<typeof useProjectStartWithPythagorasFilesMutation>;
export type ProjectStartWithPythagorasFilesMutationResult = Apollo.MutationResult<ProjectStartWithPythagorasFilesMutation>;
export type ProjectStartWithPythagorasFilesMutationOptions = Apollo.BaseMutationOptions<ProjectStartWithPythagorasFilesMutation, ProjectStartWithPythagorasFilesMutationVariables>;
export const ProjectUpdateDocument = gql`
    mutation projectUpdate($projectId: ID!, $name: String!, $description: String!) {
  projectUpdate(projectId: $projectId, name: $name, description: $description) {
    ...Projects
  }
}
    ${ProjectsFragmentDoc}`;
export type ProjectUpdateMutationFn = Apollo.MutationFunction<ProjectUpdateMutation, ProjectUpdateMutationVariables>;

/**
 * __useProjectUpdateMutation__
 *
 * To run a mutation, you first call `useProjectUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUpdateMutation, { data, loading, error }] = useProjectUpdateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useProjectUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProjectUpdateMutation, ProjectUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectUpdateMutation, ProjectUpdateMutationVariables>(ProjectUpdateDocument, options);
      }
export type ProjectUpdateMutationHookResult = ReturnType<typeof useProjectUpdateMutation>;
export type ProjectUpdateMutationResult = Apollo.MutationResult<ProjectUpdateMutation>;
export type ProjectUpdateMutationOptions = Apollo.BaseMutationOptions<ProjectUpdateMutation, ProjectUpdateMutationVariables>;
export const ProjectUpdatePreviewImageDocument = gql`
    mutation projectUpdatePreviewImage($projectId: ID!, $previewImageFileName: String!) {
  projectUpdatePreviewImage(
    projectId: $projectId
    previewImageFileName: $previewImageFileName
  ) {
    ...Projects
  }
}
    ${ProjectsFragmentDoc}`;
export type ProjectUpdatePreviewImageMutationFn = Apollo.MutationFunction<ProjectUpdatePreviewImageMutation, ProjectUpdatePreviewImageMutationVariables>;

/**
 * __useProjectUpdatePreviewImageMutation__
 *
 * To run a mutation, you first call `useProjectUpdatePreviewImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUpdatePreviewImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUpdatePreviewImageMutation, { data, loading, error }] = useProjectUpdatePreviewImageMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      previewImageFileName: // value for 'previewImageFileName'
 *   },
 * });
 */
export function useProjectUpdatePreviewImageMutation(baseOptions?: Apollo.MutationHookOptions<ProjectUpdatePreviewImageMutation, ProjectUpdatePreviewImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectUpdatePreviewImageMutation, ProjectUpdatePreviewImageMutationVariables>(ProjectUpdatePreviewImageDocument, options);
      }
export type ProjectUpdatePreviewImageMutationHookResult = ReturnType<typeof useProjectUpdatePreviewImageMutation>;
export type ProjectUpdatePreviewImageMutationResult = Apollo.MutationResult<ProjectUpdatePreviewImageMutation>;
export type ProjectUpdatePreviewImageMutationOptions = Apollo.BaseMutationOptions<ProjectUpdatePreviewImageMutation, ProjectUpdatePreviewImageMutationVariables>;
export const ProjectUpdateSettingsDocument = gql`
    mutation projectUpdateSettings($projectId: ID!, $settings: InputProjectSettings!) {
  projectUpdateSettings(projectId: $projectId, settings: $settings) {
    id
    settings {
      projectionSystem
    }
  }
}
    `;
export type ProjectUpdateSettingsMutationFn = Apollo.MutationFunction<ProjectUpdateSettingsMutation, ProjectUpdateSettingsMutationVariables>;

/**
 * __useProjectUpdateSettingsMutation__
 *
 * To run a mutation, you first call `useProjectUpdateSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUpdateSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUpdateSettingsMutation, { data, loading, error }] = useProjectUpdateSettingsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useProjectUpdateSettingsMutation(baseOptions?: Apollo.MutationHookOptions<ProjectUpdateSettingsMutation, ProjectUpdateSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectUpdateSettingsMutation, ProjectUpdateSettingsMutationVariables>(ProjectUpdateSettingsDocument, options);
      }
export type ProjectUpdateSettingsMutationHookResult = ReturnType<typeof useProjectUpdateSettingsMutation>;
export type ProjectUpdateSettingsMutationResult = Apollo.MutationResult<ProjectUpdateSettingsMutation>;
export type ProjectUpdateSettingsMutationOptions = Apollo.BaseMutationOptions<ProjectUpdateSettingsMutation, ProjectUpdateSettingsMutationVariables>;
export const ProjectDeleteDocument = gql`
    mutation projectDelete($projectId: ID!) {
  projectDelete(projectId: $projectId)
}
    `;
export type ProjectDeleteMutationFn = Apollo.MutationFunction<ProjectDeleteMutation, ProjectDeleteMutationVariables>;

/**
 * __useProjectDeleteMutation__
 *
 * To run a mutation, you first call `useProjectDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectDeleteMutation, { data, loading, error }] = useProjectDeleteMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ProjectDeleteMutation, ProjectDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectDeleteMutation, ProjectDeleteMutationVariables>(ProjectDeleteDocument, options);
      }
export type ProjectDeleteMutationHookResult = ReturnType<typeof useProjectDeleteMutation>;
export type ProjectDeleteMutationResult = Apollo.MutationResult<ProjectDeleteMutation>;
export type ProjectDeleteMutationOptions = Apollo.BaseMutationOptions<ProjectDeleteMutation, ProjectDeleteMutationVariables>;
export const ProjectActivateDocument = gql`
    mutation projectActivate($projectId: ID!) {
  projectActivate(projectId: $projectId) {
    uploadStatus
  }
}
    `;
export type ProjectActivateMutationFn = Apollo.MutationFunction<ProjectActivateMutation, ProjectActivateMutationVariables>;

/**
 * __useProjectActivateMutation__
 *
 * To run a mutation, you first call `useProjectActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectActivateMutation, { data, loading, error }] = useProjectActivateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectActivateMutation(baseOptions?: Apollo.MutationHookOptions<ProjectActivateMutation, ProjectActivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectActivateMutation, ProjectActivateMutationVariables>(ProjectActivateDocument, options);
      }
export type ProjectActivateMutationHookResult = ReturnType<typeof useProjectActivateMutation>;
export type ProjectActivateMutationResult = Apollo.MutationResult<ProjectActivateMutation>;
export type ProjectActivateMutationOptions = Apollo.BaseMutationOptions<ProjectActivateMutation, ProjectActivateMutationVariables>;
export const ProjectDuplicateDocument = gql`
    mutation projectDuplicate($projectId: ID!, $name: String!, $description: String!) {
  projectDuplicate(projectId: $projectId, name: $name, description: $description) {
    id
  }
}
    `;
export type ProjectDuplicateMutationFn = Apollo.MutationFunction<ProjectDuplicateMutation, ProjectDuplicateMutationVariables>;

/**
 * __useProjectDuplicateMutation__
 *
 * To run a mutation, you first call `useProjectDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectDuplicateMutation, { data, loading, error }] = useProjectDuplicateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useProjectDuplicateMutation(baseOptions?: Apollo.MutationHookOptions<ProjectDuplicateMutation, ProjectDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectDuplicateMutation, ProjectDuplicateMutationVariables>(ProjectDuplicateDocument, options);
      }
export type ProjectDuplicateMutationHookResult = ReturnType<typeof useProjectDuplicateMutation>;
export type ProjectDuplicateMutationResult = Apollo.MutationResult<ProjectDuplicateMutation>;
export type ProjectDuplicateMutationOptions = Apollo.BaseMutationOptions<ProjectDuplicateMutation, ProjectDuplicateMutationVariables>;
export const ProjectConfirmPointCloudUploadDocument = gql`
    mutation projectConfirmPointCloudUpload($projectId: ID!, $fileNames: [String!]!, $shouldMerge: Boolean) {
  projectConfirmPointCloudUpload(
    projectId: $projectId
    fileNames: $fileNames
    shouldMerge: $shouldMerge
  )
}
    `;
export type ProjectConfirmPointCloudUploadMutationFn = Apollo.MutationFunction<ProjectConfirmPointCloudUploadMutation, ProjectConfirmPointCloudUploadMutationVariables>;

/**
 * __useProjectConfirmPointCloudUploadMutation__
 *
 * To run a mutation, you first call `useProjectConfirmPointCloudUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectConfirmPointCloudUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectConfirmPointCloudUploadMutation, { data, loading, error }] = useProjectConfirmPointCloudUploadMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      fileNames: // value for 'fileNames'
 *      shouldMerge: // value for 'shouldMerge'
 *   },
 * });
 */
export function useProjectConfirmPointCloudUploadMutation(baseOptions?: Apollo.MutationHookOptions<ProjectConfirmPointCloudUploadMutation, ProjectConfirmPointCloudUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectConfirmPointCloudUploadMutation, ProjectConfirmPointCloudUploadMutationVariables>(ProjectConfirmPointCloudUploadDocument, options);
      }
export type ProjectConfirmPointCloudUploadMutationHookResult = ReturnType<typeof useProjectConfirmPointCloudUploadMutation>;
export type ProjectConfirmPointCloudUploadMutationResult = Apollo.MutationResult<ProjectConfirmPointCloudUploadMutation>;
export type ProjectConfirmPointCloudUploadMutationOptions = Apollo.BaseMutationOptions<ProjectConfirmPointCloudUploadMutation, ProjectConfirmPointCloudUploadMutationVariables>;
export const ProjectUndoActionDocument = gql`
    mutation projectUndoAction($projectId: ID!, $identifier: String!) {
  projectUndoAction(projectId: $projectId, identifier: $identifier) {
    id
    state {
      ...ProjectState
    }
    calculations {
      ... on VolumeCalculation {
        isOutDated
      }
      ... on ProjectionCalculation {
        isOutDated
      }
    }
    pointClouds {
      id
      displayName
    }
  }
}
    ${ProjectStateFragmentDoc}`;
export type ProjectUndoActionMutationFn = Apollo.MutationFunction<ProjectUndoActionMutation, ProjectUndoActionMutationVariables>;

/**
 * __useProjectUndoActionMutation__
 *
 * To run a mutation, you first call `useProjectUndoActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUndoActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUndoActionMutation, { data, loading, error }] = useProjectUndoActionMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useProjectUndoActionMutation(baseOptions?: Apollo.MutationHookOptions<ProjectUndoActionMutation, ProjectUndoActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectUndoActionMutation, ProjectUndoActionMutationVariables>(ProjectUndoActionDocument, options);
      }
export type ProjectUndoActionMutationHookResult = ReturnType<typeof useProjectUndoActionMutation>;
export type ProjectUndoActionMutationResult = Apollo.MutationResult<ProjectUndoActionMutation>;
export type ProjectUndoActionMutationOptions = Apollo.BaseMutationOptions<ProjectUndoActionMutation, ProjectUndoActionMutationVariables>;
export const ProjectAddActionDocument = gql`
    mutation projectAddAction($projectId: ID!, $action: InputProjectAction!) {
  projectAddAction(projectId: $projectId, action: $action) {
    id
    state {
      ...ProjectState
    }
    calculations {
      ... on VolumeCalculation {
        isOutDated
      }
      ... on ProjectionCalculation {
        isOutDated
      }
    }
    pointClouds {
      id
      displayName
    }
  }
}
    ${ProjectStateFragmentDoc}`;
export type ProjectAddActionMutationFn = Apollo.MutationFunction<ProjectAddActionMutation, ProjectAddActionMutationVariables>;

/**
 * __useProjectAddActionMutation__
 *
 * To run a mutation, you first call `useProjectAddActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectAddActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectAddActionMutation, { data, loading, error }] = useProjectAddActionMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useProjectAddActionMutation(baseOptions?: Apollo.MutationHookOptions<ProjectAddActionMutation, ProjectAddActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectAddActionMutation, ProjectAddActionMutationVariables>(ProjectAddActionDocument, options);
      }
export type ProjectAddActionMutationHookResult = ReturnType<typeof useProjectAddActionMutation>;
export type ProjectAddActionMutationResult = Apollo.MutationResult<ProjectAddActionMutation>;
export type ProjectAddActionMutationOptions = Apollo.BaseMutationOptions<ProjectAddActionMutation, ProjectAddActionMutationVariables>;
export const ProjectToggleObjectVisibilityDocument = gql`
    mutation projectToggleObjectVisibility($projectId: ID!, $identifiers: [String!]!, $visible: Boolean!) {
  projectToggleObjectVisibility(
    projectId: $projectId
    identifiers: $identifiers
    visible: $visible
  ) {
    id
    state {
      ...ProjectState
    }
    pointClouds {
      id
      visible
    }
    mapVisible
  }
}
    ${ProjectStateFragmentDoc}`;
export type ProjectToggleObjectVisibilityMutationFn = Apollo.MutationFunction<ProjectToggleObjectVisibilityMutation, ProjectToggleObjectVisibilityMutationVariables>;

/**
 * __useProjectToggleObjectVisibilityMutation__
 *
 * To run a mutation, you first call `useProjectToggleObjectVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectToggleObjectVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectToggleObjectVisibilityMutation, { data, loading, error }] = useProjectToggleObjectVisibilityMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      identifiers: // value for 'identifiers'
 *      visible: // value for 'visible'
 *   },
 * });
 */
export function useProjectToggleObjectVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<ProjectToggleObjectVisibilityMutation, ProjectToggleObjectVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectToggleObjectVisibilityMutation, ProjectToggleObjectVisibilityMutationVariables>(ProjectToggleObjectVisibilityDocument, options);
      }
export type ProjectToggleObjectVisibilityMutationHookResult = ReturnType<typeof useProjectToggleObjectVisibilityMutation>;
export type ProjectToggleObjectVisibilityMutationResult = Apollo.MutationResult<ProjectToggleObjectVisibilityMutation>;
export type ProjectToggleObjectVisibilityMutationOptions = Apollo.BaseMutationOptions<ProjectToggleObjectVisibilityMutation, ProjectToggleObjectVisibilityMutationVariables>;
export const ProjectToggleObjectLabelVisibilityDocument = gql`
    mutation projectToggleObjectLabelVisibility($projectId: ID!, $identifiers: [String!]!, $visible: Boolean!, $label: AnnotationLabels!) {
  projectToggleObjectLabelVisibility(
    projectId: $projectId
    identifiers: $identifiers
    visible: $visible
    label: $label
  ) {
    id
    state {
      annotations {
        identifier
        hiddenLabels
      }
    }
  }
}
    `;
export type ProjectToggleObjectLabelVisibilityMutationFn = Apollo.MutationFunction<ProjectToggleObjectLabelVisibilityMutation, ProjectToggleObjectLabelVisibilityMutationVariables>;

/**
 * __useProjectToggleObjectLabelVisibilityMutation__
 *
 * To run a mutation, you first call `useProjectToggleObjectLabelVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectToggleObjectLabelVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectToggleObjectLabelVisibilityMutation, { data, loading, error }] = useProjectToggleObjectLabelVisibilityMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      identifiers: // value for 'identifiers'
 *      visible: // value for 'visible'
 *      label: // value for 'label'
 *   },
 * });
 */
export function useProjectToggleObjectLabelVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<ProjectToggleObjectLabelVisibilityMutation, ProjectToggleObjectLabelVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectToggleObjectLabelVisibilityMutation, ProjectToggleObjectLabelVisibilityMutationVariables>(ProjectToggleObjectLabelVisibilityDocument, options);
      }
export type ProjectToggleObjectLabelVisibilityMutationHookResult = ReturnType<typeof useProjectToggleObjectLabelVisibilityMutation>;
export type ProjectToggleObjectLabelVisibilityMutationResult = Apollo.MutationResult<ProjectToggleObjectLabelVisibilityMutation>;
export type ProjectToggleObjectLabelVisibilityMutationOptions = Apollo.BaseMutationOptions<ProjectToggleObjectLabelVisibilityMutation, ProjectToggleObjectLabelVisibilityMutationVariables>;
export const ProjectUpdateClippingMethodDocument = gql`
    mutation projectUpdateClippingMethod($projectId: ID!, $annotationIdentifiers: [String!]!, $clipMethod: ClipMethods!) {
  projectUpdateClippingMethod(
    projectId: $projectId
    annotationIdentifiers: $annotationIdentifiers
    clipMethod: $clipMethod
  ) {
    id
    state {
      annotations {
        ... on BoxAnnotation {
          annotationFilter {
            clipMethod
          }
        }
        ... on PointCluster {
          annotationFilter {
            clipMethod
          }
        }
        ... on Plane {
          annotationFilter {
            clipMethod
          }
        }
      }
    }
  }
}
    `;
export type ProjectUpdateClippingMethodMutationFn = Apollo.MutationFunction<ProjectUpdateClippingMethodMutation, ProjectUpdateClippingMethodMutationVariables>;

/**
 * __useProjectUpdateClippingMethodMutation__
 *
 * To run a mutation, you first call `useProjectUpdateClippingMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUpdateClippingMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUpdateClippingMethodMutation, { data, loading, error }] = useProjectUpdateClippingMethodMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      annotationIdentifiers: // value for 'annotationIdentifiers'
 *      clipMethod: // value for 'clipMethod'
 *   },
 * });
 */
export function useProjectUpdateClippingMethodMutation(baseOptions?: Apollo.MutationHookOptions<ProjectUpdateClippingMethodMutation, ProjectUpdateClippingMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectUpdateClippingMethodMutation, ProjectUpdateClippingMethodMutationVariables>(ProjectUpdateClippingMethodDocument, options);
      }
export type ProjectUpdateClippingMethodMutationHookResult = ReturnType<typeof useProjectUpdateClippingMethodMutation>;
export type ProjectUpdateClippingMethodMutationResult = Apollo.MutationResult<ProjectUpdateClippingMethodMutation>;
export type ProjectUpdateClippingMethodMutationOptions = Apollo.BaseMutationOptions<ProjectUpdateClippingMethodMutation, ProjectUpdateClippingMethodMutationVariables>;
export const ProjectUpdateClippingToleranceDocument = gql`
    mutation projectUpdateClippingTolerance($projectId: ID!, $annotationIdentifiers: [String!]!, $tolerance: Float!) {
  projectUpdateClippingTolerance(
    projectId: $projectId
    annotationIdentifiers: $annotationIdentifiers
    tolerance: $tolerance
  ) {
    id
    state {
      annotations {
        ... on Plane {
          annotationFilter {
            tolerance
          }
        }
      }
    }
  }
}
    `;
export type ProjectUpdateClippingToleranceMutationFn = Apollo.MutationFunction<ProjectUpdateClippingToleranceMutation, ProjectUpdateClippingToleranceMutationVariables>;

/**
 * __useProjectUpdateClippingToleranceMutation__
 *
 * To run a mutation, you first call `useProjectUpdateClippingToleranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUpdateClippingToleranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUpdateClippingToleranceMutation, { data, loading, error }] = useProjectUpdateClippingToleranceMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      annotationIdentifiers: // value for 'annotationIdentifiers'
 *      tolerance: // value for 'tolerance'
 *   },
 * });
 */
export function useProjectUpdateClippingToleranceMutation(baseOptions?: Apollo.MutationHookOptions<ProjectUpdateClippingToleranceMutation, ProjectUpdateClippingToleranceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectUpdateClippingToleranceMutation, ProjectUpdateClippingToleranceMutationVariables>(ProjectUpdateClippingToleranceDocument, options);
      }
export type ProjectUpdateClippingToleranceMutationHookResult = ReturnType<typeof useProjectUpdateClippingToleranceMutation>;
export type ProjectUpdateClippingToleranceMutationResult = Apollo.MutationResult<ProjectUpdateClippingToleranceMutation>;
export type ProjectUpdateClippingToleranceMutationOptions = Apollo.BaseMutationOptions<ProjectUpdateClippingToleranceMutation, ProjectUpdateClippingToleranceMutationVariables>;
export const ProjectVolumeCalculateDocument = gql`
    mutation projectVolumeCalculate($projectId: ID!, $pointCloudId: ID!, $annotationIdentifier: String!, $referenceHeight: Float, $baseSurface: CalculationBaseSurfaces!, $classificationFilters: [Int!], $heightFilters: [Int], $intensityFilters: [Int], $resolutionFilter: Int, $clippingFilter: Int) {
  projectVolumeCalculate(
    projectId: $projectId
    pointCloudId: $pointCloudId
    annotationIdentifier: $annotationIdentifier
    referenceHeight: $referenceHeight
    baseSurface: $baseSurface
    classificationFilters: $classificationFilters
    heightFilters: $heightFilters
    intensityFilters: $intensityFilters
    resolutionFilter: $resolutionFilter
    clippingFilter: $clippingFilter
  ) {
    id
    calculations {
      ...Calculation
    }
  }
}
    ${CalculationFragmentDoc}`;
export type ProjectVolumeCalculateMutationFn = Apollo.MutationFunction<ProjectVolumeCalculateMutation, ProjectVolumeCalculateMutationVariables>;

/**
 * __useProjectVolumeCalculateMutation__
 *
 * To run a mutation, you first call `useProjectVolumeCalculateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectVolumeCalculateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectVolumeCalculateMutation, { data, loading, error }] = useProjectVolumeCalculateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      pointCloudId: // value for 'pointCloudId'
 *      annotationIdentifier: // value for 'annotationIdentifier'
 *      referenceHeight: // value for 'referenceHeight'
 *      baseSurface: // value for 'baseSurface'
 *      classificationFilters: // value for 'classificationFilters'
 *      heightFilters: // value for 'heightFilters'
 *      intensityFilters: // value for 'intensityFilters'
 *      resolutionFilter: // value for 'resolutionFilter'
 *      clippingFilter: // value for 'clippingFilter'
 *   },
 * });
 */
export function useProjectVolumeCalculateMutation(baseOptions?: Apollo.MutationHookOptions<ProjectVolumeCalculateMutation, ProjectVolumeCalculateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectVolumeCalculateMutation, ProjectVolumeCalculateMutationVariables>(ProjectVolumeCalculateDocument, options);
      }
export type ProjectVolumeCalculateMutationHookResult = ReturnType<typeof useProjectVolumeCalculateMutation>;
export type ProjectVolumeCalculateMutationResult = Apollo.MutationResult<ProjectVolumeCalculateMutation>;
export type ProjectVolumeCalculateMutationOptions = Apollo.BaseMutationOptions<ProjectVolumeCalculateMutation, ProjectVolumeCalculateMutationVariables>;
export const ProjectExportPointcloudDocument = gql`
    mutation projectExportPointcloud($projectId: ID!, $pointCloudId: ID!, $fileType: FileTypes, $heightFilters: [Int], $intensityFilters: [Int], $classificationFilters: [Int], $resolutionFilter: Int, $clippingFilter: Int) {
  projectExportPointcloud(
    projectId: $projectId
    pointCloudId: $pointCloudId
    fileType: $fileType
    heightFilters: $heightFilters
    intensityFilters: $intensityFilters
    classificationFilters: $classificationFilters
    resolutionFilter: $resolutionFilter
    clippingFilter: $clippingFilter
  ) {
    id
    exports {
      ...Export
    }
  }
}
    ${ExportFragmentDoc}`;
export type ProjectExportPointcloudMutationFn = Apollo.MutationFunction<ProjectExportPointcloudMutation, ProjectExportPointcloudMutationVariables>;

/**
 * __useProjectExportPointcloudMutation__
 *
 * To run a mutation, you first call `useProjectExportPointcloudMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectExportPointcloudMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectExportPointcloudMutation, { data, loading, error }] = useProjectExportPointcloudMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      pointCloudId: // value for 'pointCloudId'
 *      fileType: // value for 'fileType'
 *      heightFilters: // value for 'heightFilters'
 *      intensityFilters: // value for 'intensityFilters'
 *      classificationFilters: // value for 'classificationFilters'
 *      resolutionFilter: // value for 'resolutionFilter'
 *      clippingFilter: // value for 'clippingFilter'
 *   },
 * });
 */
export function useProjectExportPointcloudMutation(baseOptions?: Apollo.MutationHookOptions<ProjectExportPointcloudMutation, ProjectExportPointcloudMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectExportPointcloudMutation, ProjectExportPointcloudMutationVariables>(ProjectExportPointcloudDocument, options);
      }
export type ProjectExportPointcloudMutationHookResult = ReturnType<typeof useProjectExportPointcloudMutation>;
export type ProjectExportPointcloudMutationResult = Apollo.MutationResult<ProjectExportPointcloudMutation>;
export type ProjectExportPointcloudMutationOptions = Apollo.BaseMutationOptions<ProjectExportPointcloudMutation, ProjectExportPointcloudMutationVariables>;
export const ProjectProjectionCalculateDocument = gql`
    mutation projectProjectionCalculate($projectId: ID!, $pointCloudId: ID!, $annotationIdentifier: String!, $profileGroupIdentifier: String!, $classificationFilters: [Int!], $heightFilters: [Int], $intensityFilters: [Int], $resolutionFilter: Int, $clippingFilter: Int) {
  projectProjectionCalculate(
    projectId: $projectId
    pointCloudId: $pointCloudId
    annotationIdentifier: $annotationIdentifier
    profileGroupIdentifier: $profileGroupIdentifier
    classificationFilters: $classificationFilters
    heightFilters: $heightFilters
    intensityFilters: $intensityFilters
    resolutionFilter: $resolutionFilter
    clippingFilter: $clippingFilter
  ) {
    id
    calculations {
      ...Calculation
    }
  }
}
    ${CalculationFragmentDoc}`;
export type ProjectProjectionCalculateMutationFn = Apollo.MutationFunction<ProjectProjectionCalculateMutation, ProjectProjectionCalculateMutationVariables>;

/**
 * __useProjectProjectionCalculateMutation__
 *
 * To run a mutation, you first call `useProjectProjectionCalculateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectProjectionCalculateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectProjectionCalculateMutation, { data, loading, error }] = useProjectProjectionCalculateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      pointCloudId: // value for 'pointCloudId'
 *      annotationIdentifier: // value for 'annotationIdentifier'
 *      profileGroupIdentifier: // value for 'profileGroupIdentifier'
 *      classificationFilters: // value for 'classificationFilters'
 *      heightFilters: // value for 'heightFilters'
 *      intensityFilters: // value for 'intensityFilters'
 *      resolutionFilter: // value for 'resolutionFilter'
 *      clippingFilter: // value for 'clippingFilter'
 *   },
 * });
 */
export function useProjectProjectionCalculateMutation(baseOptions?: Apollo.MutationHookOptions<ProjectProjectionCalculateMutation, ProjectProjectionCalculateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectProjectionCalculateMutation, ProjectProjectionCalculateMutationVariables>(ProjectProjectionCalculateDocument, options);
      }
export type ProjectProjectionCalculateMutationHookResult = ReturnType<typeof useProjectProjectionCalculateMutation>;
export type ProjectProjectionCalculateMutationResult = Apollo.MutationResult<ProjectProjectionCalculateMutation>;
export type ProjectProjectionCalculateMutationOptions = Apollo.BaseMutationOptions<ProjectProjectionCalculateMutation, ProjectProjectionCalculateMutationVariables>;
export const ProjectDeleteCalculationDocument = gql`
    mutation projectDeleteCalculation($projectId: ID!, $calculationId: ID!) {
  projectDeleteCalculation(projectId: $projectId, calculationId: $calculationId) {
    id
    calculations {
      ...Calculation
    }
  }
}
    ${CalculationFragmentDoc}`;
export type ProjectDeleteCalculationMutationFn = Apollo.MutationFunction<ProjectDeleteCalculationMutation, ProjectDeleteCalculationMutationVariables>;

/**
 * __useProjectDeleteCalculationMutation__
 *
 * To run a mutation, you first call `useProjectDeleteCalculationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectDeleteCalculationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectDeleteCalculationMutation, { data, loading, error }] = useProjectDeleteCalculationMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      calculationId: // value for 'calculationId'
 *   },
 * });
 */
export function useProjectDeleteCalculationMutation(baseOptions?: Apollo.MutationHookOptions<ProjectDeleteCalculationMutation, ProjectDeleteCalculationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectDeleteCalculationMutation, ProjectDeleteCalculationMutationVariables>(ProjectDeleteCalculationDocument, options);
      }
export type ProjectDeleteCalculationMutationHookResult = ReturnType<typeof useProjectDeleteCalculationMutation>;
export type ProjectDeleteCalculationMutationResult = Apollo.MutationResult<ProjectDeleteCalculationMutation>;
export type ProjectDeleteCalculationMutationOptions = Apollo.BaseMutationOptions<ProjectDeleteCalculationMutation, ProjectDeleteCalculationMutationVariables>;
export const ProjectGenerateClassificationsDocument = gql`
    mutation projectGenerateClassifications($projectId: ID!, $cloudName: String!) {
  projectGenerateClassifications(projectId: $projectId, cloudName: $cloudName) {
    id
    pointClouds {
      hasClassifications
    }
  }
}
    `;
export type ProjectGenerateClassificationsMutationFn = Apollo.MutationFunction<ProjectGenerateClassificationsMutation, ProjectGenerateClassificationsMutationVariables>;

/**
 * __useProjectGenerateClassificationsMutation__
 *
 * To run a mutation, you first call `useProjectGenerateClassificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectGenerateClassificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectGenerateClassificationsMutation, { data, loading, error }] = useProjectGenerateClassificationsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      cloudName: // value for 'cloudName'
 *   },
 * });
 */
export function useProjectGenerateClassificationsMutation(baseOptions?: Apollo.MutationHookOptions<ProjectGenerateClassificationsMutation, ProjectGenerateClassificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectGenerateClassificationsMutation, ProjectGenerateClassificationsMutationVariables>(ProjectGenerateClassificationsDocument, options);
      }
export type ProjectGenerateClassificationsMutationHookResult = ReturnType<typeof useProjectGenerateClassificationsMutation>;
export type ProjectGenerateClassificationsMutationResult = Apollo.MutationResult<ProjectGenerateClassificationsMutation>;
export type ProjectGenerateClassificationsMutationOptions = Apollo.BaseMutationOptions<ProjectGenerateClassificationsMutation, ProjectGenerateClassificationsMutationVariables>;
export const ProjectPointCloudDeleteDocument = gql`
    mutation projectPointCloudDelete($projectId: ID!, $pointCloudId: ID!) {
  projectPointCloudDelete(projectId: $projectId, pointCloudId: $pointCloudId) {
    ...Project
  }
}
    ${ProjectFragmentDoc}`;
export type ProjectPointCloudDeleteMutationFn = Apollo.MutationFunction<ProjectPointCloudDeleteMutation, ProjectPointCloudDeleteMutationVariables>;

/**
 * __useProjectPointCloudDeleteMutation__
 *
 * To run a mutation, you first call `useProjectPointCloudDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectPointCloudDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectPointCloudDeleteMutation, { data, loading, error }] = useProjectPointCloudDeleteMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      pointCloudId: // value for 'pointCloudId'
 *   },
 * });
 */
export function useProjectPointCloudDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ProjectPointCloudDeleteMutation, ProjectPointCloudDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectPointCloudDeleteMutation, ProjectPointCloudDeleteMutationVariables>(ProjectPointCloudDeleteDocument, options);
      }
export type ProjectPointCloudDeleteMutationHookResult = ReturnType<typeof useProjectPointCloudDeleteMutation>;
export type ProjectPointCloudDeleteMutationResult = Apollo.MutationResult<ProjectPointCloudDeleteMutation>;
export type ProjectPointCloudDeleteMutationOptions = Apollo.BaseMutationOptions<ProjectPointCloudDeleteMutation, ProjectPointCloudDeleteMutationVariables>;
export const PointCloudUploadStatusDocument = gql`
    query pointCloudUploadStatus($projectId: ID!) {
  projectById(projectId: $projectId) {
    id
    pointClouds {
      id
      uploadStatus
    }
  }
}
    `;

/**
 * __usePointCloudUploadStatusQuery__
 *
 * To run a query within a React component, call `usePointCloudUploadStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointCloudUploadStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointCloudUploadStatusQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePointCloudUploadStatusQuery(baseOptions: Apollo.QueryHookOptions<PointCloudUploadStatusQuery, PointCloudUploadStatusQueryVariables> & ({ variables: PointCloudUploadStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointCloudUploadStatusQuery, PointCloudUploadStatusQueryVariables>(PointCloudUploadStatusDocument, options);
      }
export function usePointCloudUploadStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointCloudUploadStatusQuery, PointCloudUploadStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointCloudUploadStatusQuery, PointCloudUploadStatusQueryVariables>(PointCloudUploadStatusDocument, options);
        }
export function usePointCloudUploadStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointCloudUploadStatusQuery, PointCloudUploadStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointCloudUploadStatusQuery, PointCloudUploadStatusQueryVariables>(PointCloudUploadStatusDocument, options);
        }
export type PointCloudUploadStatusQueryHookResult = ReturnType<typeof usePointCloudUploadStatusQuery>;
export type PointCloudUploadStatusLazyQueryHookResult = ReturnType<typeof usePointCloudUploadStatusLazyQuery>;
export type PointCloudUploadStatusSuspenseQueryHookResult = ReturnType<typeof usePointCloudUploadStatusSuspenseQuery>;
export type PointCloudUploadStatusQueryResult = Apollo.QueryResult<PointCloudUploadStatusQuery, PointCloudUploadStatusQueryVariables>;
export const ProjectInitializeDocument = gql`
    mutation projectInitialize($organisationId: ID!) {
  projectInitialize(organisationId: $organisationId) {
    id
  }
}
    `;
export type ProjectInitializeMutationFn = Apollo.MutationFunction<ProjectInitializeMutation, ProjectInitializeMutationVariables>;

/**
 * __useProjectInitializeMutation__
 *
 * To run a mutation, you first call `useProjectInitializeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectInitializeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectInitializeMutation, { data, loading, error }] = useProjectInitializeMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useProjectInitializeMutation(baseOptions?: Apollo.MutationHookOptions<ProjectInitializeMutation, ProjectInitializeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectInitializeMutation, ProjectInitializeMutationVariables>(ProjectInitializeDocument, options);
      }
export type ProjectInitializeMutationHookResult = ReturnType<typeof useProjectInitializeMutation>;
export type ProjectInitializeMutationResult = Apollo.MutationResult<ProjectInitializeMutation>;
export type ProjectInitializeMutationOptions = Apollo.BaseMutationOptions<ProjectInitializeMutation, ProjectInitializeMutationVariables>;
export const ProjectAddCommentDocument = gql`
    mutation projectAddComment($projectId: ID!, $comment: String!, $referenceIdentifier: String!) {
  projectAddComment(
    projectId: $projectId
    comment: $comment
    referenceIdentifier: $referenceIdentifier
  ) {
    comments {
      id
    }
  }
}
    `;
export type ProjectAddCommentMutationFn = Apollo.MutationFunction<ProjectAddCommentMutation, ProjectAddCommentMutationVariables>;

/**
 * __useProjectAddCommentMutation__
 *
 * To run a mutation, you first call `useProjectAddCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectAddCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectAddCommentMutation, { data, loading, error }] = useProjectAddCommentMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      comment: // value for 'comment'
 *      referenceIdentifier: // value for 'referenceIdentifier'
 *   },
 * });
 */
export function useProjectAddCommentMutation(baseOptions?: Apollo.MutationHookOptions<ProjectAddCommentMutation, ProjectAddCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectAddCommentMutation, ProjectAddCommentMutationVariables>(ProjectAddCommentDocument, options);
      }
export type ProjectAddCommentMutationHookResult = ReturnType<typeof useProjectAddCommentMutation>;
export type ProjectAddCommentMutationResult = Apollo.MutationResult<ProjectAddCommentMutation>;
export type ProjectAddCommentMutationOptions = Apollo.BaseMutationOptions<ProjectAddCommentMutation, ProjectAddCommentMutationVariables>;
export const ProjectDeleteCommentDocument = gql`
    mutation projectDeleteComment($commentId: ID!, $projectId: ID!) {
  projectDeleteComment(commentId: $commentId, projectId: $projectId) {
    id
    comments {
      id
    }
  }
}
    `;
export type ProjectDeleteCommentMutationFn = Apollo.MutationFunction<ProjectDeleteCommentMutation, ProjectDeleteCommentMutationVariables>;

/**
 * __useProjectDeleteCommentMutation__
 *
 * To run a mutation, you first call `useProjectDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectDeleteCommentMutation, { data, loading, error }] = useProjectDeleteCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<ProjectDeleteCommentMutation, ProjectDeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectDeleteCommentMutation, ProjectDeleteCommentMutationVariables>(ProjectDeleteCommentDocument, options);
      }
export type ProjectDeleteCommentMutationHookResult = ReturnType<typeof useProjectDeleteCommentMutation>;
export type ProjectDeleteCommentMutationResult = Apollo.MutationResult<ProjectDeleteCommentMutation>;
export type ProjectDeleteCommentMutationOptions = Apollo.BaseMutationOptions<ProjectDeleteCommentMutation, ProjectDeleteCommentMutationVariables>;
export const ProjectEditCommentDocument = gql`
    mutation projectEditComment($commentId: ID!, $projectId: ID!, $newComment: String!) {
  projectEditComment(
    commentId: $commentId
    projectId: $projectId
    updatedComment: $newComment
  ) {
    id
    comments {
      id
      __typename
      comment
    }
  }
}
    `;
export type ProjectEditCommentMutationFn = Apollo.MutationFunction<ProjectEditCommentMutation, ProjectEditCommentMutationVariables>;

/**
 * __useProjectEditCommentMutation__
 *
 * To run a mutation, you first call `useProjectEditCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectEditCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectEditCommentMutation, { data, loading, error }] = useProjectEditCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      projectId: // value for 'projectId'
 *      newComment: // value for 'newComment'
 *   },
 * });
 */
export function useProjectEditCommentMutation(baseOptions?: Apollo.MutationHookOptions<ProjectEditCommentMutation, ProjectEditCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectEditCommentMutation, ProjectEditCommentMutationVariables>(ProjectEditCommentDocument, options);
      }
export type ProjectEditCommentMutationHookResult = ReturnType<typeof useProjectEditCommentMutation>;
export type ProjectEditCommentMutationResult = Apollo.MutationResult<ProjectEditCommentMutation>;
export type ProjectEditCommentMutationOptions = Apollo.BaseMutationOptions<ProjectEditCommentMutation, ProjectEditCommentMutationVariables>;
export const ProjectAddCustomClassDocument = gql`
    mutation projectAddCustomClass($projectId: ID!, $name: String!, $color: InputColor!) {
  projectAddCustomClass(projectId: $projectId, name: $name, color: $color) {
    id
    customClasses {
      id
      name
      color {
        r
        g
        b
        a
      }
      code
    }
  }
}
    `;
export type ProjectAddCustomClassMutationFn = Apollo.MutationFunction<ProjectAddCustomClassMutation, ProjectAddCustomClassMutationVariables>;

/**
 * __useProjectAddCustomClassMutation__
 *
 * To run a mutation, you first call `useProjectAddCustomClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectAddCustomClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectAddCustomClassMutation, { data, loading, error }] = useProjectAddCustomClassMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      name: // value for 'name'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useProjectAddCustomClassMutation(baseOptions?: Apollo.MutationHookOptions<ProjectAddCustomClassMutation, ProjectAddCustomClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectAddCustomClassMutation, ProjectAddCustomClassMutationVariables>(ProjectAddCustomClassDocument, options);
      }
export type ProjectAddCustomClassMutationHookResult = ReturnType<typeof useProjectAddCustomClassMutation>;
export type ProjectAddCustomClassMutationResult = Apollo.MutationResult<ProjectAddCustomClassMutation>;
export type ProjectAddCustomClassMutationOptions = Apollo.BaseMutationOptions<ProjectAddCustomClassMutation, ProjectAddCustomClassMutationVariables>;
export const ProjectDeleteCustomClassDocument = gql`
    mutation projectDeleteCustomClass($customClassId: ID!, $projectId: ID!) {
  projectDeleteCustomClass(customClassId: $customClassId, projectId: $projectId) {
    id
    state {
      annotations {
        ... on PointCluster {
          annotationClass
        }
      }
    }
    customClasses {
      id
    }
  }
}
    `;
export type ProjectDeleteCustomClassMutationFn = Apollo.MutationFunction<ProjectDeleteCustomClassMutation, ProjectDeleteCustomClassMutationVariables>;

/**
 * __useProjectDeleteCustomClassMutation__
 *
 * To run a mutation, you first call `useProjectDeleteCustomClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectDeleteCustomClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectDeleteCustomClassMutation, { data, loading, error }] = useProjectDeleteCustomClassMutation({
 *   variables: {
 *      customClassId: // value for 'customClassId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectDeleteCustomClassMutation(baseOptions?: Apollo.MutationHookOptions<ProjectDeleteCustomClassMutation, ProjectDeleteCustomClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectDeleteCustomClassMutation, ProjectDeleteCustomClassMutationVariables>(ProjectDeleteCustomClassDocument, options);
      }
export type ProjectDeleteCustomClassMutationHookResult = ReturnType<typeof useProjectDeleteCustomClassMutation>;
export type ProjectDeleteCustomClassMutationResult = Apollo.MutationResult<ProjectDeleteCustomClassMutation>;
export type ProjectDeleteCustomClassMutationOptions = Apollo.BaseMutationOptions<ProjectDeleteCustomClassMutation, ProjectDeleteCustomClassMutationVariables>;
export const ProjectEditCustomClassNameDocument = gql`
    mutation projectEditCustomClassName($customClassId: ID!, $projectId: ID!, $newName: String!) {
  projectEditCustomClassName(
    customClassId: $customClassId
    projectId: $projectId
    updatedName: $newName
  ) {
    id
    customClasses {
      id
      name
    }
  }
}
    `;
export type ProjectEditCustomClassNameMutationFn = Apollo.MutationFunction<ProjectEditCustomClassNameMutation, ProjectEditCustomClassNameMutationVariables>;

/**
 * __useProjectEditCustomClassNameMutation__
 *
 * To run a mutation, you first call `useProjectEditCustomClassNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectEditCustomClassNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectEditCustomClassNameMutation, { data, loading, error }] = useProjectEditCustomClassNameMutation({
 *   variables: {
 *      customClassId: // value for 'customClassId'
 *      projectId: // value for 'projectId'
 *      newName: // value for 'newName'
 *   },
 * });
 */
export function useProjectEditCustomClassNameMutation(baseOptions?: Apollo.MutationHookOptions<ProjectEditCustomClassNameMutation, ProjectEditCustomClassNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectEditCustomClassNameMutation, ProjectEditCustomClassNameMutationVariables>(ProjectEditCustomClassNameDocument, options);
      }
export type ProjectEditCustomClassNameMutationHookResult = ReturnType<typeof useProjectEditCustomClassNameMutation>;
export type ProjectEditCustomClassNameMutationResult = Apollo.MutationResult<ProjectEditCustomClassNameMutation>;
export type ProjectEditCustomClassNameMutationOptions = Apollo.BaseMutationOptions<ProjectEditCustomClassNameMutation, ProjectEditCustomClassNameMutationVariables>;
export const ProjectEditCustomClassColorDocument = gql`
    mutation projectEditCustomClassColor($customClassId: ID!, $projectId: ID!, $newColor: InputColor!) {
  projectEditCustomClassColor(
    customClassId: $customClassId
    projectId: $projectId
    updatedColor: $newColor
  ) {
    id
    customClasses {
      id
      color {
        r
        g
        b
        a
      }
    }
  }
}
    `;
export type ProjectEditCustomClassColorMutationFn = Apollo.MutationFunction<ProjectEditCustomClassColorMutation, ProjectEditCustomClassColorMutationVariables>;

/**
 * __useProjectEditCustomClassColorMutation__
 *
 * To run a mutation, you first call `useProjectEditCustomClassColorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectEditCustomClassColorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectEditCustomClassColorMutation, { data, loading, error }] = useProjectEditCustomClassColorMutation({
 *   variables: {
 *      customClassId: // value for 'customClassId'
 *      projectId: // value for 'projectId'
 *      newColor: // value for 'newColor'
 *   },
 * });
 */
export function useProjectEditCustomClassColorMutation(baseOptions?: Apollo.MutationHookOptions<ProjectEditCustomClassColorMutation, ProjectEditCustomClassColorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectEditCustomClassColorMutation, ProjectEditCustomClassColorMutationVariables>(ProjectEditCustomClassColorDocument, options);
      }
export type ProjectEditCustomClassColorMutationHookResult = ReturnType<typeof useProjectEditCustomClassColorMutation>;
export type ProjectEditCustomClassColorMutationResult = Apollo.MutationResult<ProjectEditCustomClassColorMutation>;
export type ProjectEditCustomClassColorMutationOptions = Apollo.BaseMutationOptions<ProjectEditCustomClassColorMutation, ProjectEditCustomClassColorMutationVariables>;
export const ProjectEditAnnotationColorDocument = gql`
    mutation projectEditAnnotationColor($annotationIds: [ID!]!, $projectId: ID!, $newColor: InputColor!) {
  projectEditAnnotationColor(
    annotationIds: $annotationIds
    projectId: $projectId
    newColor: $newColor
  ) {
    id
    state {
      ...ProjectState
    }
  }
}
    ${ProjectStateFragmentDoc}`;
export type ProjectEditAnnotationColorMutationFn = Apollo.MutationFunction<ProjectEditAnnotationColorMutation, ProjectEditAnnotationColorMutationVariables>;

/**
 * __useProjectEditAnnotationColorMutation__
 *
 * To run a mutation, you first call `useProjectEditAnnotationColorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectEditAnnotationColorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectEditAnnotationColorMutation, { data, loading, error }] = useProjectEditAnnotationColorMutation({
 *   variables: {
 *      annotationIds: // value for 'annotationIds'
 *      projectId: // value for 'projectId'
 *      newColor: // value for 'newColor'
 *   },
 * });
 */
export function useProjectEditAnnotationColorMutation(baseOptions?: Apollo.MutationHookOptions<ProjectEditAnnotationColorMutation, ProjectEditAnnotationColorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectEditAnnotationColorMutation, ProjectEditAnnotationColorMutationVariables>(ProjectEditAnnotationColorDocument, options);
      }
export type ProjectEditAnnotationColorMutationHookResult = ReturnType<typeof useProjectEditAnnotationColorMutation>;
export type ProjectEditAnnotationColorMutationResult = Apollo.MutationResult<ProjectEditAnnotationColorMutation>;
export type ProjectEditAnnotationColorMutationOptions = Apollo.BaseMutationOptions<ProjectEditAnnotationColorMutation, ProjectEditAnnotationColorMutationVariables>;
export const ProjectEditAnnotationClassDocument = gql`
    mutation projectEditAnnotationClass($annotationIds: [ID!]!, $projectId: ID!, $newClass: Int!) {
  projectEditAnnotationClass(
    annotationIds: $annotationIds
    projectId: $projectId
    newClass: $newClass
  ) {
    id
    state {
      ...ProjectState
    }
    pointClouds {
      id
      availableClasses
    }
  }
}
    ${ProjectStateFragmentDoc}`;
export type ProjectEditAnnotationClassMutationFn = Apollo.MutationFunction<ProjectEditAnnotationClassMutation, ProjectEditAnnotationClassMutationVariables>;

/**
 * __useProjectEditAnnotationClassMutation__
 *
 * To run a mutation, you first call `useProjectEditAnnotationClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectEditAnnotationClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectEditAnnotationClassMutation, { data, loading, error }] = useProjectEditAnnotationClassMutation({
 *   variables: {
 *      annotationIds: // value for 'annotationIds'
 *      projectId: // value for 'projectId'
 *      newClass: // value for 'newClass'
 *   },
 * });
 */
export function useProjectEditAnnotationClassMutation(baseOptions?: Apollo.MutationHookOptions<ProjectEditAnnotationClassMutation, ProjectEditAnnotationClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectEditAnnotationClassMutation, ProjectEditAnnotationClassMutationVariables>(ProjectEditAnnotationClassDocument, options);
      }
export type ProjectEditAnnotationClassMutationHookResult = ReturnType<typeof useProjectEditAnnotationClassMutation>;
export type ProjectEditAnnotationClassMutationResult = Apollo.MutationResult<ProjectEditAnnotationClassMutation>;
export type ProjectEditAnnotationClassMutationOptions = Apollo.BaseMutationOptions<ProjectEditAnnotationClassMutation, ProjectEditAnnotationClassMutationVariables>;
export const ProjectEditLayerElevationDocument = gql`
    mutation projectEditLayerElevation($layerIds: [ID!]!, $projectId: ID!, $newElevation: Float!) {
  projectEditLayerElevation(
    layerIds: $layerIds
    projectId: $projectId
    newElevation: $newElevation
  ) {
    id
    state {
      ...ProjectState
    }
  }
}
    ${ProjectStateFragmentDoc}`;
export type ProjectEditLayerElevationMutationFn = Apollo.MutationFunction<ProjectEditLayerElevationMutation, ProjectEditLayerElevationMutationVariables>;

/**
 * __useProjectEditLayerElevationMutation__
 *
 * To run a mutation, you first call `useProjectEditLayerElevationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectEditLayerElevationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectEditLayerElevationMutation, { data, loading, error }] = useProjectEditLayerElevationMutation({
 *   variables: {
 *      layerIds: // value for 'layerIds'
 *      projectId: // value for 'projectId'
 *      newElevation: // value for 'newElevation'
 *   },
 * });
 */
export function useProjectEditLayerElevationMutation(baseOptions?: Apollo.MutationHookOptions<ProjectEditLayerElevationMutation, ProjectEditLayerElevationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectEditLayerElevationMutation, ProjectEditLayerElevationMutationVariables>(ProjectEditLayerElevationDocument, options);
      }
export type ProjectEditLayerElevationMutationHookResult = ReturnType<typeof useProjectEditLayerElevationMutation>;
export type ProjectEditLayerElevationMutationResult = Apollo.MutationResult<ProjectEditLayerElevationMutation>;
export type ProjectEditLayerElevationMutationOptions = Apollo.BaseMutationOptions<ProjectEditLayerElevationMutation, ProjectEditLayerElevationMutationVariables>;
export const ProjectAddGuestDocument = gql`
    mutation projectAddGuest($projectId: ID!, $email: String!) {
  projectAddGuest(projectId: $projectId, email: $email) {
    id
  }
}
    `;
export type ProjectAddGuestMutationFn = Apollo.MutationFunction<ProjectAddGuestMutation, ProjectAddGuestMutationVariables>;

/**
 * __useProjectAddGuestMutation__
 *
 * To run a mutation, you first call `useProjectAddGuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectAddGuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectAddGuestMutation, { data, loading, error }] = useProjectAddGuestMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useProjectAddGuestMutation(baseOptions?: Apollo.MutationHookOptions<ProjectAddGuestMutation, ProjectAddGuestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectAddGuestMutation, ProjectAddGuestMutationVariables>(ProjectAddGuestDocument, options);
      }
export type ProjectAddGuestMutationHookResult = ReturnType<typeof useProjectAddGuestMutation>;
export type ProjectAddGuestMutationResult = Apollo.MutationResult<ProjectAddGuestMutation>;
export type ProjectAddGuestMutationOptions = Apollo.BaseMutationOptions<ProjectAddGuestMutation, ProjectAddGuestMutationVariables>;
export const ProjectRemoveGuestDocument = gql`
    mutation projectRemoveGuest($projectId: ID!, $userId: ID!) {
  projectRemoveGuest(projectId: $projectId, userId: $userId) {
    id
  }
}
    `;
export type ProjectRemoveGuestMutationFn = Apollo.MutationFunction<ProjectRemoveGuestMutation, ProjectRemoveGuestMutationVariables>;

/**
 * __useProjectRemoveGuestMutation__
 *
 * To run a mutation, you first call `useProjectRemoveGuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectRemoveGuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectRemoveGuestMutation, { data, loading, error }] = useProjectRemoveGuestMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useProjectRemoveGuestMutation(baseOptions?: Apollo.MutationHookOptions<ProjectRemoveGuestMutation, ProjectRemoveGuestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectRemoveGuestMutation, ProjectRemoveGuestMutationVariables>(ProjectRemoveGuestDocument, options);
      }
export type ProjectRemoveGuestMutationHookResult = ReturnType<typeof useProjectRemoveGuestMutation>;
export type ProjectRemoveGuestMutationResult = Apollo.MutationResult<ProjectRemoveGuestMutation>;
export type ProjectRemoveGuestMutationOptions = Apollo.BaseMutationOptions<ProjectRemoveGuestMutation, ProjectRemoveGuestMutationVariables>;
export const ProjectRequestDownloadTokenDocument = gql`
    query projectRequestDownloadToken($projectId: ID!) {
  projectRequestDownloadToken(projectId: $projectId)
}
    `;

/**
 * __useProjectRequestDownloadTokenQuery__
 *
 * To run a query within a React component, call `useProjectRequestDownloadTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRequestDownloadTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectRequestDownloadTokenQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectRequestDownloadTokenQuery(baseOptions: Apollo.QueryHookOptions<ProjectRequestDownloadTokenQuery, ProjectRequestDownloadTokenQueryVariables> & ({ variables: ProjectRequestDownloadTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectRequestDownloadTokenQuery, ProjectRequestDownloadTokenQueryVariables>(ProjectRequestDownloadTokenDocument, options);
      }
export function useProjectRequestDownloadTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectRequestDownloadTokenQuery, ProjectRequestDownloadTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectRequestDownloadTokenQuery, ProjectRequestDownloadTokenQueryVariables>(ProjectRequestDownloadTokenDocument, options);
        }
export function useProjectRequestDownloadTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectRequestDownloadTokenQuery, ProjectRequestDownloadTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectRequestDownloadTokenQuery, ProjectRequestDownloadTokenQueryVariables>(ProjectRequestDownloadTokenDocument, options);
        }
export type ProjectRequestDownloadTokenQueryHookResult = ReturnType<typeof useProjectRequestDownloadTokenQuery>;
export type ProjectRequestDownloadTokenLazyQueryHookResult = ReturnType<typeof useProjectRequestDownloadTokenLazyQuery>;
export type ProjectRequestDownloadTokenSuspenseQueryHookResult = ReturnType<typeof useProjectRequestDownloadTokenSuspenseQuery>;
export type ProjectRequestDownloadTokenQueryResult = Apollo.QueryResult<ProjectRequestDownloadTokenQuery, ProjectRequestDownloadTokenQueryVariables>;
export const SuperadminOrganisationsDocument = gql`
    query superadminOrganisations {
  superadminOrganisations {
    ...SuperadminOrganisation
  }
}
    ${SuperadminOrganisationFragmentDoc}`;

/**
 * __useSuperadminOrganisationsQuery__
 *
 * To run a query within a React component, call `useSuperadminOrganisationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperadminOrganisationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperadminOrganisationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSuperadminOrganisationsQuery(baseOptions?: Apollo.QueryHookOptions<SuperadminOrganisationsQuery, SuperadminOrganisationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperadminOrganisationsQuery, SuperadminOrganisationsQueryVariables>(SuperadminOrganisationsDocument, options);
      }
export function useSuperadminOrganisationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperadminOrganisationsQuery, SuperadminOrganisationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperadminOrganisationsQuery, SuperadminOrganisationsQueryVariables>(SuperadminOrganisationsDocument, options);
        }
export function useSuperadminOrganisationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuperadminOrganisationsQuery, SuperadminOrganisationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuperadminOrganisationsQuery, SuperadminOrganisationsQueryVariables>(SuperadminOrganisationsDocument, options);
        }
export type SuperadminOrganisationsQueryHookResult = ReturnType<typeof useSuperadminOrganisationsQuery>;
export type SuperadminOrganisationsLazyQueryHookResult = ReturnType<typeof useSuperadminOrganisationsLazyQuery>;
export type SuperadminOrganisationsSuspenseQueryHookResult = ReturnType<typeof useSuperadminOrganisationsSuspenseQuery>;
export type SuperadminOrganisationsQueryResult = Apollo.QueryResult<SuperadminOrganisationsQuery, SuperadminOrganisationsQueryVariables>;
export const SuperadminUpdateTrialDateDocument = gql`
    mutation superadminUpdateTrialDate($organisationId: ID!, $endDate: Date!) {
  superadminUpdateTrialDate(organisationId: $organisationId, endDate: $endDate) {
    ...SuperadminOrganisation
  }
}
    ${SuperadminOrganisationFragmentDoc}`;
export type SuperadminUpdateTrialDateMutationFn = Apollo.MutationFunction<SuperadminUpdateTrialDateMutation, SuperadminUpdateTrialDateMutationVariables>;

/**
 * __useSuperadminUpdateTrialDateMutation__
 *
 * To run a mutation, you first call `useSuperadminUpdateTrialDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperadminUpdateTrialDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superadminUpdateTrialDateMutation, { data, loading, error }] = useSuperadminUpdateTrialDateMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useSuperadminUpdateTrialDateMutation(baseOptions?: Apollo.MutationHookOptions<SuperadminUpdateTrialDateMutation, SuperadminUpdateTrialDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperadminUpdateTrialDateMutation, SuperadminUpdateTrialDateMutationVariables>(SuperadminUpdateTrialDateDocument, options);
      }
export type SuperadminUpdateTrialDateMutationHookResult = ReturnType<typeof useSuperadminUpdateTrialDateMutation>;
export type SuperadminUpdateTrialDateMutationResult = Apollo.MutationResult<SuperadminUpdateTrialDateMutation>;
export type SuperadminUpdateTrialDateMutationOptions = Apollo.BaseMutationOptions<SuperadminUpdateTrialDateMutation, SuperadminUpdateTrialDateMutationVariables>;
export const SuperadminUpdatePlanDocument = gql`
    mutation superadminUpdatePlan($organisationId: ID!, $customLimits: InputSubscriptionCustomLimits!, $subscriptionType: SubscriptionType!, $endDate: Date!) {
  superadminUpdatePlan(
    organisationId: $organisationId
    customLimits: $customLimits
    subscriptionType: $subscriptionType
    endDate: $endDate
  ) {
    ...SuperadminOrganisation
  }
}
    ${SuperadminOrganisationFragmentDoc}`;
export type SuperadminUpdatePlanMutationFn = Apollo.MutationFunction<SuperadminUpdatePlanMutation, SuperadminUpdatePlanMutationVariables>;

/**
 * __useSuperadminUpdatePlanMutation__
 *
 * To run a mutation, you first call `useSuperadminUpdatePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperadminUpdatePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superadminUpdatePlanMutation, { data, loading, error }] = useSuperadminUpdatePlanMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      customLimits: // value for 'customLimits'
 *      subscriptionType: // value for 'subscriptionType'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useSuperadminUpdatePlanMutation(baseOptions?: Apollo.MutationHookOptions<SuperadminUpdatePlanMutation, SuperadminUpdatePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperadminUpdatePlanMutation, SuperadminUpdatePlanMutationVariables>(SuperadminUpdatePlanDocument, options);
      }
export type SuperadminUpdatePlanMutationHookResult = ReturnType<typeof useSuperadminUpdatePlanMutation>;
export type SuperadminUpdatePlanMutationResult = Apollo.MutationResult<SuperadminUpdatePlanMutation>;
export type SuperadminUpdatePlanMutationOptions = Apollo.BaseMutationOptions<SuperadminUpdatePlanMutation, SuperadminUpdatePlanMutationVariables>;
export const UsersDocument = gql`
    query users($organisationId: ID!) {
  usersByOrganisationId(organisationId: $organisationId) {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useUsersQuery(baseOptions: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables> & ({ variables: UsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export function useUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersSuspenseQueryHookResult = ReturnType<typeof useUsersSuspenseQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const CurrentUserDocument = gql`
    query currentUser {
  currentUser {
    ...CurrentUser
  }
}
    ${CurrentUserFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export function useCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const UserAddToOrganisationDocument = gql`
    mutation userAddToOrganisation($organisationId: ID!, $email: String!, $role: UserRole!) {
  userAddToOrganisation(
    organisationId: $organisationId
    email: $email
    role: $role
  ) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type UserAddToOrganisationMutationFn = Apollo.MutationFunction<UserAddToOrganisationMutation, UserAddToOrganisationMutationVariables>;

/**
 * __useUserAddToOrganisationMutation__
 *
 * To run a mutation, you first call `useUserAddToOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAddToOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAddToOrganisationMutation, { data, loading, error }] = useUserAddToOrganisationMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      email: // value for 'email'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUserAddToOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<UserAddToOrganisationMutation, UserAddToOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserAddToOrganisationMutation, UserAddToOrganisationMutationVariables>(UserAddToOrganisationDocument, options);
      }
export type UserAddToOrganisationMutationHookResult = ReturnType<typeof useUserAddToOrganisationMutation>;
export type UserAddToOrganisationMutationResult = Apollo.MutationResult<UserAddToOrganisationMutation>;
export type UserAddToOrganisationMutationOptions = Apollo.BaseMutationOptions<UserAddToOrganisationMutation, UserAddToOrganisationMutationVariables>;
export const UserResendInvitationDocument = gql`
    mutation userResendInvitation($organisationId: ID!, $userId: ID!) {
  userResendInvitation(organisationId: $organisationId, userId: $userId) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type UserResendInvitationMutationFn = Apollo.MutationFunction<UserResendInvitationMutation, UserResendInvitationMutationVariables>;

/**
 * __useUserResendInvitationMutation__
 *
 * To run a mutation, you first call `useUserResendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserResendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userResendInvitationMutation, { data, loading, error }] = useUserResendInvitationMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserResendInvitationMutation(baseOptions?: Apollo.MutationHookOptions<UserResendInvitationMutation, UserResendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserResendInvitationMutation, UserResendInvitationMutationVariables>(UserResendInvitationDocument, options);
      }
export type UserResendInvitationMutationHookResult = ReturnType<typeof useUserResendInvitationMutation>;
export type UserResendInvitationMutationResult = Apollo.MutationResult<UserResendInvitationMutation>;
export type UserResendInvitationMutationOptions = Apollo.BaseMutationOptions<UserResendInvitationMutation, UserResendInvitationMutationVariables>;
export const UserDeleteFromOrganisationDocument = gql`
    mutation userDeleteFromOrganisation($organisationId: ID!, $userId: ID!) {
  userDeleteFromOrganisation(organisationId: $organisationId, userId: $userId)
}
    `;
export type UserDeleteFromOrganisationMutationFn = Apollo.MutationFunction<UserDeleteFromOrganisationMutation, UserDeleteFromOrganisationMutationVariables>;

/**
 * __useUserDeleteFromOrganisationMutation__
 *
 * To run a mutation, you first call `useUserDeleteFromOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDeleteFromOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDeleteFromOrganisationMutation, { data, loading, error }] = useUserDeleteFromOrganisationMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserDeleteFromOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<UserDeleteFromOrganisationMutation, UserDeleteFromOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserDeleteFromOrganisationMutation, UserDeleteFromOrganisationMutationVariables>(UserDeleteFromOrganisationDocument, options);
      }
export type UserDeleteFromOrganisationMutationHookResult = ReturnType<typeof useUserDeleteFromOrganisationMutation>;
export type UserDeleteFromOrganisationMutationResult = Apollo.MutationResult<UserDeleteFromOrganisationMutation>;
export type UserDeleteFromOrganisationMutationOptions = Apollo.BaseMutationOptions<UserDeleteFromOrganisationMutation, UserDeleteFromOrganisationMutationVariables>;
export const UserChangeRoleDocument = gql`
    mutation userChangeRole($organisationId: ID!, $userId: ID!, $role: UserRole!) {
  userChangeRole(organisationId: $organisationId, userId: $userId, role: $role) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type UserChangeRoleMutationFn = Apollo.MutationFunction<UserChangeRoleMutation, UserChangeRoleMutationVariables>;

/**
 * __useUserChangeRoleMutation__
 *
 * To run a mutation, you first call `useUserChangeRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserChangeRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userChangeRoleMutation, { data, loading, error }] = useUserChangeRoleMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUserChangeRoleMutation(baseOptions?: Apollo.MutationHookOptions<UserChangeRoleMutation, UserChangeRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserChangeRoleMutation, UserChangeRoleMutationVariables>(UserChangeRoleDocument, options);
      }
export type UserChangeRoleMutationHookResult = ReturnType<typeof useUserChangeRoleMutation>;
export type UserChangeRoleMutationResult = Apollo.MutationResult<UserChangeRoleMutation>;
export type UserChangeRoleMutationOptions = Apollo.BaseMutationOptions<UserChangeRoleMutation, UserChangeRoleMutationVariables>;
export const UserDisableDocument = gql`
    mutation userDisable($organisationId: ID!, $userId: ID!) {
  userDisable(organisationId: $organisationId, userId: $userId) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type UserDisableMutationFn = Apollo.MutationFunction<UserDisableMutation, UserDisableMutationVariables>;

/**
 * __useUserDisableMutation__
 *
 * To run a mutation, you first call `useUserDisableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDisableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDisableMutation, { data, loading, error }] = useUserDisableMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserDisableMutation(baseOptions?: Apollo.MutationHookOptions<UserDisableMutation, UserDisableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserDisableMutation, UserDisableMutationVariables>(UserDisableDocument, options);
      }
export type UserDisableMutationHookResult = ReturnType<typeof useUserDisableMutation>;
export type UserDisableMutationResult = Apollo.MutationResult<UserDisableMutation>;
export type UserDisableMutationOptions = Apollo.BaseMutationOptions<UserDisableMutation, UserDisableMutationVariables>;
export const UserEnableDocument = gql`
    mutation userEnable($organisationId: ID!, $userId: ID!) {
  userEnable(organisationId: $organisationId, userId: $userId) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type UserEnableMutationFn = Apollo.MutationFunction<UserEnableMutation, UserEnableMutationVariables>;

/**
 * __useUserEnableMutation__
 *
 * To run a mutation, you first call `useUserEnableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserEnableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userEnableMutation, { data, loading, error }] = useUserEnableMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserEnableMutation(baseOptions?: Apollo.MutationHookOptions<UserEnableMutation, UserEnableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserEnableMutation, UserEnableMutationVariables>(UserEnableDocument, options);
      }
export type UserEnableMutationHookResult = ReturnType<typeof useUserEnableMutation>;
export type UserEnableMutationResult = Apollo.MutationResult<UserEnableMutation>;
export type UserEnableMutationOptions = Apollo.BaseMutationOptions<UserEnableMutation, UserEnableMutationVariables>;
export const UserInviteInfoDocument = gql`
    query userInviteInfo($token: String!) {
  userInviteInfo(token: $token) {
    email
    organisationName
    isNewUser
    inviteId
  }
}
    `;

/**
 * __useUserInviteInfoQuery__
 *
 * To run a query within a React component, call `useUserInviteInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInviteInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInviteInfoQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUserInviteInfoQuery(baseOptions: Apollo.QueryHookOptions<UserInviteInfoQuery, UserInviteInfoQueryVariables> & ({ variables: UserInviteInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserInviteInfoQuery, UserInviteInfoQueryVariables>(UserInviteInfoDocument, options);
      }
export function useUserInviteInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserInviteInfoQuery, UserInviteInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserInviteInfoQuery, UserInviteInfoQueryVariables>(UserInviteInfoDocument, options);
        }
export function useUserInviteInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserInviteInfoQuery, UserInviteInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserInviteInfoQuery, UserInviteInfoQueryVariables>(UserInviteInfoDocument, options);
        }
export type UserInviteInfoQueryHookResult = ReturnType<typeof useUserInviteInfoQuery>;
export type UserInviteInfoLazyQueryHookResult = ReturnType<typeof useUserInviteInfoLazyQuery>;
export type UserInviteInfoSuspenseQueryHookResult = ReturnType<typeof useUserInviteInfoSuspenseQuery>;
export type UserInviteInfoQueryResult = Apollo.QueryResult<UserInviteInfoQuery, UserInviteInfoQueryVariables>;
export const UserAcceptInvitationDocument = gql`
    mutation userAcceptInvitation($inviteId: String!, $userEmail: String!, $user: InputUser) {
  userAcceptInvitation(inviteId: $inviteId, userEmail: $userEmail, user: $user)
}
    `;
export type UserAcceptInvitationMutationFn = Apollo.MutationFunction<UserAcceptInvitationMutation, UserAcceptInvitationMutationVariables>;

/**
 * __useUserAcceptInvitationMutation__
 *
 * To run a mutation, you first call `useUserAcceptInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAcceptInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAcceptInvitationMutation, { data, loading, error }] = useUserAcceptInvitationMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *      userEmail: // value for 'userEmail'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUserAcceptInvitationMutation(baseOptions?: Apollo.MutationHookOptions<UserAcceptInvitationMutation, UserAcceptInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserAcceptInvitationMutation, UserAcceptInvitationMutationVariables>(UserAcceptInvitationDocument, options);
      }
export type UserAcceptInvitationMutationHookResult = ReturnType<typeof useUserAcceptInvitationMutation>;
export type UserAcceptInvitationMutationResult = Apollo.MutationResult<UserAcceptInvitationMutation>;
export type UserAcceptInvitationMutationOptions = Apollo.BaseMutationOptions<UserAcceptInvitationMutation, UserAcceptInvitationMutationVariables>;
export const UserUpdateDocument = gql`
    mutation userUpdate($firstName: String!, $lastName: String!, $email: String!) {
  userUpdate(firstName: $firstName, lastName: $lastName, email: $email) {
    ...CurrentUser
  }
}
    ${CurrentUserFragmentDoc}`;
export type UserUpdateMutationFn = Apollo.MutationFunction<UserUpdateMutation, UserUpdateMutationVariables>;

/**
 * __useUserUpdateMutation__
 *
 * To run a mutation, you first call `useUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateMutation, { data, loading, error }] = useUserUpdateMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUserUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdateMutation, UserUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdateMutation, UserUpdateMutationVariables>(UserUpdateDocument, options);
      }
export type UserUpdateMutationHookResult = ReturnType<typeof useUserUpdateMutation>;
export type UserUpdateMutationResult = Apollo.MutationResult<UserUpdateMutation>;
export type UserUpdateMutationOptions = Apollo.BaseMutationOptions<UserUpdateMutation, UserUpdateMutationVariables>;
export const UserUpdateFavoritesDocument = gql`
    mutation userUpdateFavorites($projectId: ID!, $inFavorites: Boolean!) {
  userUpdateFavorites(projectId: $projectId, inFavorites: $inFavorites) {
    id
    favoriteProjectIds
  }
}
    `;
export type UserUpdateFavoritesMutationFn = Apollo.MutationFunction<UserUpdateFavoritesMutation, UserUpdateFavoritesMutationVariables>;

/**
 * __useUserUpdateFavoritesMutation__
 *
 * To run a mutation, you first call `useUserUpdateFavoritesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateFavoritesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateFavoritesMutation, { data, loading, error }] = useUserUpdateFavoritesMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      inFavorites: // value for 'inFavorites'
 *   },
 * });
 */
export function useUserUpdateFavoritesMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdateFavoritesMutation, UserUpdateFavoritesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdateFavoritesMutation, UserUpdateFavoritesMutationVariables>(UserUpdateFavoritesDocument, options);
      }
export type UserUpdateFavoritesMutationHookResult = ReturnType<typeof useUserUpdateFavoritesMutation>;
export type UserUpdateFavoritesMutationResult = Apollo.MutationResult<UserUpdateFavoritesMutation>;
export type UserUpdateFavoritesMutationOptions = Apollo.BaseMutationOptions<UserUpdateFavoritesMutation, UserUpdateFavoritesMutationVariables>;
export const UserChangeUnitsDocument = gql`
    mutation userChangeUnits($inUnit: MeasurementUnits!) {
  userChangeUnits(inUnit: $inUnit) {
    id
    measurementUnit
  }
}
    `;
export type UserChangeUnitsMutationFn = Apollo.MutationFunction<UserChangeUnitsMutation, UserChangeUnitsMutationVariables>;

/**
 * __useUserChangeUnitsMutation__
 *
 * To run a mutation, you first call `useUserChangeUnitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserChangeUnitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userChangeUnitsMutation, { data, loading, error }] = useUserChangeUnitsMutation({
 *   variables: {
 *      inUnit: // value for 'inUnit'
 *   },
 * });
 */
export function useUserChangeUnitsMutation(baseOptions?: Apollo.MutationHookOptions<UserChangeUnitsMutation, UserChangeUnitsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserChangeUnitsMutation, UserChangeUnitsMutationVariables>(UserChangeUnitsDocument, options);
      }
export type UserChangeUnitsMutationHookResult = ReturnType<typeof useUserChangeUnitsMutation>;
export type UserChangeUnitsMutationResult = Apollo.MutationResult<UserChangeUnitsMutation>;
export type UserChangeUnitsMutationOptions = Apollo.BaseMutationOptions<UserChangeUnitsMutation, UserChangeUnitsMutationVariables>;
export const UserChangeDateFormatDocument = gql`
    mutation userChangeDateFormat($inFormat: DateFormats!) {
  userChangeDateFormat(inFormat: $inFormat) {
    id
    dateFormat
  }
}
    `;
export type UserChangeDateFormatMutationFn = Apollo.MutationFunction<UserChangeDateFormatMutation, UserChangeDateFormatMutationVariables>;

/**
 * __useUserChangeDateFormatMutation__
 *
 * To run a mutation, you first call `useUserChangeDateFormatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserChangeDateFormatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userChangeDateFormatMutation, { data, loading, error }] = useUserChangeDateFormatMutation({
 *   variables: {
 *      inFormat: // value for 'inFormat'
 *   },
 * });
 */
export function useUserChangeDateFormatMutation(baseOptions?: Apollo.MutationHookOptions<UserChangeDateFormatMutation, UserChangeDateFormatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserChangeDateFormatMutation, UserChangeDateFormatMutationVariables>(UserChangeDateFormatDocument, options);
      }
export type UserChangeDateFormatMutationHookResult = ReturnType<typeof useUserChangeDateFormatMutation>;
export type UserChangeDateFormatMutationResult = Apollo.MutationResult<UserChangeDateFormatMutation>;
export type UserChangeDateFormatMutationOptions = Apollo.BaseMutationOptions<UserChangeDateFormatMutation, UserChangeDateFormatMutationVariables>;
export const UserChangeDarkModeDocument = gql`
    mutation userChangeDarkMode($inDarkMode: Boolean!) {
  userChangeDarkMode(inDarkMode: $inDarkMode) {
    id
    darkMode
  }
}
    `;
export type UserChangeDarkModeMutationFn = Apollo.MutationFunction<UserChangeDarkModeMutation, UserChangeDarkModeMutationVariables>;

/**
 * __useUserChangeDarkModeMutation__
 *
 * To run a mutation, you first call `useUserChangeDarkModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserChangeDarkModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userChangeDarkModeMutation, { data, loading, error }] = useUserChangeDarkModeMutation({
 *   variables: {
 *      inDarkMode: // value for 'inDarkMode'
 *   },
 * });
 */
export function useUserChangeDarkModeMutation(baseOptions?: Apollo.MutationHookOptions<UserChangeDarkModeMutation, UserChangeDarkModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserChangeDarkModeMutation, UserChangeDarkModeMutationVariables>(UserChangeDarkModeDocument, options);
      }
export type UserChangeDarkModeMutationHookResult = ReturnType<typeof useUserChangeDarkModeMutation>;
export type UserChangeDarkModeMutationResult = Apollo.MutationResult<UserChangeDarkModeMutation>;
export type UserChangeDarkModeMutationOptions = Apollo.BaseMutationOptions<UserChangeDarkModeMutation, UserChangeDarkModeMutationVariables>;
export const UserChangeLanguageDocument = gql`
    mutation userChangeLanguage($language: Language!) {
  userChangeLanguage(language: $language) {
    id
    language
  }
}
    `;
export type UserChangeLanguageMutationFn = Apollo.MutationFunction<UserChangeLanguageMutation, UserChangeLanguageMutationVariables>;

/**
 * __useUserChangeLanguageMutation__
 *
 * To run a mutation, you first call `useUserChangeLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserChangeLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userChangeLanguageMutation, { data, loading, error }] = useUserChangeLanguageMutation({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUserChangeLanguageMutation(baseOptions?: Apollo.MutationHookOptions<UserChangeLanguageMutation, UserChangeLanguageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserChangeLanguageMutation, UserChangeLanguageMutationVariables>(UserChangeLanguageDocument, options);
      }
export type UserChangeLanguageMutationHookResult = ReturnType<typeof useUserChangeLanguageMutation>;
export type UserChangeLanguageMutationResult = Apollo.MutationResult<UserChangeLanguageMutation>;
export type UserChangeLanguageMutationOptions = Apollo.BaseMutationOptions<UserChangeLanguageMutation, UserChangeLanguageMutationVariables>;